(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}

console.warn('Compiled in DEV mode. Follow the advice at https://elm-lang.org/0.19.1/optimize for better performance and smaller assets.');


var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log_UNUSED = F2(function(tag, value)
{
	return value;
});

var _Debug_log = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString_UNUSED(value)
{
	return '<internals>';
}

function _Debug_toString(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash_UNUSED(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.start.line === region.end.line)
	{
		return 'on line ' + region.start.line;
	}
	return 'on lines ' + region.start.line + ' through ' + region.end.line;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**_UNUSED/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**_UNUSED/
	if (typeof x.$ === 'undefined')
	//*/
	/**/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0_UNUSED = 0;
var _Utils_Tuple0 = { $: '#0' };

function _Utils_Tuple2_UNUSED(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3_UNUSED(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr_UNUSED(c) { return c; }
function _Utils_chr(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil_UNUSED = { $: 0 };
var _List_Nil = { $: '[]' };

function _List_Cons_UNUSED(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap(value) { return { $: 0, a: value }; }
function _Json_unwrap(value) { return value.a; }

function _Json_wrap_UNUSED(value) { return value; }
function _Json_unwrap_UNUSED(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**_UNUSED/
	var node = args['node'];
	//*/
	/**/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**_UNUSED/''//*//**/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**_UNUSED/''//*//**/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**_UNUSED/''//*//**/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		message: func(record.message),
		stopPropagation: record.stopPropagation,
		preventDefault: record.preventDefault
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.message;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.stopPropagation;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.preventDefault) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function(sendToApp, initialModel) {
			var view = impl.view;
			/**_UNUSED/
			var domNode = args['node'];
			//*/
			/**/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.init,
		impl.update,
		impl.subscriptions,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.setup && impl.setup(sendToApp)
			var view = impl.view;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.body);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.title) && (_VirtualDom_doc.title = title = doc.title);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.onUrlChange;
	var onUrlRequest = impl.onUrlRequest;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };
key['elm-hot-nav-key'] = true;

	return _Browser_document({
		setup: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.protocol === next.protocol
							&& curr.host === next.host
							&& curr.port_.a === next.port_.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		init: function(flags)
		{
			return A3(impl.init, flags, _Browser_getUrl(), key);
		},
		view: impl.view,
		update: impl.update,
		subscriptions: impl.subscriptions
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hidden: 'hidden', change: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hidden: 'mozHidden', change: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hidden: 'msHidden', change: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hidden: 'webkitHidden', change: 'webkitvisibilitychange' }
		: { hidden: 'hidden', change: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		scene: _Browser_getScene(),
		viewport: {
			x: _Browser_window.pageXOffset,
			y: _Browser_window.pageYOffset,
			width: _Browser_doc.documentElement.clientWidth,
			height: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		width: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		height: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			scene: {
				width: node.scrollWidth,
				height: node.scrollHeight
			},
			viewport: {
				x: node.scrollLeft,
				y: node.scrollTop,
				width: node.clientWidth,
				height: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			scene: _Browser_getScene(),
			viewport: {
				x: x,
				y: y,
				width: _Browser_doc.documentElement.clientWidth,
				height: _Browser_doc.documentElement.clientHeight
			},
			element: {
				x: x + rect.left,
				y: y + rect.top,
				width: rect.width,
				height: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.expect.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.expect.b, xhr)); });
		$elm$core$Maybe$isJust(request.tracker) && _Http_track(router, xhr, request.tracker.a);

		try {
			xhr.open(request.method, request.url, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.url));
		}

		_Http_configureRequest(xhr, request);

		request.body.a && xhr.setRequestHeader('Content-Type', request.body.a);
		xhr.send(request.body.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.headers; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.timeout.a || 0;
	xhr.responseType = request.expect.d;
	xhr.withCredentials = request.allowCookiesFromOtherDomains;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		url: xhr.responseURL,
		statusCode: xhr.status,
		statusText: xhr.statusText,
		headers: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			sent: event.loaded,
			size: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			received: event.loaded,
			size: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});
var $author$project$Main$LinkClicked = function (a) {
	return {$: 'LinkClicked', a: a};
};
var $author$project$Main$UrlChanged = function (a) {
	return {$: 'UrlChanged', a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (node.$ === 'SubTree') {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0.a;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = {$: 'EQ'};
var $elm$core$Basics$GT = {$: 'GT'};
var $elm$core$Basics$LT = {$: 'LT'};
var $elm$core$Result$Err = function (a) {
	return {$: 'Err', a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 'Failure', a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 'Field', a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 'Index', a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 'Ok', a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 'OneOf', a: a};
};
var $elm$core$Basics$False = {$: 'False'};
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 'Just', a: a};
};
var $elm$core$Maybe$Nothing = {$: 'Nothing'};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 'Field':
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 'Nothing') {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'Index':
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 'OneOf':
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 'Array_elm_builtin', a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 'Leaf', a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 'SubTree', a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.nodeListSize) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.tail);
		} else {
			var treeLen = builder.nodeListSize * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.nodeList) : builder.nodeList;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.nodeListSize);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.tail) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.tail);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{nodeList: nodeList, nodeListSize: (len / $elm$core$Array$branchFactor) | 0, tail: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = {$: 'True'};
var $elm$core$Result$isOk = function (result) {
	if (result.$ === 'Ok') {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 'Normal':
			return 0;
		case 'MayStopPropagation':
			return 1;
		case 'MayPreventDefault':
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 'External', a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 'Internal', a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = function (a) {
	return {$: 'NotFound', a: a};
};
var $elm$url$Url$Http = {$: 'Http'};
var $elm$url$Url$Https = {$: 'Https'};
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {fragment: fragment, host: host, path: path, port_: port_, protocol: protocol, query: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 'Nothing') {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		$elm$url$Url$Http,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		$elm$url$Url$Https,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0.a;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = function (a) {
	return {$: 'Perform', a: a};
};
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(_Utils_Tuple0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0.a;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return _Utils_Tuple0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(_Utils_Tuple0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0.a;
		return $elm$core$Task$Perform(
			A2($elm$core$Task$map, tagger, task));
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2($elm$core$Task$map, toMessage, task)));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Main$EN = {$: 'EN'};
var $author$project$Main$NotReady = {$: 'NotReady'};
var $author$project$Main$Ready = F2(
	function (a, b) {
		return {$: 'Ready', a: a, b: b};
	});
var $author$project$Main$RouterMsg = function (a) {
	return {$: 'RouterMsg', a: a};
};
var $author$project$Main$UK = {$: 'UK'};
var $Confidenceman02$elm_select$Select$Basic = function (a) {
	return {$: 'Basic', a: a};
};
var $Confidenceman02$elm_select$Select$basicMenuItem = function (bscItem) {
	return $Confidenceman02$elm_select$Select$Basic(
		{filterable: true, group: $elm$core$Maybe$Nothing, item: bscItem.item, label: bscItem.label, styles: $elm$core$Maybe$Nothing});
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $author$project$Routing$Router$SearchMsg = function (a) {
	return {$: 'SearchMsg', a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Page$Search$LocationReceived = function (a) {
	return {$: 'LocationReceived', a: a};
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 'BadStatus_', a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 'BadUrl_', a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 'GoodStatus_', a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 'NetworkError_'};
var $elm$http$Http$Receiving = function (a) {
	return {$: 'Receiving', a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 'Sending', a: a};
};
var $elm$http$Http$Timeout_ = {$: 'Timeout_'};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: 'RBEmpty_elm_builtin'};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Maybe$isJust = function (maybe) {
	if (maybe.$ === 'Just') {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1.$) {
					case 'LT':
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 'EQ':
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = {$: 'Black'};
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: 'RBNode_elm_builtin', a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = {$: 'Red'};
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Red')) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) && (left.d.$ === 'RBNode_elm_builtin')) && (left.d.a.$ === 'Red')) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Red,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1.$) {
				case 'LT':
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 'EQ':
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
		if ((dict.e.d.$ === 'RBNode_elm_builtin') && (dict.e.d.a.$ === 'Red')) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				$elm$core$Dict$Red,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr.$ === 'Black') {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) && (dict.e.$ === 'RBNode_elm_builtin')) {
		if ((dict.d.d.$ === 'RBNode_elm_builtin') && (dict.d.d.a.$ === 'Red')) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				$elm$core$Dict$Red,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr.$ === 'Black') {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					$elm$core$Dict$Black,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Red')) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Red, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === 'RBNode_elm_builtin') && (right.a.$ === 'Black')) {
					if (right.d.$ === 'RBNode_elm_builtin') {
						if (right.d.a.$ === 'Black') {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === 'RBNode_elm_builtin') && (dict.d.$ === 'RBNode_elm_builtin')) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor.$ === 'Black') {
			if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === 'RBNode_elm_builtin') {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === 'RBEmpty_elm_builtin') {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === 'RBNode_elm_builtin') && (left.a.$ === 'Black')) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === 'RBNode_elm_builtin') && (lLeft.a.$ === 'Red')) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === 'RBNode_elm_builtin') {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === 'RBNode_elm_builtin') {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === 'RBNode_elm_builtin') {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === 'RBNode_elm_builtin') && (_v0.a.$ === 'Red')) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, $elm$core$Dict$Black, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (_v0.$ === 'Just') {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (result.$ === 'Ok') {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 'BadBody', a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 'BadStatus', a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 'BadUrl', a: a};
};
var $elm$http$Http$NetworkError = {$: 'NetworkError'};
var $elm$http$Http$Timeout = {$: 'Timeout'};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 'BadUrl_':
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 'Timeout_':
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 'NetworkError_':
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 'BadStatus_':
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.statusCode));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 'Failure', a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 'Success', a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 'Err') {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Request = function (a) {
	return {$: 'Request', a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {reqs: reqs, subs: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (cmd.$ === 'Cancel') {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 'Nothing') {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.tracker;
							if (_v4.$ === 'Nothing') {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.reqs));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (_v0.$ === 'Just') {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.subs)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 'Cancel', a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (cmd.$ === 'Cancel') {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					allowCookiesFromOtherDomains: r.allowCookiesFromOtherDomains,
					body: r.body,
					expect: A2(_Http_mapExpect, func, r.expect),
					headers: r.headers,
					method: r.method,
					timeout: r.timeout,
					tracker: r.tracker,
					url: r.url
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 'MySub', a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{allowCookiesFromOtherDomains: false, body: r.body, expect: r.expect, headers: r.headers, method: r.method, timeout: r.timeout, tracker: r.tracker, url: r.url}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{body: $elm$http$Http$emptyBody, expect: r.expect, headers: _List_Nil, method: 'GET', timeout: $elm$core$Maybe$Nothing, tracker: $elm$core$Maybe$Nothing, url: r.url});
};
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Document$Location = F4(
	function (id, name_eng, name_ukr, name_rus) {
		return {id: id, name_eng: name_eng, name_rus: name_rus, name_ukr: name_ukr};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Document$locationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name_rus',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name_ukr',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name_eng',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Document$Location)))));
var $author$project$Page$Search$fetchLocation = function (share) {
	return $elm$http$Http$get(
		{
			expect: A2(
				$elm$http$Http$expectJson,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$Search$LocationReceived),
				$elm$json$Json$Decode$list($author$project$Document$locationDecoder)),
			url: share.env.weetags + '/locations/where/[(\'level\',\'=\',1)]?fields=id,name_eng,name_ukr,name_rus'
		});
};
var $author$project$Page$Search$SubTopicReceived = F2(
	function (a, b) {
		return {$: 'SubTopicReceived', a: a, b: b};
	});
var $author$project$Document$SubTopics = F4(
	function (id, name_eng, name_ukr, parent) {
		return {id: id, name_eng: name_eng, name_ukr: name_ukr, parent: parent};
	});
var $author$project$Document$subTopicsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'parent',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name_ukr',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name_eng',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Document$SubTopics)))));
var $author$project$Page$Search$fetchSubTopic = F2(
	function (share, topic) {
		var testUrl = share.env.weetags + '/topics/find_all/';
		var endUrl = '/child?fields=id,name_eng,name_ukr,parent';
		var test = _Utils_ap(
			testUrl,
			_Utils_ap(topic, endUrl));
		return $elm$http$Http$get(
			{
				expect: A2(
					$elm$http$Http$expectJson,
					A2(
						$elm$core$Basics$composeR,
						$krisajenkins$remotedata$RemoteData$fromResult,
						$author$project$Page$Search$SubTopicReceived(topic)),
					$elm$json$Json$Decode$list($author$project$Document$subTopicsDecoder)),
				url: test
			});
	});
var $krisajenkins$remotedata$RemoteData$Loading = {$: 'Loading'};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 'NotAsked'};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (maybe.$ === 'Just') {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $ChristophP$elm_i18next$I18Next$t = F2(
	function (_v0, key) {
		var translations = _v0.a;
		return A2(
			$elm$core$Maybe$withDefault,
			key,
			A2($elm$core$Dict$get, key, translations));
	});
var $author$project$Page$Search$initialModel = F3(
	function (url, query, share) {
		return {
			citiesList: $krisajenkins$remotedata$RemoteData$NotAsked,
			data: $elm$core$String$isEmpty(query.query) ? $krisajenkins$remotedata$RemoteData$NotAsked : $krisajenkins$remotedata$RemoteData$Loading,
			educationSubOpen: false,
			emigrationSubOpen: false,
			employmentSubOpen: false,
			error: '',
			financialSubOpen: false,
			healthcareSubOpen: false,
			hotlineSubOpen: false,
			housingSubOpen: false,
			humanitarianSubOpen: false,
			legalaidSubOpen: false,
			locationList: $krisajenkins$remotedata$RemoteData$NotAsked,
			locationOpen: false,
			locationTr: $elm$core$Dict$empty,
			modalOpen: false,
			openSurvey: true,
			petSubOpen: false,
			protectionSubOpen: false,
			psychoSubOpen: false,
			regionList: $krisajenkins$remotedata$RemoteData$NotAsked,
			search: {
				filters: {tags_cities: $elm$core$Maybe$Nothing, tags_main_country: $elm$core$Maybe$Nothing, tags_regions: $elm$core$Maybe$Nothing, tags_small_cities: $elm$core$Maybe$Nothing, tags_sub_topics: $elm$core$Maybe$Nothing, tags_topics: $elm$core$Maybe$Nothing, tags_village: $elm$core$Maybe$Nothing, visible: true},
				query: $elm$core$String$isEmpty(query.query) ? '' : query.query
			},
			selectCOpen: false,
			selectOpen: false,
			selectROpen: false,
			selectSOpen: false,
			selectVOpen: false,
			selectedCities: A2($ChristophP$elm_i18next$I18Next$t, share.translations, 'search.location.Area'),
			selectedCountry: '',
			selectedLocation: A2($ChristophP$elm_i18next$I18Next$t, share.translations, 'search.location.Country'),
			selectedRegion: A2($ChristophP$elm_i18next$I18Next$t, share.translations, 'search.location.Region'),
			selectedSmallCities: A2($ChristophP$elm_i18next$I18Next$t, share.translations, 'search.location.Community'),
			selectedVillage: A2($ChristophP$elm_i18next$I18Next$t, share.translations, 'search.location.Settlement'),
			showLocation: false,
			showTopics: false,
			smallCitiesList: $krisajenkins$remotedata$RemoteData$NotAsked,
			socialSubOpen: false,
			subTopicsDict: $elm$core$Dict$empty,
			tagsSubTopics: $elm$core$Maybe$Nothing,
			tagsTopics: $elm$core$Maybe$Nothing,
			topicsOpen: false,
			transportSubOpen: false,
			url: '',
			viewData: $elm$core$Maybe$Nothing,
			villageList: $krisajenkins$remotedata$RemoteData$NotAsked
		};
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $author$project$Page$Search$DataReceived = function (a) {
	return {$: 'DataReceived', a: a};
};
var $author$project$Document$Data = F2(
	function (query, documents) {
		return {documents: documents, query: query};
	});
var $author$project$Document$Dct = F3(
	function (content, meta, score) {
		return {content: content, meta: meta, score: score};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Document$Meta = function (visible) {
	return function (licence_url) {
		return function (license_name) {
			return function (internal_id) {
				return function (resource_type) {
					return function (help_offer) {
						return function (language) {
							return function (access_rights) {
								return function (tags_sub_topics) {
									return function (register_for_help) {
										return function (title) {
											return function (url) {
												return function (last_accessed_date) {
													return function (subtitle) {
														return function (publisher) {
															return function (modified) {
																return function (tags_topics) {
																	return function (published_date) {
																		return function (tags_countries) {
																			return function (tags_main_country) {
																				return function (tags_regions) {
																					return function (tags_cities) {
																						return function (tags_small_cities) {
																							return function (tags_village) {
																								return function (tags_org_location) {
																									return function (tags_audience) {
																										return function (tags_other) {
																											return function (name) {
																												return function (purpose) {
																													return function (webpage) {
																														return function (email) {
																															return function (contact_person) {
																																return function (description) {
																																	return function (about_page_url) {
																																		return {about_page_url: about_page_url, access_rights: access_rights, contact_person: contact_person, description: description, email: email, help_offer: help_offer, internal_id: internal_id, language: language, last_accessed_date: last_accessed_date, licence_url: licence_url, license_name: license_name, modified: modified, name: name, published_date: published_date, publisher: publisher, purpose: purpose, register_for_help: register_for_help, resource_type: resource_type, subtitle: subtitle, tags_audience: tags_audience, tags_cities: tags_cities, tags_countries: tags_countries, tags_main_country: tags_main_country, tags_org_location: tags_org_location, tags_other: tags_other, tags_regions: tags_regions, tags_small_cities: tags_small_cities, tags_sub_topics: tags_sub_topics, tags_topics: tags_topics, tags_village: tags_village, title: title, url: url, visible: visible, webpage: webpage};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (_v0.$ === 'Ok') {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (_v1.$ === 'Ok') {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Document$metaDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'about_page_url',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'description',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'contact_person',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			_List_fromArray(
				['']),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'email',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
				_List_fromArray(
					['']),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'webpage',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					_List_fromArray(
						['']),
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'purpose',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						_List_fromArray(
							['']),
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'name',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'tags_other',
								$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
								_List_fromArray(
									['']),
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'tags_audience',
									$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
									_List_fromArray(
										['']),
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'tags_org_location',
										$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
										_List_fromArray(
											['']),
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'tags_village',
											$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
											_List_fromArray(
												['']),
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'tags_small_cities',
												$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
												_List_fromArray(
													['']),
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'tags_cities',
													$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
													_List_fromArray(
														['']),
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'tags_regions',
														$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
														_List_fromArray(
															['']),
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'tags_main_country',
															$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
															_List_fromArray(
																['']),
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'tags_countries',
																$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																_List_fromArray(
																	['']),
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'published_date',
																	$elm$json$Json$Decode$string,
																	'',
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'tags_topics',
																		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																		_List_fromArray(
																			['']),
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'modified',
																			$elm$json$Json$Decode$bool,
																			false,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'publisher',
																				$elm$json$Json$Decode$string,
																				'',
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'subtitle',
																					$elm$json$Json$Decode$string,
																					'',
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'last_accessed_date',
																						$elm$json$Json$Decode$string,
																						'',
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'url',
																							$elm$json$Json$Decode$string,
																							'',
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'title',
																								$elm$json$Json$Decode$string,
																								'',
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'register_for_help',
																									$elm$json$Json$Decode$bool,
																									false,
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'tags_sub_topics',
																										$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																										_List_fromArray(
																											['']),
																										A4(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																											'access_rights',
																											$elm$json$Json$Decode$string,
																											'',
																											A4(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																												'language',
																												$elm$json$Json$Decode$string,
																												'',
																												A4(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																													'help_offer',
																													$elm$json$Json$Decode$bool,
																													false,
																													A4(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																														'resource_type',
																														$elm$json$Json$Decode$string,
																														'',
																														A4(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																															'licence_name',
																															$elm$json$Json$Decode$string,
																															'',
																															A4(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																'licence_url',
																																$elm$json$Json$Decode$string,
																																'',
																																A4(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																	'internal_id',
																																	$elm$json$Json$Decode$string,
																																	'',
																																	A4(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																		'visible',
																																		$elm$json$Json$Decode$bool,
																																		false,
																																		$elm$json$Json$Decode$succeed($author$project$Document$Meta)))))))))))))))))))))))))))))))))));
var $author$project$Document$dctDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'score',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'meta',
		$author$project$Document$metaDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'content',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Document$Dct))));
var $author$project$Document$dataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'documents',
	$elm$json$Json$Decode$list($author$project$Document$dctDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'query',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Document$Data)));
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$http$Http$post = function (r) {
	return $elm$http$Http$request(
		{body: r.body, expect: r.expect, headers: _List_Nil, method: 'POST', timeout: $elm$core$Maybe$Nothing, tracker: $elm$core$Maybe$Nothing, url: r.url});
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(_Utils_Tuple0),
			pairs));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(_Utils_Tuple0),
				entries));
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Document$tagsEncoder = function (tags) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'$in',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, tags.val))
			]));
};
var $author$project$Document$filtersEncoder = function (filters) {
	var tags_village_en = function () {
		var _v13 = filters.tags_village;
		if (_v13.$ === 'Just') {
			var vl = _v13.a;
			return vl;
		} else {
			return {val: _List_Nil};
		}
	}();
	var tags_village_list = function () {
		var _v12 = tags_village_en.val;
		var vl = _v12;
		return vl;
	}();
	var tags_village_encoder = $elm$core$List$isEmpty(tags_village_list) ? $elm$json$Json$Encode$object(_List_Nil) : $author$project$Document$tagsEncoder(tags_village_en);
	var tags_topics_en = function () {
		var _v11 = filters.tags_topics;
		if (_v11.$ === 'Just') {
			var topics = _v11.a;
			return topics;
		} else {
			return {val: _List_Nil};
		}
	}();
	var tags_topics_list = function () {
		var _v10 = tags_topics_en.val;
		var topics = _v10;
		return topics;
	}();
	var tags_topics_encoder = $elm$core$List$isEmpty(tags_topics_list) ? $elm$json$Json$Encode$object(_List_Nil) : $author$project$Document$tagsEncoder(tags_topics_en);
	var tags_subtopics_en = function () {
		var _v9 = filters.tags_sub_topics;
		if (_v9.$ === 'Just') {
			var subtopics = _v9.a;
			return subtopics;
		} else {
			return {val: _List_Nil};
		}
	}();
	var tags_sub_topics_list = function () {
		var _v8 = tags_subtopics_en.val;
		var sub = _v8;
		return sub;
	}();
	var tags_subtopics_encoder = $elm$core$List$isEmpty(tags_sub_topics_list) ? $elm$json$Json$Encode$object(_List_Nil) : $author$project$Document$tagsEncoder(tags_subtopics_en);
	var tags_smallcities_en = function () {
		var _v7 = filters.tags_small_cities;
		if (_v7.$ === 'Just') {
			var sm = _v7.a;
			return sm;
		} else {
			return {val: _List_Nil};
		}
	}();
	var tags_smcities_list = function () {
		var _v6 = tags_smallcities_en.val;
		var sm = _v6;
		return sm;
	}();
	var tags_smcities_encoder = $elm$core$List$isEmpty(tags_smcities_list) ? $elm$json$Json$Encode$object(_List_Nil) : $author$project$Document$tagsEncoder(tags_smallcities_en);
	var tags_regions_en = function () {
		var _v5 = filters.tags_regions;
		if (_v5.$ === 'Just') {
			var regions = _v5.a;
			return regions;
		} else {
			return {val: _List_Nil};
		}
	}();
	var tags_regions_list = function () {
		var _v4 = tags_regions_en.val;
		var regions = _v4;
		return regions;
	}();
	var tags_regions_encoder = $elm$core$List$isEmpty(tags_regions_list) ? $elm$json$Json$Encode$object(_List_Nil) : $author$project$Document$tagsEncoder(tags_regions_en);
	var tags_countries_en = function () {
		var _v3 = filters.tags_main_country;
		if (_v3.$ === 'Just') {
			var countries = _v3.a;
			return countries;
		} else {
			return {val: _List_Nil};
		}
	}();
	var tags_countries_list = function () {
		var _v2 = tags_countries_en.val;
		var countries = _v2;
		return countries;
	}();
	var tags_countries_encoder = $elm$core$List$isEmpty(tags_countries_list) ? $elm$json$Json$Encode$object(_List_Nil) : $author$project$Document$tagsEncoder(tags_countries_en);
	var tags_cities_en = function () {
		var _v1 = filters.tags_cities;
		if (_v1.$ === 'Just') {
			var cities = _v1.a;
			return cities;
		} else {
			return {val: _List_Nil};
		}
	}();
	var tags_cities_list = function () {
		var _v0 = tags_cities_en.val;
		var cities = _v0;
		return cities;
	}();
	var tags_cities_encoder = $elm$core$List$isEmpty(tags_cities_list) ? $elm$json$Json$Encode$object(_List_Nil) : $author$project$Document$tagsEncoder(tags_cities_en);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2('tags_topics', tags_topics_encoder),
				_Utils_Tuple2('tags_main_country', tags_countries_encoder),
				_Utils_Tuple2(
				'visible',
				$elm$json$Json$Encode$bool(filters.visible)),
				_Utils_Tuple2('tags_sub_topics', tags_subtopics_encoder),
				_Utils_Tuple2('tags_regions', tags_regions_encoder),
				_Utils_Tuple2('tags_cities', tags_cities_encoder),
				_Utils_Tuple2('tags_small_cities', tags_smcities_encoder),
				_Utils_Tuple2('tags_village', tags_village_encoder)
			]));
};
var $author$project$Document$queryEncoder = function (query) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'query',
				$elm$json$Json$Encode$string(query.query)),
				_Utils_Tuple2(
				'filters',
				$author$project$Document$filtersEncoder(query.filters))
			]));
};
var $author$project$Page$Search$searchData = F2(
	function (share, query) {
		return $elm$http$Http$post(
			{
				body: $elm$http$Http$jsonBody(
					$author$project$Document$queryEncoder(query)),
				expect: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$Search$DataReceived),
					$author$project$Document$dataDecoder),
				url: share.env.haycap + '/search/document_search'
			});
	});
var $author$project$Page$Search$init = F2(
	function (url, share) {
		var queryMaybe = url.query;
		var qry = function () {
			if (queryMaybe.$ === 'Just') {
				var q = queryMaybe.a;
				return q;
			} else {
				return '';
			}
		}();
		var getslice = A2($elm$core$String$dropLeft, 6, qry);
		var parsepercenturl = function () {
			var _v0 = $elm$url$Url$percentDecode(getslice);
			if (_v0.$ === 'Just') {
				var decoded = _v0.a;
				return decoded;
			} else {
				return '';
			}
		}();
		var parsedQuery = parsepercenturl;
		var query = {
			filters: {tags_cities: $elm$core$Maybe$Nothing, tags_main_country: $elm$core$Maybe$Nothing, tags_regions: $elm$core$Maybe$Nothing, tags_small_cities: $elm$core$Maybe$Nothing, tags_sub_topics: $elm$core$Maybe$Nothing, tags_topics: $elm$core$Maybe$Nothing, tags_village: $elm$core$Maybe$Nothing, visible: true},
			query: parsedQuery
		};
		return _Utils_Tuple2(
			A3($author$project$Page$Search$initialModel, '', query, share),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Page$Search$fetchLocation(share),
						A2($author$project$Page$Search$fetchSubTopic, share, 'Housing'),
						A2($author$project$Page$Search$fetchSubTopic, share, 'Healthcare'),
						A2($author$project$Page$Search$fetchSubTopic, share, 'Legal aid'),
						A2($author$project$Page$Search$fetchSubTopic, share, 'Education'),
						A2($author$project$Page$Search$fetchSubTopic, share, 'Employment'),
						A2($author$project$Page$Search$fetchSubTopic, share, 'Financial support'),
						A2($author$project$Page$Search$fetchSubTopic, share, 'Humanitarian aid'),
						A2($author$project$Page$Search$fetchSubTopic, share, 'Social services'),
						A2($author$project$Page$Search$fetchSubTopic, share, 'Protection'),
						A2($author$project$Page$Search$fetchSubTopic, share, 'Transportation'),
						A2($author$project$Page$Search$fetchSubTopic, share, 'Hotlines'),
						A2($author$project$Page$Search$fetchSubTopic, share, 'Pets'),
						A2($author$project$Page$Search$fetchSubTopic, share, 'Emigration'),
						A2($author$project$Page$Search$fetchSubTopic, share, 'Psychological support'),
						A2($author$project$Page$Search$searchData, share, query)
					])));
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Page$Home$init = F2(
	function (url, share) {
		var _v0 = A2($author$project$Page$Search$init, url, share);
		var search = _v0.a;
		var searchCmd = _v0.b;
		return _Utils_Tuple2(
			{
				error: '',
				query: {
					filters: {tags_cities: $elm$core$Maybe$Nothing, tags_main_country: $elm$core$Maybe$Nothing, tags_regions: $elm$core$Maybe$Nothing, tags_small_cities: $elm$core$Maybe$Nothing, tags_sub_topics: $elm$core$Maybe$Nothing, tags_topics: $elm$core$Maybe$Nothing, tags_village: $elm$core$Maybe$Nothing, visible: true},
					query: ''
				},
				slider: _List_fromArray(
					[1, 2, 3]),
				sliderImgs: _List_fromArray(
					[
						{sub: 'home.prompts.prompt1.sub', title: 'home.prompts.prompt1.title', url: 'home.prompts.prompt1.img'},
						{sub: 'home.prompts.prompt2.sub', title: 'home.prompts.prompt2.title', url: '/assets/img_1.svg'},
						{sub: 'home.prompts.prompt3.sub', title: 'home.prompts.prompt3.title', url: '/assets/img_2.svg'}
					]),
				sliderPosition: 0
			},
			$elm$core$Platform$Cmd$none);
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Route$NotFound = {$: 'NotFound'};
var $author$project$Route$Contact = {$: 'Contact'};
var $author$project$Route$Home = {$: 'Home'};
var $author$project$Route$Privacy = {$: 'Privacy'};
var $author$project$Route$Report = {$: 'Report'};
var $author$project$Route$Search = {$: 'Search'};
var $elm$url$Url$Parser$Parser = function (a) {
	return {$: 'Parser', a: a};
};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {frag: frag, params: params, unvisited: unvisited, value: value, visited: visited};
	});
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.visited;
		var unvisited = _v0.unvisited;
		var params = _v0.params;
		var frag = _v0.frag;
		var value = _v0.value;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0.a;
		return $elm$url$Url$Parser$Parser(
			function (_v1) {
				var visited = _v1.visited;
				var unvisited = _v1.unvisited;
				var params = _v1.params;
				var frag = _v1.frag;
				var value = _v1.value;
				return A2(
					$elm$core$List$map,
					$elm$url$Url$Parser$mapState(value),
					parseArg(
						A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
			});
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return $elm$url$Url$Parser$Parser(
		function (state) {
			return A2(
				$elm$core$List$concatMap,
				function (_v0) {
					var parser = _v0.a;
					return parser(state);
				},
				parsers);
		});
};
var $elm$url$Url$Parser$s = function (str) {
	return $elm$url$Url$Parser$Parser(
		function (_v0) {
			var visited = _v0.visited;
			var unvisited = _v0.unvisited;
			var params = _v0.params;
			var frag = _v0.frag;
			var value = _v0.value;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				return _Utils_eq(next, str) ? _List_fromArray(
					[
						A5(
						$elm$url$Url$Parser$State,
						A2($elm$core$List$cons, next, visited),
						rest,
						params,
						frag,
						value)
					]) : _List_Nil;
			}
		});
};
var $elm$url$Url$Parser$top = $elm$url$Url$Parser$Parser(
	function (state) {
		return _List_fromArray(
			[state]);
	});
var $author$project$Route$matchRoute = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Route$Home, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Home,
			$elm$url$Url$Parser$s('home')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Search,
			$elm$url$Url$Parser$s('search')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Privacy,
			$elm$url$Url$Parser$s('privacy')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Contact,
			$elm$url$Url$Parser$s('contact')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Report,
			$elm$url$Url$Parser$s('report'))
		]));
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.unvisited;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.value);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.value);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 'Nothing') {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 'Nothing') {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 'Nothing') {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 'Nothing') {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0.a;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.path),
					$elm$url$Url$Parser$prepareQuery(url.query),
					url.fragment,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$parseUrl = function (url) {
	var _v0 = A2($elm$url$Url$Parser$parse, $author$project$Route$matchRoute, url);
	if (_v0.$ === 'Just') {
		var route = _v0.a;
		return route;
	} else {
		return $author$project$Route$NotFound;
	}
};
var $author$project$Routing$Router$init = F2(
	function (url, share) {
		var _v0 = A2($author$project$Page$Search$init, url, share);
		var searchmodel = _v0.a;
		var searchCmd = _v0.b;
		var _v1 = A2($author$project$Page$Home$init, url, share);
		var homemodel = _v1.a;
		var homeCmd = _v1.b;
		return _Utils_Tuple3(
			{
				homeModel: homemodel,
				route: $author$project$Route$parseUrl(url),
				searchModel: searchmodel
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Routing$Router$SearchMsg, searchCmd),
			share);
	});
var $Confidenceman02$elm_select$Select$Mouse = {$: 'Mouse'};
var $Confidenceman02$elm_select$Select$Internal$NothingMousedown = {$: 'NothingMousedown'};
var $Confidenceman02$elm_select$Select$State = function (a) {
	return {$: 'State', a: a};
};
var $Confidenceman02$elm_select$Select$initState = function (id_) {
	return $Confidenceman02$elm_select$Select$State(
		{activeTargetIndex: 0, controlUiFocused: $elm$core$Maybe$Nothing, headlessEvent: $elm$core$Maybe$Nothing, initialAction: $Confidenceman02$elm_select$Select$Internal$NothingMousedown, inputValue: $elm$core$Maybe$Nothing, jsOptimize: false, keepOpen: false, menuListScrollTop: 0, menuNavigation: $Confidenceman02$elm_select$Select$Mouse, menuOpen: false, menuViewportFocusNodes: $elm$core$Maybe$Nothing, selectId: id_});
};
var $ChristophP$elm_i18next$I18Next$Translations = function (a) {
	return {$: 'Translations', a: a};
};
var $ChristophP$elm_i18next$I18Next$initialTranslations = $ChristophP$elm_i18next$I18Next$Translations($elm$core$Dict$empty);
var $Confidenceman02$elm_select$Select$SelectId = function (a) {
	return {$: 'SelectId', a: a};
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $Confidenceman02$elm_select$Select$selectIdentifier = function (id_) {
	return $Confidenceman02$elm_select$Select$SelectId(
		$elm$core$String$concat(
			A2($elm$core$String$split, ' ', id_)) + '__elm-select');
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === 'RBEmpty_elm_builtin') {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $ChristophP$elm_i18next$I18Next$flattenTranslationsHelp = F3(
	function (initialValue, namespace, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, val, acc) {
					var newNamespace = function (currentKey) {
						return $elm$core$String$isEmpty(namespace) ? currentKey : (namespace + ('.' + currentKey));
					};
					if (val.$ === 'Leaf') {
						var str = val.a;
						return A3(
							$elm$core$Dict$insert,
							newNamespace(key),
							str,
							acc);
					} else {
						var children = val.a;
						return A3(
							$ChristophP$elm_i18next$I18Next$flattenTranslationsHelp,
							acc,
							newNamespace(key),
							children);
					}
				}),
			initialValue,
			dict);
	});
var $ChristophP$elm_i18next$I18Next$flattenTranslations = A2($ChristophP$elm_i18next$I18Next$flattenTranslationsHelp, $elm$core$Dict$empty, '');
var $ChristophP$elm_i18next$I18Next$Branch = function (a) {
	return {$: 'Branch', a: a};
};
var $ChristophP$elm_i18next$I18Next$Leaf = function (a) {
	return {$: 'Leaf', a: a};
};
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(_Utils_Tuple0));
};
function $ChristophP$elm_i18next$I18Next$cyclic$treeDecoder() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $ChristophP$elm_i18next$I18Next$Leaf, $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$map,
						$ChristophP$elm_i18next$I18Next$Branch,
						$elm$json$Json$Decode$dict(
							$ChristophP$elm_i18next$I18Next$cyclic$treeDecoder()));
				})
			]));
}
try {
	var $ChristophP$elm_i18next$I18Next$treeDecoder = $ChristophP$elm_i18next$I18Next$cyclic$treeDecoder();
	$ChristophP$elm_i18next$I18Next$cyclic$treeDecoder = function () {
		return $ChristophP$elm_i18next$I18Next$treeDecoder;
	};
} catch ($) {
	throw 'Some top-level definitions from `I18Next` are causing infinite recursion:\n\n  ┌─────┐\n  │    treeDecoder\n  └─────┘\n\nThese errors are very tricky, so read https://elm-lang.org/0.19.1/bad-recursion to learn how to fix it!';}
var $ChristophP$elm_i18next$I18Next$translationsDecoder = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeR, $ChristophP$elm_i18next$I18Next$flattenTranslations, $ChristophP$elm_i18next$I18Next$Translations),
	$elm$json$Json$Decode$dict($ChristophP$elm_i18next$I18Next$treeDecoder));
var $author$project$Main$init = F3(
	function (flags, url, navKey) {
		var initCmd = function () {
			var _v7 = A2($elm$json$Json$Decode$decodeString, $ChristophP$elm_i18next$I18Next$translationsDecoder, flags.tr);
			if (_v7.$ === 'Ok') {
				var translations = _v7.a;
				var initSharedState = {
					env: {haycap: flags.env.haycap, weetags: flags.env.weetags},
					lang: '',
					navKey: navKey,
					testRoute: $author$project$Route$parseUrl(url),
					theme: 'white',
					translations: translations
				};
				var _v8 = A2($author$project$Routing$Router$init, url, initSharedState);
				var initRouterModel = _v8.a;
				var routerCmd = _v8.b;
				var share = _v8.c;
				return routerCmd;
			} else {
				var err = _v7.a;
				return $elm$core$Platform$Cmd$none;
			}
		}();
		var defLang = function () {
			var _v5 = A2($elm$json$Json$Decode$decodeString, $ChristophP$elm_i18next$I18Next$translationsDecoder, flags.tr);
			if (_v5.$ === 'Ok') {
				var translations = _v5.a;
				var _v6 = A2($ChristophP$elm_i18next$I18Next$t, translations, 'lang');
				if (_v6 === 'uk') {
					return $elm$core$Maybe$Just($author$project$Main$UK);
				} else {
					return $elm$core$Maybe$Just($author$project$Main$EN);
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var lang = function () {
			if ((defLang.$ === 'Just') && (defLang.a.$ === 'UK')) {
				var _v4 = defLang.a;
				return 'uk';
			} else {
				return 'en';
			}
		}();
		var select = {
			items: _List_fromArray(
				[
					$Confidenceman02$elm_select$Select$basicMenuItem(
					{item: $author$project$Main$EN, label: 'EN'}),
					$Confidenceman02$elm_select$Select$basicMenuItem(
					{item: $author$project$Main$UK, label: 'UA'})
				]),
			selectState: $Confidenceman02$elm_select$Select$initState(
				$Confidenceman02$elm_select$Select$selectIdentifier('LocalSelector')),
			selectedLanguage: defLang
		};
		var initmodel = function () {
			var _v0 = A2($elm$json$Json$Decode$decodeString, $ChristophP$elm_i18next$I18Next$translationsDecoder, flags.tr);
			if (_v0.$ === 'Ok') {
				var translations = _v0.a;
				var initSharedState = {
					env: {haycap: flags.env.haycap, weetags: flags.env.weetags},
					lang: '',
					navKey: navKey,
					testRoute: $author$project$Route$parseUrl(url),
					theme: 'white',
					translations: translations
				};
				var defaultLn = A2($ChristophP$elm_i18next$I18Next$t, translations, 'lang');
				var selectLn = function () {
					if (defaultLn === 'uk') {
						return $elm$core$Maybe$Just($author$project$Main$UK);
					} else {
						return $elm$core$Maybe$Just($author$project$Main$EN);
					}
				}();
				var _v1 = A2($author$project$Routing$Router$init, url, initSharedState);
				var initRouterModel = _v1.a;
				var routerCmd = _v1.b;
				var share = _v1.c;
				return {
					appState: A2($author$project$Main$Ready, initSharedState, initRouterModel),
					env: {haycap: flags.env.haycap, weetags: flags.env.weetags},
					items: select.items,
					locOpen: false,
					navKey: navKey,
					openHamb: false,
					selectLn: $elm$core$Maybe$Just(lang),
					selectState: select.selectState,
					selectedLanguage: select.selectedLanguage,
					theme: 'white',
					translations: translations,
					url: url
				};
			} else {
				var err = _v0.a;
				return {
					appState: $author$project$Main$NotReady,
					env: {haycap: flags.env.haycap, weetags: flags.env.weetags},
					items: select.items,
					locOpen: false,
					navKey: navKey,
					openHamb: false,
					selectLn: $elm$core$Maybe$Just(lang),
					selectState: select.selectState,
					selectedLanguage: select.selectedLanguage,
					theme: 'white',
					translations: $ChristophP$elm_i18next$I18Next$initialTranslations,
					url: url
				};
			}
		}();
		return _Utils_Tuple2(
			initmodel,
			A2($elm$core$Platform$Cmd$map, $author$project$Main$RouterMsg, initCmd));
	});
var $author$project$Main$ChangedLn = function (a) {
	return {$: 'ChangedLn', a: a};
};
var $author$project$Main$changeLg = _Platform_incomingPort('changeLg', $elm$json$Json$Decode$string);
var $author$project$Main$subscriptions = function (_v0) {
	return $author$project$Main$changeLg($author$project$Main$ChangedLn);
};
var $author$project$Routing$Router$UrlChanged = function (a) {
	return {$: 'UrlChanged', a: a};
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$core$Basics$not = _Basics_not;
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Main$selectLg = _Platform_outgoingPort('selectLg', $elm$json$Json$Encode$string);
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 'Nothing') {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 'Nothing') {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.protocol;
		if (_v0.$ === 'Http') {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.fragment,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.query,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.port_,
					_Utils_ap(http, url.host)),
				url.path)));
};
var $author$project$SharedState$UpdateRoute = function (a) {
	return {$: 'UpdateRoute', a: a};
};
var $author$project$SharedState$update = F2(
	function (sharedState, sharedStateUpdate) {
		switch (sharedStateUpdate.$) {
			case 'UpdateTranslations':
				var tr = sharedStateUpdate.a;
				return _Utils_update(
					sharedState,
					{translations: tr});
			case 'NoUpdate':
				return sharedState;
			case 'UpdateRoute':
				var route = sharedStateUpdate.a;
				return _Utils_update(
					sharedState,
					{testRoute: route});
			case 'ChangeTheme':
				var th = sharedStateUpdate.a;
				return _Utils_update(
					sharedState,
					{theme: th});
			default:
				var ln = sharedStateUpdate.a;
				return _Utils_update(
					sharedState,
					{lang: ln});
		}
	});
var $author$project$Routing$Router$HomeMsg = function (a) {
	return {$: 'HomeMsg', a: a};
};
var $author$project$Page$Search$ResetQuery = {$: 'ResetQuery'};
var $author$project$Page$Search$SearchData = {$: 'SearchData'};
var $author$project$Page$Search$UpdateQuery = function (a) {
	return {$: 'UpdateQuery', a: a};
};
var $author$project$Page$Home$SearchMsg = function (a) {
	return {$: 'SearchMsg', a: a};
};
var $author$project$Page$Home$Focus = {$: 'Focus'};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			$elm$core$Task$Perform(
				A2(
					$elm$core$Task$onError,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Err),
					A2(
						$elm$core$Task$andThen,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
							$elm$core$Result$Ok),
						task))));
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Page$Home$focusSearchBox = A2(
	$elm$core$Task$attempt,
	function (_v0) {
		return $author$project$Page$Home$Focus;
	},
	$elm$browser$Browser$Dom$focus('search-box'));
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{nodeList: nodeList, nodeListSize: nodeListSize, tail: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (_v0.$ === 'SubTree') {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 'QueryParameter', a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Route$stringFromUrl = function (route) {
	switch (route.$) {
		case 'Home':
			return 'Home';
		case 'Search':
			return 'Search';
		case 'Contact':
			return 'Contact';
		case 'Report':
			return 'Report';
		case 'Privacy':
			return 'Privacy';
		default:
			return 'NotFound';
	}
};
var $author$project$Page$Home$update = F3(
	function (sharedstate, msg, model) {
		switch (msg.$) {
			case 'UpdateQ':
				var qry = msg.a;
				var newQ = {
					filters: {tags_cities: $elm$core$Maybe$Nothing, tags_main_country: $elm$core$Maybe$Nothing, tags_regions: $elm$core$Maybe$Nothing, tags_small_cities: $elm$core$Maybe$Nothing, tags_sub_topics: $elm$core$Maybe$Nothing, tags_topics: $elm$core$Maybe$Nothing, tags_village: $elm$core$Maybe$Nothing, visible: true},
					query: qry
				};
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{error: '', query: newQ}),
					$elm$core$Platform$Cmd$none,
					sharedstate);
			case 'SubmitData':
				var urlStr = $author$project$Route$stringFromUrl(sharedstate.testRoute);
				var queryUrl = A2(
					$elm$url$Url$Builder$relative,
					_List_fromArray(
						['search']),
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'query', model.query.query)
						]));
				var oldFilters = model.query.filters;
				return $elm$core$String$isEmpty(model.query.query) ? _Utils_Tuple3(
					_Utils_update(
						model,
						{error: ' Please enter a  question '}),
					$elm$core$Platform$Cmd$none,
					sharedstate) : _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Page$Home$SearchMsg,
								A2(
									$author$project$Page$Search$searchData,
									sharedstate,
									{
										filters: _Utils_update(
											oldFilters,
											{tags_topics: $elm$core$Maybe$Nothing}),
										query: model.query.query
									})),
								A2($elm$browser$Browser$Navigation$pushUrl, sharedstate.navKey, queryUrl)
							])),
					sharedstate);
			case 'ResetQuery':
				var oldFilters = model.query.filters;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							query: {
								filters: _Utils_update(
									oldFilters,
									{tags_topics: $elm$core$Maybe$Nothing}),
								query: ''
							}
						}),
					$elm$core$Platform$Cmd$none,
					sharedstate);
			case 'SearchMsg':
				var searchMsg = msg.a;
				var oldFilters = model.query.filters;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							query: {
								filters: _Utils_update(
									oldFilters,
									{tags_topics: $elm$core$Maybe$Nothing}),
								query: ''
							}
						}),
					$elm$core$Platform$Cmd$none,
					sharedstate);
			case 'NextSlide':
				var newPosition = (model.sliderPosition < 2) ? (model.sliderPosition + 1) : 0;
				var imgsArray = $elm$core$Array$fromList(model.sliderImgs);
				var getImage = A2($elm$core$Array$get, newPosition, imgsArray);
				var img = function () {
					if (getImage.$ === 'Just') {
						var image = getImage.a;
						return image;
					} else {
						return {sub: '', title: '', url: ''};
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sliderPosition: newPosition}),
					$elm$core$Platform$Cmd$none,
					sharedstate);
			case 'PrevSlide':
				var newPosition = (model.sliderPosition > 0) ? (model.sliderPosition - 1) : 2;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sliderPosition: newPosition}),
					$elm$core$Platform$Cmd$none,
					sharedstate);
			default:
				return _Utils_Tuple3(model, $author$project$Page$Home$focusSearchBox, sharedstate);
		}
	});
var $author$project$Page$Search$CitiesReceived = function (a) {
	return {$: 'CitiesReceived', a: a};
};
var $author$project$Page$Search$fetchCities = F2(
	function (share, id) {
		var testUrl = share.env.weetags + '/locations/find_all/';
		var modelCountry = id;
		var endUrl = '/child?fields=id,name_eng,name_ukr,name_rus';
		var test = _Utils_ap(
			testUrl,
			_Utils_ap(id, endUrl));
		return $elm$http$Http$get(
			{
				expect: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$Search$CitiesReceived),
					$elm$json$Json$Decode$list($author$project$Document$locationDecoder)),
				url: test
			});
	});
var $author$project$Page$Search$RegionReceived = function (a) {
	return {$: 'RegionReceived', a: a};
};
var $author$project$Page$Search$fetchRegion = F2(
	function (share, id) {
		var testUrl = share.env.weetags + '/locations/find_all/';
		var modelCountry = id;
		var endUrl = '/child?fields=id,name_eng,name_ukr,name_rus';
		var test = _Utils_ap(
			testUrl,
			_Utils_ap(id, endUrl));
		return $elm$http$Http$get(
			{
				expect: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$Search$RegionReceived),
					$elm$json$Json$Decode$list($author$project$Document$locationDecoder)),
				url: test
			});
	});
var $author$project$Page$Search$SmallCitiesReceived = function (a) {
	return {$: 'SmallCitiesReceived', a: a};
};
var $author$project$Page$Search$fetchSmallCities = F2(
	function (share, id) {
		var testUrl = share.env.weetags + '/locations/find_all/';
		var modelCountry = id;
		var endUrl = '/child?fields=id,name_eng,name_ukr,name_rus';
		var test = _Utils_ap(
			testUrl,
			_Utils_ap(id, endUrl));
		return $elm$http$Http$get(
			{
				expect: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$Search$SmallCitiesReceived),
					$elm$json$Json$Decode$list($author$project$Document$locationDecoder)),
				url: test
			});
	});
var $author$project$Page$Search$VillagesReceived = function (a) {
	return {$: 'VillagesReceived', a: a};
};
var $author$project$Page$Search$fetchVillages = F2(
	function (share, id) {
		var testUrl = share.env.weetags + '/locations/find_all/';
		var modelCountry = id;
		var endUrl = '/child?fields=id,name_eng,name_ukr,name_rus';
		var test = _Utils_ap(
			testUrl,
			_Utils_ap(id, endUrl));
		return $elm$http$Http$get(
			{
				expect: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Page$Search$VillagesReceived),
					$elm$json$Json$Decode$list($author$project$Document$locationDecoder)),
				url: test
			});
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Page$Search$uncheck = _Platform_outgoingPort(
	'uncheck',
	$elm$json$Json$Encode$list($elm$json$Json$Encode$string));
var $author$project$Page$Search$update = F3(
	function (sharedstate, msg, model) {
		switch (msg.$) {
			case 'DataReceived':
				var response = msg.a;
				var queryUrl = A2(
					$elm$url$Url$Builder$relative,
					_List_fromArray(
						['search']),
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'query', model.search.query)
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{data: response}),
					$elm$core$Platform$Cmd$none);
			case 'SearchData':
				var closeModel = function () {
					var _v2 = model.modalOpen;
					if (_v2) {
						return false;
					} else {
						return false;
					}
				}();
				var closeLocation = function () {
					var _v1 = model.locationOpen;
					if (_v1) {
						return false;
					} else {
						return false;
					}
				}();
				if (model.search.query !== '') {
					var queryUrl = A2(
						$elm$url$Url$Builder$relative,
						_List_fromArray(
							['search']),
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'query', model.search.query)
							]));
					var cmdUrl = A2($elm$browser$Browser$Navigation$replaceUrl, sharedstate.navKey, queryUrl);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{data: $krisajenkins$remotedata$RemoteData$Loading}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmdUrl,
									A2($author$project$Page$Search$searchData, sharedstate, model.search)
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{error: 'Please enter a question', locationOpen: closeLocation, modalOpen: closeModel}),
						$elm$core$Platform$Cmd$none);
				}
			case 'CommonSearch':
				var common = msg.a;
				var queryUrl = A2(
					$elm$url$Url$Builder$relative,
					_List_fromArray(
						['search']),
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'query', common)
						]));
				var oldSearch = model.search;
				var newSearch = _Utils_update(
					oldSearch,
					{query: common});
				var cmdUrl = A2($elm$browser$Browser$Navigation$replaceUrl, sharedstate.navKey, queryUrl);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{data: $krisajenkins$remotedata$RemoteData$Loading, search: newSearch}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmdUrl,
								A2($author$project$Page$Search$searchData, sharedstate, newSearch)
							])));
			case 'UpdateQuery':
				var query = msg.a;
				var oldSearch = model.search;
				var noError = '';
				var newSearch = _Utils_update(
					oldSearch,
					{query: query});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{error: '', search: newSearch}),
					$elm$core$Platform$Cmd$none);
			case 'ResetFilters':
				var filters = msg.a;
				var topics = function () {
					var _v4 = model.tagsTopics;
					if (_v4.$ === 'Just') {
						var top = _v4.a;
						return top;
					} else {
						return _List_Nil;
					}
				}();
				var subtopics = function () {
					var _v3 = model.tagsSubTopics;
					if (_v3.$ === 'Just') {
						var top = _v3.a;
						return top;
					} else {
						return _List_Nil;
					}
				}();
				var oldSearch = model.search;
				var oldFilters = model.search.filters;
				var reset = _Utils_update(
					oldSearch,
					{
						filters: _Utils_update(
							oldFilters,
							{tags_cities: $elm$core$Maybe$Nothing, tags_main_country: $elm$core$Maybe$Nothing, tags_regions: $elm$core$Maybe$Nothing, tags_small_cities: $elm$core$Maybe$Nothing, tags_sub_topics: $elm$core$Maybe$Nothing, tags_topics: $elm$core$Maybe$Nothing, tags_village: $elm$core$Maybe$Nothing, visible: true})
					});
				var cmd = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$Page$Search$searchData, sharedstate, reset),
							$author$project$Page$Search$uncheck(topics)
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							data: $krisajenkins$remotedata$RemoteData$Loading,
							search: reset,
							selectedCities: A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.location.Area'),
							selectedLocation: A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.location.Country'),
							selectedRegion: A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.location.Region'),
							selectedSmallCities: A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.location.Community'),
							selectedVillage: A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.location.Settlement'),
							tagsSubTopics: $elm$core$Maybe$Just(_List_Nil),
							tagsTopics: $elm$core$Maybe$Just(_List_Nil)
						}),
					cmd);
			case 'LanguageFilter':
				var _v5 = model.data;
				if (_v5.$ === 'Success') {
					var data = _v5.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 'ResetQuery':
				var search = model.search;
				var reseted = _Utils_update(
					search,
					{query: ''});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{search: reseted}),
					$elm$core$Platform$Cmd$none);
			case 'CloseSurvey':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{openSurvey: false}),
					$elm$core$Platform$Cmd$none);
			case 'ToggleModal':
				var select = function () {
					var _v6 = model.selectOpen;
					if (_v6) {
						return false;
					} else {
						return false;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{locationOpen: !model.locationOpen, modalOpen: !model.modalOpen, selectOpen: select}),
					$elm$core$Platform$Cmd$none);
			case 'OpenTopics':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{topicsOpen: !model.topicsOpen}),
					$elm$core$Platform$Cmd$none);
			case 'OpenLocation':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{locationOpen: !model.locationOpen}),
					$elm$core$Platform$Cmd$none);
			case 'ViewSubTopic':
				var topic = msg.a;
				return (topic === 'housing') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{housingSubOpen: !model.housingSubOpen}),
					A2($author$project$Page$Search$fetchSubTopic, sharedstate, 'Housing')) : ((topic === 'healthcare') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{healthcareSubOpen: !model.healthcareSubOpen}),
					$elm$core$Platform$Cmd$none) : ((topic === 'legalaid') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{legalaidSubOpen: !model.legalaidSubOpen}),
					$elm$core$Platform$Cmd$none) : ((topic === 'employment') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{employmentSubOpen: !model.employmentSubOpen}),
					$elm$core$Platform$Cmd$none) : ((topic === 'education') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{educationSubOpen: !model.educationSubOpen}),
					$elm$core$Platform$Cmd$none) : ((topic === 'financialsupport') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{financialSubOpen: !model.financialSubOpen}),
					$elm$core$Platform$Cmd$none) : ((topic === 'humanitarianaid') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{humanitarianSubOpen: !model.humanitarianSubOpen}),
					$elm$core$Platform$Cmd$none) : ((topic === 'socialservices') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{socialSubOpen: !model.socialSubOpen}),
					$elm$core$Platform$Cmd$none) : ((topic === 'protection') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{protectionSubOpen: !model.protectionSubOpen}),
					$elm$core$Platform$Cmd$none) : ((topic === 'transportation') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{transportSubOpen: !model.transportSubOpen}),
					$elm$core$Platform$Cmd$none) : ((topic === 'emigration') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{emigrationSubOpen: !model.emigrationSubOpen}),
					$elm$core$Platform$Cmd$none) : ((topic === 'hotlines') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{hotlineSubOpen: !model.hotlineSubOpen}),
					$elm$core$Platform$Cmd$none) : ((topic === 'pets') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{petSubOpen: !model.petSubOpen}),
					$elm$core$Platform$Cmd$none) : ((topic === 'psychologicalsupport') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{psychoSubOpen: !model.psychoSubOpen}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none))))))))))))));
			case 'FilterTopics':
				var topic = msg.a;
				var val = msg.b;
				var topicsFilters = function () {
					var _v8 = model.tagsTopics;
					if (_v8.$ === 'Nothing') {
						return $elm$core$Maybe$Just(
							_List_fromArray(
								[topic]));
					} else {
						var topicsList = _v8.a;
						var newFilteredList = function () {
							if (val) {
								return A2($elm$core$List$cons, topic, topicsList);
							} else {
								return A2(
									$elm$core$List$filter,
									function (filter) {
										return !_Utils_eq(filter, topic);
									},
									topicsList);
							}
						}();
						return $elm$core$Maybe$Just(newFilteredList);
					}
				}();
				var oldfFilters = model.search.filters;
				var oldSearch = model.search;
				var oldFilters = model.search.query;
				var listTags = function () {
					if (topicsFilters.$ === 'Nothing') {
						return _List_Nil;
					} else {
						var filters = topicsFilters.a;
						return filters;
					}
				}();
				var newSearch = _Utils_update(
					oldSearch,
					{
						filters: _Utils_update(
							oldfFilters,
							{
								tags_topics: $elm$core$Maybe$Just(
									{val: listTags})
							})
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							data: $krisajenkins$remotedata$RemoteData$Loading,
							search: _Utils_update(
								oldSearch,
								{
									filters: _Utils_update(
										oldfFilters,
										{
											tags_topics: $elm$core$Maybe$Just(
												{val: listTags})
										})
								}),
							tagsTopics: topicsFilters
						}),
					A2($author$project$Page$Search$searchData, sharedstate, newSearch));
			case 'FilterSubTopics':
				var subtopic = msg.a;
				var val = msg.b;
				var topicsFilters = function () {
					var _v11 = model.tagsSubTopics;
					if (_v11.$ === 'Nothing') {
						return $elm$core$Maybe$Just(
							_List_fromArray(
								[subtopic]));
					} else {
						var topicsList = _v11.a;
						var newFilteredList = function () {
							if (val) {
								return A2($elm$core$List$cons, subtopic, topicsList);
							} else {
								return A2(
									$elm$core$List$filter,
									function (filter) {
										return !_Utils_eq(filter, subtopic);
									},
									topicsList);
							}
						}();
						return $elm$core$Maybe$Just(newFilteredList);
					}
				}();
				var oldfFilters = model.search.filters;
				var oldSearch = model.search;
				var oldFilters = model.search.query;
				var listTags = function () {
					if (topicsFilters.$ === 'Nothing') {
						return _List_Nil;
					} else {
						var filters = topicsFilters.a;
						return filters;
					}
				}();
				var newSearch = _Utils_update(
					oldSearch,
					{
						filters: _Utils_update(
							oldfFilters,
							{
								tags_sub_topics: $elm$core$Maybe$Just(
									{val: listTags})
							})
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							data: $krisajenkins$remotedata$RemoteData$Loading,
							search: _Utils_update(
								oldSearch,
								{
									filters: _Utils_update(
										oldfFilters,
										{
											tags_sub_topics: $elm$core$Maybe$Just(
												{val: listTags})
										})
								}),
							tagsSubTopics: topicsFilters
						}),
					A2($author$project$Page$Search$searchData, sharedstate, newSearch));
			case 'ViewDropdown':
				var location = msg.a;
				return (location === 'Country') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{selectOpen: !model.selectOpen}),
					$elm$core$Platform$Cmd$none) : ((location === 'Region') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{selectROpen: !model.selectROpen}),
					$elm$core$Platform$Cmd$none) : ((location === 'Cities') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{selectCOpen: !model.selectCOpen}),
					$elm$core$Platform$Cmd$none) : ((location === 'Small cities') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{selectSOpen: !model.selectSOpen}),
					$elm$core$Platform$Cmd$none) : ((location === 'Villages') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{selectVOpen: !model.selectVOpen}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none)))));
			case 'CloseDrop':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{selectOpen: !model.selectOpen}),
					$elm$core$Platform$Cmd$none);
			case 'SelectLocation':
				var location = msg.a;
				var id = msg.b;
				var villageLocation = (location === 'Ukraine') ? model.search.filters.tags_village : $elm$core$Maybe$Just(
					{val: _List_Nil});
				var smCitiesLocation = (location === 'Ukraine') ? model.search.filters.tags_small_cities : $elm$core$Maybe$Just(
					{val: _List_Nil});
				var regionLocation = (location === 'Ukraine') ? model.search.filters.tags_regions : $elm$core$Maybe$Just(
					{val: _List_Nil});
				var oldSearch = model.search;
				var oldFilters = model.search.filters;
				var listLocation = (location === 'All') ? _List_Nil : ((location === 'все') ? _List_Nil : $elm$core$List$singleton(id));
				var newsearch = _Utils_update(
					oldSearch,
					{
						filters: _Utils_update(
							oldFilters,
							{
								tags_main_country: $elm$core$Maybe$Just(
									{val: listLocation})
							})
					});
				var cmd = (id !== 'All') ? $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$Page$Search$searchData, sharedstate, newsearch),
							A2($author$project$Page$Search$fetchRegion, sharedstate, id)
						])) : A2($author$project$Page$Search$searchData, sharedstate, newsearch);
				var citiesLocation = (location === 'Ukraine') ? model.search.filters.tags_cities : $elm$core$Maybe$Just(
					{val: _List_Nil});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							data: $krisajenkins$remotedata$RemoteData$Loading,
							search: _Utils_update(
								oldSearch,
								{
									filters: _Utils_update(
										oldFilters,
										{
											tags_cities: citiesLocation,
											tags_main_country: $elm$core$Maybe$Just(
												{val: listLocation}),
											tags_regions: regionLocation,
											tags_small_cities: smCitiesLocation,
											tags_village: villageLocation
										})
								}),
							selectOpen: !model.selectOpen,
							selectedCities: 'Area/Raion',
							selectedCountry: id,
							selectedLocation: location,
							selectedRegion: 'Region/Oblast',
							selectedSmallCities: 'Community/Hromada',
							selectedVillage: 'Settlement/Naselenyi punkt'
						}),
					cmd);
			case 'SelectRegion':
				var region = msg.a;
				var id = msg.b;
				var oldSearch = model.search;
				var oldFilters = model.search.filters;
				var listLocation = (region === 'All') ? _List_Nil : ((region === 'все') ? _List_Nil : $elm$core$List$singleton(id));
				var newSearch = _Utils_update(
					oldSearch,
					{
						filters: _Utils_update(
							oldFilters,
							{
								tags_regions: $elm$core$Maybe$Just(
									{val: listLocation})
							})
					});
				var cmd = (id !== 'All') ? $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$Page$Search$searchData, sharedstate, newSearch),
							A2($author$project$Page$Search$fetchCities, sharedstate, id)
						])) : A2($author$project$Page$Search$searchData, sharedstate, newSearch);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							data: $krisajenkins$remotedata$RemoteData$Loading,
							search: _Utils_update(
								oldSearch,
								{
									filters: _Utils_update(
										oldFilters,
										{
											tags_regions: $elm$core$Maybe$Just(
												{val: listLocation})
										})
								}),
							selectROpen: !model.selectROpen,
							selectedRegion: region
						}),
					cmd);
			case 'SelectCities':
				var city = msg.a;
				var id = msg.b;
				var oldSearch = model.search;
				var oldFilters = model.search.filters;
				var listLocation = (city === 'All') ? _List_Nil : ((city === 'все') ? _List_Nil : $elm$core$List$singleton(id));
				var newSearch = _Utils_update(
					oldSearch,
					{
						filters: _Utils_update(
							oldFilters,
							{
								tags_cities: $elm$core$Maybe$Just(
									{val: listLocation})
							})
					});
				var cmd = (id !== 'All') ? $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$Page$Search$searchData, sharedstate, newSearch),
							A2($author$project$Page$Search$fetchSmallCities, sharedstate, id)
						])) : A2($author$project$Page$Search$searchData, sharedstate, newSearch);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							data: $krisajenkins$remotedata$RemoteData$Loading,
							search: _Utils_update(
								oldSearch,
								{
									filters: _Utils_update(
										oldFilters,
										{
											tags_cities: $elm$core$Maybe$Just(
												{val: listLocation})
										})
								}),
							selectCOpen: !model.selectCOpen,
							selectedCities: city
						}),
					cmd);
			case 'SelectSmallCities':
				var smallcity = msg.a;
				var id = msg.b;
				var oldSearch = model.search;
				var oldFilters = model.search.filters;
				var listLocation = (smallcity === 'All') ? _List_Nil : ((smallcity === 'все') ? _List_Nil : $elm$core$List$singleton(id));
				var newSearch = _Utils_update(
					oldSearch,
					{
						filters: _Utils_update(
							oldFilters,
							{
								tags_small_cities: $elm$core$Maybe$Just(
									{val: listLocation})
							})
					});
				var cmd = (id !== 'All') ? $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($author$project$Page$Search$searchData, sharedstate, newSearch),
							A2($author$project$Page$Search$fetchVillages, sharedstate, id)
						])) : A2($author$project$Page$Search$searchData, sharedstate, newSearch);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							data: $krisajenkins$remotedata$RemoteData$Loading,
							search: _Utils_update(
								oldSearch,
								{
									filters: _Utils_update(
										oldFilters,
										{
											tags_small_cities: $elm$core$Maybe$Just(
												{val: listLocation})
										})
								}),
							selectSOpen: !model.selectSOpen,
							selectedSmallCities: smallcity
						}),
					cmd);
			case 'SelectVillage':
				var village = msg.a;
				var id = msg.b;
				var oldSearch = model.search;
				var oldFilters = model.search.filters;
				var listLocation = (village === 'All') ? _List_Nil : ((village === 'все') ? _List_Nil : $elm$core$List$singleton(id));
				var newSearch = _Utils_update(
					oldSearch,
					{
						filters: _Utils_update(
							oldFilters,
							{
								tags_village: $elm$core$Maybe$Just(
									{val: listLocation})
							})
					});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							data: $krisajenkins$remotedata$RemoteData$Loading,
							search: _Utils_update(
								oldSearch,
								{
									filters: _Utils_update(
										oldFilters,
										{
											tags_village: $elm$core$Maybe$Just(
												{val: listLocation})
										})
								}),
							selectVOpen: !model.selectVOpen,
							selectedVillage: village
						}),
					A2($author$project$Page$Search$searchData, sharedstate, newSearch));
			case 'RegionReceived':
				var regions = msg.a;
				var reg = function () {
					if (regions.$ === 'Success') {
						var regi = regions.a;
						return regi;
					} else {
						return _List_Nil;
					}
				}();
				var dictLoc = A2(
					$elm$core$List$map,
					function (x) {
						return A2($elm$core$Tuple$pair, x.id, x.name_eng);
					},
					reg);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{regionList: regions}),
					$elm$core$Platform$Cmd$none);
			case 'CitiesReceived':
				var cities = msg.a;
				var cit = function () {
					if (cities.$ === 'Success') {
						var cty = cities.a;
						return cty;
					} else {
						return _List_Nil;
					}
				}();
				var dictLoc = A2(
					$elm$core$List$map,
					function (x) {
						return A2($elm$core$Tuple$pair, x.id, x.name_eng);
					},
					cit);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{citiesList: cities}),
					$elm$core$Platform$Cmd$none);
			case 'SmallCitiesReceived':
				var cities = msg.a;
				var cit = function () {
					if (cities.$ === 'Success') {
						var cty = cities.a;
						return cty;
					} else {
						return _List_Nil;
					}
				}();
				var dictLoc = A2(
					$elm$core$List$map,
					function (x) {
						return A2($elm$core$Tuple$pair, x.id, x.name_eng);
					},
					cit);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{smallCitiesList: cities}),
					$elm$core$Platform$Cmd$none);
			case 'VillagesReceived':
				var villages = msg.a;
				var cit = function () {
					if (villages.$ === 'Success') {
						var cty = villages.a;
						return cty;
					} else {
						return _List_Nil;
					}
				}();
				var dictLoc = A2(
					$elm$core$List$map,
					function (x) {
						return A2($elm$core$Tuple$pair, x.id, x.name_eng);
					},
					cit);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{villageList: villages}),
					$elm$core$Platform$Cmd$none);
			case 'LocationReceived':
				var locations = msg.a;
				var loc = function () {
					if (locations.$ === 'Success') {
						var loct = locations.a;
						return loct;
					} else {
						return _List_Nil;
					}
				}();
				var dictLoc = A2(
					$elm$core$List$map,
					function (x) {
						return A2($elm$core$Tuple$pair, x.id, x.name_eng);
					},
					loc);
				var dictLocation = $elm$core$Dict$fromList(dictLoc);
				var getValue = A2($elm$core$Dict$get, 'UK', dictLocation);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{locationList: locations, locationTr: dictLocation}),
					$elm$core$Platform$Cmd$none);
			case 'ShowFilters':
				var filter = msg.a;
				return (filter === 'location') ? _Utils_Tuple2(
					_Utils_update(
						model,
						{showLocation: !model.showLocation}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{showTopics: !model.showTopics}),
					$elm$core$Platform$Cmd$none);
			default:
				var topic = msg.a;
				var subtopics = msg.b;
				var sub = function () {
					if (subtopics.$ === 'Success') {
						var sb = subtopics.a;
						return sb;
					} else {
						return _List_Nil;
					}
				}();
				var subdict = A3($elm$core$Dict$insert, topic, sub, model.subTopicsDict);
				var testget = A2($elm$core$Dict$get, topic, subdict);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{subTopicsDict: subdict}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Routing$Router$updateSearch = F3(
	function (sharedstate, model, searchmsg) {
		var _v0 = A3($author$project$Page$Search$update, sharedstate, searchmsg, model.searchModel);
		var nextSearchModel = _v0.a;
		var searchCmd = _v0.b;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{searchModel: nextSearchModel}),
			A2($elm$core$Platform$Cmd$map, $author$project$Routing$Router$SearchMsg, searchCmd),
			sharedstate);
	});
var $author$project$Routing$Router$updateHome = F3(
	function (sharedstate, model, homemsg) {
		var _v0 = function () {
			switch (homemsg.$) {
				case 'UpdateQ':
					var val = homemsg.a;
					return A3(
						$author$project$Routing$Router$updateSearch,
						sharedstate,
						model,
						$author$project$Page$Search$UpdateQuery(val));
				case 'SubmitData':
					return A3($author$project$Routing$Router$updateSearch, sharedstate, model, $author$project$Page$Search$SearchData);
				case 'SearchMsg':
					var searchMsg = homemsg.a;
					return A3($author$project$Routing$Router$updateSearch, sharedstate, model, searchMsg);
				case 'ResetQuery':
					return A3($author$project$Routing$Router$updateSearch, sharedstate, model, $author$project$Page$Search$ResetQuery);
				default:
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, sharedstate);
			}
		}();
		var updatedSearchModel = _v0.a;
		var searchCmd = _v0.b;
		var sharedS = _v0.c;
		var _v2 = A3($author$project$Page$Home$update, sharedstate, homemsg, model.homeModel);
		var nextHomeModel = _v2.a;
		var homeCmd = _v2.b;
		var shared = _v2.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{homeModel: nextHomeModel, searchModel: updatedSearchModel.searchModel}),
			A2($elm$core$Platform$Cmd$map, $author$project$Routing$Router$HomeMsg, homeCmd),
			shared);
	});
var $author$project$Routing$Router$update = F3(
	function (sharestate, msg, model) {
		switch (msg.$) {
			case 'UrlChanged':
				var location = msg.a;
				var newShared = A2(
					$author$project$SharedState$update,
					sharestate,
					$author$project$SharedState$UpdateRoute(
						$author$project$Route$parseUrl(location)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							route: $author$project$Route$parseUrl(location)
						}),
					$elm$core$Platform$Cmd$none,
					newShared);
			case 'HomeMsg':
				var homemsg = msg.a;
				return A3($author$project$Routing$Router$updateHome, sharestate, model, homemsg);
			case 'SearchMsg':
				var searchmsg = msg.a;
				return A3($author$project$Routing$Router$updateSearch, sharestate, model, searchmsg);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, sharestate);
		}
	});
var $author$project$Main$updateRouter = F2(
	function (model, routerMsg) {
		var _v0 = model.appState;
		if (_v0.$ === 'Ready') {
			var shareState = _v0.a;
			var routeModel = _v0.b;
			var _v1 = A3($author$project$Routing$Router$update, shareState, routerMsg, routeModel);
			var nextRouterModel = _v1.a;
			var routerCmd = _v1.b;
			var newSharedState = _v1.c;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						appState: A2($author$project$Main$Ready, newSharedState, nextRouterModel)
					}),
				A2($elm$core$Platform$Cmd$map, $author$project$Main$RouterMsg, routerCmd));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$SharedState$ChangeTheme = function (a) {
	return {$: 'ChangeTheme', a: a};
};
var $author$project$Main$selectTh = _Platform_outgoingPort('selectTh', $elm$json$Json$Encode$string);
var $author$project$Main$updateTheme = function (model) {
	var _v0 = model.theme;
	if (_v0 === 'white') {
		var updatedTheme = $author$project$SharedState$ChangeTheme('dark');
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{theme: 'black'}),
			$author$project$Main$selectTh('dark'));
	} else {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{theme: 'white'}),
			$author$project$Main$selectTh('white'));
	}
};
var $author$project$SharedState$UpdateTranslations = function (a) {
	return {$: 'UpdateTranslations', a: a};
};
var $author$project$Main$updateTranslations = F3(
	function (route, model, ln) {
		var _v0 = A2($elm$json$Json$Decode$decodeString, $ChristophP$elm_i18next$I18Next$translationsDecoder, ln);
		if (_v0.$ === 'Ok') {
			var translations = _v0.a;
			var _v1 = model.appState;
			switch (_v1.$) {
				case 'NotReady':
					var initSharedState = {
						env: model.env,
						lang: ln,
						navKey: model.navKey,
						testRoute: $author$project$Route$parseUrl(route),
						theme: 'white',
						translations: translations
					};
					var _v2 = A2($author$project$Routing$Router$init, model.url, initSharedState);
					var initRouterModel = _v2.a;
					var routerCmd = _v2.b;
					var share = _v2.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								appState: A2($author$project$Main$Ready, initSharedState, initRouterModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Main$RouterMsg, routerCmd));
				case 'Ready':
					var shareState = _v1.a;
					var routerModel = _v1.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								appState: A2(
									$author$project$Main$Ready,
									A2(
										$author$project$SharedState$update,
										shareState,
										$author$project$SharedState$UpdateTranslations(translations)),
									routerModel)
							}),
						$elm$core$Platform$Cmd$none);
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		} else {
			var err = _v0.a;
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 'RouterMsg':
				var routerMsg = msg.a;
				return A2($author$project$Main$updateRouter, model, routerMsg);
			case 'UrlChanged':
				var url = msg.a;
				return A2(
					$author$project$Main$updateRouter,
					_Utils_update(
						model,
						{url: url}),
					$author$project$Routing$Router$UrlChanged(url));
			case 'SelectLg':
				var ln = msg.a;
				var lang = (ln === 'UK') ? $elm$core$Maybe$Just($author$project$Main$UK) : $elm$core$Maybe$Just($author$project$Main$EN);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							selectLn: $elm$core$Maybe$Just(ln),
							selectedLanguage: lang
						}),
					$author$project$Main$selectLg(ln));
			case 'LinkClicked':
				var urlRequest = msg.a;
				if (urlRequest.$ === 'Internal') {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$browser$Browser$Navigation$replaceUrl,
							model.navKey,
							$elm$url$Url$toString(url)));
				} else {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(url));
				}
			case 'ChangedLn':
				var ln = msg.a;
				return A3($author$project$Main$updateTranslations, model.url, model, ln);
			case 'ChangedTh':
				var th = msg.a;
				return $author$project$Main$updateTheme(model);
			case 'OpenHamb':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{openHamb: !model.openHamb}),
					$elm$core$Platform$Cmd$none);
			case 'ViewLoc':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{locOpen: !model.locOpen}),
					$elm$core$Platform$Cmd$none);
			default:
				var loc = msg.a;
				var lang = (loc === 'uk') ? $elm$core$Maybe$Just($author$project$Main$UK) : $elm$core$Maybe$Just($author$project$Main$EN);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							locOpen: !model.locOpen,
							selectLn: $elm$core$Maybe$Just(loc),
							selectedLanguage: lang
						}),
					$author$project$Main$selectLg(loc));
		}
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $tesk9$accessible_html$Accessibility$Utils$role = function (role_) {
	return A2($elm$html$Html$Attributes$attribute, 'role', role_);
};
var $tesk9$accessible_html$Accessibility$Role$document = $tesk9$accessible_html$Accessibility$Utils$role('document');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $tesk9$accessible_html$Accessibility$Utils$aria = A2(
	$elm$core$Basics$composeL,
	$elm$html$Html$Attributes$attribute,
	$elm$core$Basics$append('aria-'));
var $tesk9$accessible_html$Accessibility$Aria$label = $tesk9$accessible_html$Accessibility$Utils$aria('label');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Main$returnState = function (model) {
	var _v0 = model.appState;
	if (_v0.$ === 'Ready') {
		var sharedState = _v0.a;
		var routeModel = _v0.b;
		return _Utils_Tuple2(sharedState, routeModel);
	} else {
		var _v1 = A2(
			$author$project$Routing$Router$init,
			model.url,
			{
				env: model.env,
				lang: '',
				navKey: model.navKey,
				testRoute: $author$project$Route$parseUrl(model.url),
				theme: 'white',
				translations: $ChristophP$elm_i18next$I18Next$initialTranslations
			});
		var initRouterModel = _v1.a;
		var routerCmd = _v1.b;
		var share = _v1.c;
		return _Utils_Tuple2(
			{
				env: {haycap: share.env.haycap, weetags: share.env.weetags},
				lang: '',
				navKey: model.navKey,
				testRoute: $author$project$Route$parseUrl(model.url),
				theme: 'white',
				translations: $ChristophP$elm_i18next$I18Next$initialTranslations
			},
			initRouterModel);
	}
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Routing$Router$ContactMsg = function (a) {
	return {$: 'ContactMsg', a: a};
};
var $author$project$Routing$Router$PrivacyMsg = function (a) {
	return {$: 'PrivacyMsg', a: a};
};
var $author$project$Routing$Router$ReportMsg = function (a) {
	return {$: 'ReportMsg', a: a};
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $tesk9$accessible_html$Accessibility$Landmark$main_ = $tesk9$accessible_html$Accessibility$Utils$role('main');
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $tesk9$accessible_html$Accessibility$Aria$roleDescription = $tesk9$accessible_html$Accessibility$Utils$aria('roledescription');
var $icidasset$elm_material_icons$Material$Icons$Types$Color = function (a) {
	return {$: 'Color', a: a};
};
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$br = _VirtualDom_node('br');
var $tesk9$accessible_html$Accessibility$Role$button = $tesk9$accessible_html$Accessibility$Utils$role('button');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $icidasset$elm_material_icons$Material$Icons$Internal$f = $elm$svg$Svg$Attributes$fill;
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$core$Basics$round = _Basics_round;
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $icidasset$elm_material_icons$Material$Icons$Internal$icon = F4(
	function (attributes, nodes, size, coloring) {
		var sizeAsString = $elm$core$String$fromInt(size);
		return A2(
			$elm$svg$Svg$svg,
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$height(sizeAsString),
						$elm$svg$Svg$Attributes$width(sizeAsString)
					])),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							function () {
							if (coloring.$ === 'Color') {
								var color = coloring.a;
								return $elm$svg$Svg$Attributes$fill(
									$avh4$elm_color$Color$toCssString(color));
							} else {
								return $elm$svg$Svg$Attributes$fill('currentColor');
							}
						}()
						]),
					nodes)
				]));
	});
var $elm$svg$Svg$Attributes$opacity = _VirtualDom_attribute('opacity');
var $icidasset$elm_material_icons$Material$Icons$Internal$o = $elm$svg$Svg$Attributes$opacity;
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $icidasset$elm_material_icons$Material$Icons$Internal$p = $elm$svg$Svg$path;
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $icidasset$elm_material_icons$Material$Icons$Internal$v = $elm$svg$Svg$Attributes$viewBox;
var $icidasset$elm_material_icons$Material$Icons$Outlined$cancel = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0V0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none'),
					$icidasset$elm_material_icons$Material$Icons$Internal$o('.87')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z')
				]),
			_List_Nil)
		]));
var $tesk9$accessible_html$Accessibility$Aria$errorMessage = $tesk9$accessible_html$Accessibility$Utils$aria('errormessage');
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $tesk9$accessible_html$Accessibility$Landmark$form = $tesk9$accessible_html$Accessibility$Utils$role('form');
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 'Normal', a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 'MayStopPropagation', a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 'MayPreventDefault', a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $tesk9$accessible_html$Accessibility$Utils$toBoolString = function (bool) {
	return bool ? 'true' : 'false';
};
var $tesk9$accessible_html$Accessibility$Aria$required = A2(
	$elm$core$Basics$composeL,
	$tesk9$accessible_html$Accessibility$Utils$aria('required'),
	$tesk9$accessible_html$Accessibility$Utils$toBoolString);
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 'RgbaSpace', a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$scaleFrom255 = function (c) {
	return c / 255;
};
var $avh4$elm_color$Color$rgb255 = F3(
	function (r, g, b) {
		return A4(
			$avh4$elm_color$Color$RgbaSpace,
			$avh4$elm_color$Color$scaleFrom255(r),
			$avh4$elm_color$Color$scaleFrom255(g),
			$avh4$elm_color$Color$scaleFrom255(b),
			1.0);
	});
var $tesk9$accessible_html$Accessibility$Landmark$search = $tesk9$accessible_html$Accessibility$Utils$role('search');
var $icidasset$elm_material_icons$Material$Icons$Outlined$search = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0V0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')
				]),
			_List_Nil)
		]));
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $tesk9$accessible_html$Accessibility$Role$textBox = $tesk9$accessible_html$Accessibility$Utils$role('textbox');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Page$Search$searchSm = F2(
	function (sharedState, model) {
		var visibleOR = function () {
			var _v4 = sharedState.testRoute;
			if (_v4.$ === 'Search') {
				return ' w-112 hidden md:block md:w-128';
			} else {
				return 'hidden';
			}
		}();
		var showSearchBar = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-kompas-300 dark:bg-slate-400   h-full  w-24 border-md flex flex-row justify-center items-center '),
					$elm$html$Html$Attributes$tabindex(0),
					$tesk9$accessible_html$Accessibility$Role$button,
					$tesk9$accessible_html$Accessibility$Aria$label('Submit'),
					$tesk9$accessible_html$Accessibility$Landmark$search,
					$elm$html$Html$Events$onClick($author$project$Page$Search$SearchData)
				]),
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Outlined$search,
					32,
					$icidasset$elm_material_icons$Material$Icons$Types$Color(
						A3($avh4$elm_color$Color$rgb255, 255, 255, 255)))
				]));
		var isHidden = function () {
			var _v3 = $elm$core$String$isEmpty(model.search.query);
			if (_v3) {
				return 'invisible';
			} else {
				return '';
			}
		}();
		var showReset = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(isHidden),
					$elm$html$Html$Events$onClick($author$project$Page$Search$ResetQuery),
					$elm$html$Html$Attributes$tabindex(0),
					$tesk9$accessible_html$Accessibility$Aria$label('reset query icon'),
					$elm$html$Html$Attributes$alt('reset query')
				]),
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Outlined$cancel,
					25,
					$icidasset$elm_material_icons$Material$Icons$Types$Color(
						A3($avh4$elm_color$Color$rgb255, 45, 55, 72)))
				]));
		var isError = function () {
			var _v1 = sharedState.testRoute;
			if (_v1.$ === 'Search') {
				var _v2 = $elm$core$String$isEmpty(model.error);
				if (_v2) {
					return 'invisible';
				} else {
					return 'text-center text-kompas-300 dark:text-slate-950 text-sm visible';
				}
			} else {
				return 'invisible';
			}
		}();
		var data = function () {
			var _v0 = model.data;
			if (_v0.$ === 'Success') {
				return true;
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mx-8 block sm:hidden mb-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded-3xl h-10'),
							$elm$html$Html$Events$onSubmit($author$project$Page$Search$SearchData),
							$tesk9$accessible_html$Accessibility$Landmark$form
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('  md:block rounded-3xl overflow-hidden dark:bg-none dark:border-solid dark:border dark:border-slate-600   drop-shadow-lg border-solid border border-kompas-300 h-full')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-row h-full items-center bg-white gap-x-2')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$for('search-bar'),
													$tesk9$accessible_html$Accessibility$Aria$label('search bar')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_(' text'),
													$elm$html$Html$Attributes$class('w-full h-12 px-12 outline-none rounded-md text-slate-700'),
													$elm$html$Html$Attributes$value(model.search.query),
													$elm$html$Html$Attributes$id('search-bar'),
													$elm$html$Html$Attributes$name('search-bar'),
													$elm$html$Html$Attributes$placeholder(
													A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'search.searchData')),
													$elm$html$Html$Events$onInput($author$project$Page$Search$UpdateQuery),
													$tesk9$accessible_html$Accessibility$Role$textBox,
													$tesk9$accessible_html$Accessibility$Aria$required(true)
												]),
											_List_Nil),
											showReset,
											showSearchBar
										]))
								])),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(isError),
									$tesk9$accessible_html$Accessibility$Aria$errorMessage('error-message-id')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('error-message-id')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'errors.search'))
										]))
								]))
						]))
				]));
	});
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$Page$Contact$hubForm = F2(
	function (attributes, children) {
		return A3($elm$html$Html$node, 'hub-spot', attributes, children);
	});
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Page$Contact$view = function (sharedstate) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-100 md:w-200')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(' relative basis-full dark:bg-white bg-kompas-300 p-2 dark:border-solid dark:border-2 dark:border-slate-200 ')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(' text-xs md:text-sm h-10 md:h-10 flex  flex-col md:flex-row gap-x-2 justify-center items-center ')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(' flex flex-row gap-x-2 dark:grayscale  items-center text-white dark:text-primarytext ')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src('/assets/message.svg'),
														$elm$html$Html$Attributes$alt('editing-icon')
													]),
												_List_Nil),
												$elm$html$Html$text(
												A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'survey.help'))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold underline ')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href(
														A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'survey.link')),
														$elm$html$Html$Attributes$target('_blank'),
														$elm$html$Html$Attributes$class('text-kyellow dark:text-primarytext')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'survey.submit'))
													]))
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-center text-2xl uppercase text-primarytext font-bold p-8 ')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'contact.title'))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-row justify-center')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Page$Contact$hubForm,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$placeholder('input for hubpost'),
								$elm$html$Html$Attributes$class('basis-3/4')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('#hbspt-form-1aec1fe8-caf2-4c60-a54c-056dcf950ae6')
					]),
				_List_Nil)
			]));
};
var $author$project$Page$Home$ResetQuery = {$: 'ResetQuery'};
var $author$project$Page$Home$SubmitData = {$: 'SubmitData'};
var $author$project$Page$Home$UpdateQ = function (a) {
	return {$: 'UpdateQ', a: a};
};
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $icidasset$elm_material_icons$Material$Icons$Types$Inherit = {$: 'Inherit'};
var $author$project$Page$Home$NextSlide = {$: 'NextSlide'};
var $author$project$Page$Home$PrevSlide = {$: 'PrevSlide'};
var $elm$svg$Svg$Attributes$enableBackground = _VirtualDom_attribute('enable-background');
var $icidasset$elm_material_icons$Material$Icons$Internal$b = $elm$svg$Svg$Attributes$enableBackground;
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $icidasset$elm_material_icons$Material$Icons$Outlined$arrow_circle_left = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M2,12c0,5.52,4.48,10,10,10c5.52,0,10-4.48,10-10S17.52,2,12,2C6.48,2,2,6.48,2,12z M20,12c0,4.42-3.58,8-8,8 c-4.42,0-8-3.58-8-8s3.58-8,8-8C16.42,4,20,7.58,20,12z M8,12l4-4l1.41,1.41L11.83,11H16v2h-4.17l1.59,1.59L12,16L8,12z')
						]),
					_List_Nil)
				]))
		]));
var $icidasset$elm_material_icons$Material$Icons$Outlined$arrow_circle_right = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$b('new 0 0 24 24'),
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$rect,
					_List_fromArray(
						[
							$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
						]),
					_List_Nil)
				])),
			A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Internal$p,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M22,12c0-5.52-4.48-10-10-10C6.48,2,2,6.48,2,12s4.48,10,10,10C17.52,22,22,17.52,22,12z M4,12c0-4.42,3.58-8,8-8 c4.42,0,8,3.58,8,8s-3.58,8-8,8C7.58,20,4,16.42,4,12z M16,12l-4,4l-1.41-1.41L12.17,13H8v-2h4.17l-1.59-1.59L12,8L16,12z')
						]),
					_List_Nil)
				]))
		]));
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Page$Home$viewSlide = F2(
	function (sharedstate, model) {
		var imgsArray = $elm$core$Array$fromList(model.sliderImgs);
		var getImage = A2($elm$core$Array$get, model.sliderPosition, imgsArray);
		var imgV = function () {
			if (getImage.$ === 'Just') {
				var image = getImage.a;
				return image;
			} else {
				return {sub: '', title: '', url: ''};
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-row justify-around  items-center px-8 gap-x-2  mt-8 md:hidden w-full'),
					$tesk9$accessible_html$Accessibility$Aria$label('carousel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Page$Home$NextSlide),
							$elm$html$Html$Attributes$class('text-kompas-400 dark:text-slate-950'),
							$elm$html$Html$Attributes$alt('next slide'),
							$elm$html$Html$Attributes$title('next slide'),
							$tesk9$accessible_html$Accessibility$Aria$label('Next slide')
						]),
					_List_fromArray(
						[
							A2($icidasset$elm_material_icons$Material$Icons$Outlined$arrow_circle_left, 30, $icidasset$elm_material_icons$Material$Icons$Types$Inherit)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col w-80 justify-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, imgV.url)),
									$elm$html$Html$Attributes$class('dark:grayscale grow'),
									$elm$html$Html$Attributes$alt('graphic representing a user of Kompas using it')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(' dark:text-slate-950 text-kompas-300 font-bold text-xl mt-4 text-center md:text-start')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, imgV.title))
								])),
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-2 text-center md:text-start')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, imgV.sub))
								]))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Page$Home$PrevSlide),
							$elm$html$Html$Attributes$class('text-kompas-400 dark:text-slate-950'),
							$elm$html$Html$Attributes$alt('previous slide'),
							$elm$html$Html$Attributes$title('next slide'),
							$tesk9$accessible_html$Accessibility$Aria$label('Next slide')
						]),
					_List_fromArray(
						[
							A2($icidasset$elm_material_icons$Material$Icons$Outlined$arrow_circle_right, 30, $icidasset$elm_material_icons$Material$Icons$Types$Inherit)
						]))
				]));
	});
var $author$project$Page$Home$view = F2(
	function (sharedState, model) {
		var top = 'basis-3/4 text-center  w-64 ';
		var title = ' font-normal sm:font-extrabold text-kompas-300 sm:text-2xl text-lg dark:text-slate-950 md:min-h-14';
		var sub = 'text-sm mt-1';
		var showSearchBar = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(' bg-kompas-300 dark:bg-slate-400 ml-2  h-full  w-24 border-md flex flex-row justify-center items-center cursor-pointer '),
					$tesk9$accessible_html$Accessibility$Role$button,
					$elm$html$Html$Events$onClick($author$project$Page$Home$SubmitData),
					$elm$html$Html$Attributes$alt('submit-button'),
					$elm$html$Html$Attributes$name('submit your form '),
					$tesk9$accessible_html$Accessibility$Aria$label('submit'),
					$elm$html$Html$Attributes$tabindex(0)
				]),
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Outlined$search,
					37,
					$icidasset$elm_material_icons$Material$Icons$Types$Color(
						A3($avh4$elm_color$Color$rgb255, 255, 255, 255)))
				]));
		var isHidden = function () {
			var _v1 = $elm$core$String$isEmpty(model.query.query);
			if (_v1) {
				return 'invisible';
			} else {
				return 'visible';
			}
		}();
		var showReset = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(isHidden),
					$elm$html$Html$Events$onClick($author$project$Page$Home$ResetQuery),
					$elm$html$Html$Attributes$alt('reset-button'),
					$elm$html$Html$Attributes$tabindex(0),
					$elm$html$Html$Attributes$name('reset query')
				]),
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Outlined$cancel,
					25,
					$icidasset$elm_material_icons$Material$Icons$Types$Color(
						A3($avh4$elm_color$Color$rgb255, 45, 55, 72)))
				]));
		var isError = function () {
			var _v0 = $elm$core$String$isEmpty(model.error);
			if (_v0) {
				return 'invisible';
			} else {
				return ' text-center font-bold text-kompas-300 dark:text-slate-700 text-sm mt-2 visible';
			}
		}();
		var image = 'border-solid border-2 border-red-300';
		var comp = 'basis-1/2';
		var border = 'border-solid border-2 border-red-300';
		var below = 'flex flex-col  basis-1/4  ';
		var around = 'flex flex-col justify-normal   ';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-white  w-full  flex flex-row justify-center')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(' w-full flex flex-col  gap-1.5  h-full ')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center basis-1/4 ')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('gradient-text dark:bg-none mx-12 sm:mx-0  p-2  dark:text-slate-950   text-4xl sm:text-6xl font-extrabold md:mb-4 align-middle'),
											$tesk9$accessible_html$Accessibility$Aria$label('Home message')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'home.message'))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex justify-center pt-4')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('md:w-148 w-100 px-8')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$form,
													_List_fromArray(
														[
															$elm$html$Html$Events$onSubmit($author$project$Page$Home$SubmitData),
															$elm$html$Html$Attributes$class('bg-white rounded-3xl h-10'),
															$tesk9$accessible_html$Accessibility$Landmark$form
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('md:block rounded-3xl overflow-hidden dark:bg-none dark:border-solid dark:border dark:border-slate-600   border-solid border border-kompas-300 h-full box-shadow-lg')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class(' flex flex-row h-full items-center bg-transparent')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$label,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$for('search-home'),
																					$tesk9$accessible_html$Accessibility$Aria$label('search on kompas')
																				]),
																			_List_Nil),
																			A2(
																			$elm$html$Html$input,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$type_('text'),
																					$elm$html$Html$Attributes$id('search-home'),
																					$elm$html$Html$Attributes$name('search'),
																					$elm$html$Html$Attributes$class('w-full h-12 px-12 outline-none rounded-md text-slate-700 focus:bg-white active:bg-white hover:bg-white'),
																					$elm$html$Html$Attributes$value(model.query.query),
																					$elm$html$Html$Attributes$placeholder(
																					A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'search.searchData')),
																					$elm$html$Html$Events$onInput($author$project$Page$Home$UpdateQ),
																					$elm$html$Html$Attributes$autofocus(true),
																					$elm$html$Html$Attributes$tabindex(0),
																					$tesk9$accessible_html$Accessibility$Aria$required(true),
																					$tesk9$accessible_html$Accessibility$Role$textBox
																				]),
																			_List_Nil),
																			showReset,
																			showSearchBar
																		]))
																])),
															A2(
															$elm$html$Html$h2,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(isError)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'errors.search'))
																])),
															A2($elm$html$Html$br, _List_Nil, _List_Nil)
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-col justify-center text-xs mt-4  dark:text-primarytext text-kompas-400 ')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('mx-12 md:mx-0 items-center')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('font-bold pb-2 ')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'home.topics.title'))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'home.topics.all'))
														]))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hidden md:block  md:mt-12 md:px-12')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-row justify-around ')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('w-64 ')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src(
															A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'home.prompts.prompt1.img')),
															$elm$html$Html$Attributes$class(' dark:grayscale w-full'),
															$elm$html$Html$Attributes$alt('img_1')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h1,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(title)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'home.prompts.prompt1.title'))
																])),
															A2(
															$elm$html$Html$h2,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(sub)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'home.prompts.prompt1.sub'))
																]))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('w-64')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src('/assets/img_1.svg'),
															$elm$html$Html$Attributes$class('dark:grayscale w-full'),
															$elm$html$Html$Attributes$alt('img_2')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h2,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(title)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'home.prompts.prompt2.title'))
																])),
															A2(
															$elm$html$Html$h2,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(sub)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'home.prompts.prompt2.sub'))
																]))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('w-64')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src('/assets/img_2.svg'),
															$elm$html$Html$Attributes$class('dark:grayscale w-full'),
															$elm$html$Html$Attributes$alt('img_3')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$h2,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(title)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'home.prompts.prompt3.title'))
																])),
															A2(
															$elm$html$Html$h2,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class(sub)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'home.prompts.prompt3.sub'))
																]))
														]))
												]))
										]))
								])),
							A2($author$project$Page$Home$viewSlide, sharedState, model)
						]))
				]));
	});
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Page$Privacy$view = function (sharedstate) {
	var layout = 'bg-white  dark:bg-slate-50 text-primarytext text-sm';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(layout)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(' relative basis-full dark:bg-white bg-kompas-300 p-2 dark:border-solid dark:border-2 dark:border-slate-200 ')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(' text-xs md:text-sm h-10 md:h-10 flex  flex-col md:flex-row gap-x-2 justify-center items-center ')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(' flex flex-row gap-x-2 dark:grayscale  items-center text-white dark:text-primarytext ')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src('/assets/message.svg'),
														$elm$html$Html$Attributes$alt('editing-icon')
													]),
												_List_Nil),
												$elm$html$Html$text(
												A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'survey.help'))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold underline ')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href(
														A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'survey.link')),
														$elm$html$Html$Attributes$target('_blank'),
														$elm$html$Html$Attributes$class('text-kyellow dark:text-primarytext')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'survey.submit'))
													]))
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(' pt-8 ')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-kompas-300 font-bold text-center text-2xl px-20 md:px-40 dark:text-slate-700')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.title'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('md:px-40 sm:px-20 p-8 mt-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('flex flex-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.updated'))
											])),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(': Jul 24, 2023')
											]))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.intro.p1'))
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.intro.p2'))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-8')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.info.title'))
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-4 pl-4 list-disc')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-bold inline-block mr-4')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.info.p1.title'))
																	])),
																$elm$html$Html$text(
																A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.info.p1.content'))
															]))
													])),
												A2(
												$elm$html$Html$li,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mt-2')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-bold inline-block mr-4')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.info.p2.title'))
																	])),
																$elm$html$Html$text(
																A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.info.p2.content'))
															]))
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-8')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.howinfo.title'))
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-4 pl-4 list-disc')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-bold inline-block mr-4')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.howinfo.p1.title'))
																	])),
																$elm$html$Html$text(
																A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.howinfo.p1.content'))
															]))
													])),
												A2(
												$elm$html$Html$li,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mt-2')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-bold inline-block mr-4')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.howinfo.p2.title'))
																	])),
																$elm$html$Html$text(
																A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.howinfo.p2.content'))
															]))
													])),
												A2(
												$elm$html$Html$li,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mt-2')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-bold inline-block mr-4')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.howinfo.p3.title'))
																	])),
																$elm$html$Html$text(
																A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.howinfo.p3.content'))
															]))
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-8')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.security.title'))
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-4 pl-4 list-disc')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-bold inline-block mr-4')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.security.p1.title'))
																	])),
																$elm$html$Html$text(
																A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.security.p1.content'))
															]))
													])),
												A2(
												$elm$html$Html$li,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mt-2')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-bold inline-block mr-4')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.security.p2.title'))
																	])),
																$elm$html$Html$text(
																A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.security.p2.content'))
															]))
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-8')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.sharing.title'))
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-4 pl-4 list-disc')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-bold inline-block mr-4')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.sharing.p1.title'))
																	])),
																$elm$html$Html$text(
																A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.sharing.p1.content'))
															]))
													])),
												A2(
												$elm$html$Html$li,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mt-2')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-bold inline-block mr-4')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.sharing.p2.title'))
																	])),
																$elm$html$Html$text(
																A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.sharing.p2.content'))
															]))
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-8')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.choices.title'))
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-4 pl-4 list-disc')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-bold inline-block mr-4')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.choices.p1.title'))
																	])),
																$elm$html$Html$text(
																A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.choices.p1.content'))
															]))
													])),
												A2(
												$elm$html$Html$li,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('mt-2')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-bold inline-block mr-4')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.choices.p2.title'))
																	])),
																$elm$html$Html$text(
																A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.choices.p2.content'))
															]))
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-8')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.children.title'))
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-4 pl-4 list-disc')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-bold inline-block mr-4')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.children.p1.title'))
																	])),
																$elm$html$Html$text(
																A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.children.p1.content'))
															]))
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-8')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.changes.title'))
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-4 pl-4 list-disc')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-bold inline-block mr-4')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.changes.p1.title'))
																	])),
																$elm$html$Html$text(
																A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.changes.p1.content'))
															]))
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-8')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.contact.title'))
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-4 pl-4 list-disc')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('font-bold inline-block mr-4')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.contact.p1.title'))
																	])),
																$elm$html$Html$text(
																A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'privacy.contact.p1.content'))
															]))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Page$Report$view = function (sharedstate) {
	var layout = 'bg-white  dark:bg-slate-50 mb-8';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(layout)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(' relative basis-full dark:bg-white bg-kompas-300 p-2 dark:border-solid dark:border-2 dark:border-slate-200 ')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(' text-xs md:text-sm h-10 md:h-10 flex  flex-col md:flex-row gap-x-2 justify-center items-center ')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(' flex flex-row gap-x-2 dark:grayscale  items-center text-white dark:text-primarytext ')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src('/assets/message.svg'),
														$elm$html$Html$Attributes$alt('editing-icon')
													]),
												_List_Nil),
												$elm$html$Html$text(
												A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'survey.help'))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('font-bold underline ')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href(
														A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'survey.link')),
														$elm$html$Html$Attributes$target('_blank'),
														$elm$html$Html$Attributes$class('text-kyellow dark:text-primarytext')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'survey.submit'))
													]))
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(' pt-8 text-primarytext text-sm ')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-kompas-300 font-bold text-center  text-2xl uppercase dark:text-slate-700')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'report.title'))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(' p-3 ms:px-20 md:px-40 mt-4')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-2')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'report.p1'))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mt-8')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'report.p2.content'))
											])),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-4 pl-4 list-disc')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class(' inline-block mr-2')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'report.p2.li1'))
																	]))
															])),
														A2(
														$elm$html$Html$li,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('mt-2')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class(' inline-block mr-2')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'report.p2.li2'))
																			]))
																	]))
															])),
														A2(
														$elm$html$Html$li,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('mt-2')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$span,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class(' inline-block mr-2')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'report.p2.li3'))
																			]))
																	]))
															]))
													]))
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mt-2')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'report.p3'))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Page$Search$CloseSurvey = {$: 'CloseSurvey'};
var $author$project$Page$Search$CommonSearch = function (a) {
	return {$: 'CommonSearch', a: a};
};
var $author$project$Page$Search$FilterTopics = F2(
	function (a, b) {
		return {$: 'FilterTopics', a: a, b: b};
	});
var $author$project$Page$Search$ResetFilters = function (a) {
	return {$: 'ResetFilters', a: a};
};
var $author$project$Page$Search$ShowFilters = function (a) {
	return {$: 'ShowFilters', a: a};
};
var $author$project$Page$Search$ViewDropdown = function (a) {
	return {$: 'ViewDropdown', a: a};
};
var $author$project$Page$Search$ViewSubTopic = function (a) {
	return {$: 'ViewSubTopic', a: a};
};
var $rtfeldman$elm_sorter_experiment$Sort$Sorter = function (a) {
	return {$: 'Sorter', a: a};
};
var $rtfeldman$elm_sorter_experiment$Sort$alphabetical = $rtfeldman$elm_sorter_experiment$Sort$Sorter($elm$core$Basics$compare);
var $rtfeldman$elm_sorter_experiment$Sort$by = F2(
	function (transform, _v0) {
		var sort = _v0.a;
		return $rtfeldman$elm_sorter_experiment$Sort$Sorter(
			F2(
				function (first, second) {
					return A2(
						sort,
						transform(first),
						transform(second));
				}));
	});
var $tesk9$accessible_html$Accessibility$Role$checkBox = $tesk9$accessible_html$Accessibility$Utils$role('checkbox');
var $icidasset$elm_material_icons$Material$Icons$Outlined$close = A2(
	$icidasset$elm_material_icons$Material$Icons$Internal$icon,
	_List_fromArray(
		[
			$icidasset$elm_material_icons$Material$Icons$Internal$v('0 0 24 24')
		]),
	_List_fromArray(
		[
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M0 0h24v24H0V0z'),
					$icidasset$elm_material_icons$Material$Icons$Internal$f('none')
				]),
			_List_Nil),
			A2(
			$icidasset$elm_material_icons$Material$Icons$Internal$p,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z')
				]),
			_List_Nil)
		]));
var $author$project$Page$Search$getDictList = function (dict) {
	if (dict.$ === 'Just') {
		var list = dict.a;
		return list;
	} else {
		return _List_Nil;
	}
};
var $tesk9$accessible_html$Accessibility$Aria$labelledBy = $elm$html$Html$Attributes$attribute('aria-labelledby');
var $tesk9$accessible_html$Accessibility$Role$link = $tesk9$accessible_html$Accessibility$Utils$role('link');
var $elm$core$List$sortWith = _List_sortWith;
var $rtfeldman$elm_sorter_experiment$Sort$list = F2(
	function (_v0, elems) {
		var sort = _v0.a;
		return A2($elm$core$List$sortWith, sort, elems);
	});
var $tesk9$accessible_html$Accessibility$Role$listBox = $tesk9$accessible_html$Accessibility$Utils$role('listbox');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $tesk9$accessible_html$Accessibility$Role$presentation = $tesk9$accessible_html$Accessibility$Utils$role('presentation');
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Page$Search$buildError = function (httpError) {
	switch (httpError.$) {
		case 'BadUrl':
			var message = httpError.a;
			return message;
		case 'Timeout':
			return 'Server is taking too long to respond. Please try again later.';
		case 'NetworkError':
			return 'Unable to reach server.';
		case 'BadStatus':
			var statusCode = httpError.a;
			return 'Request failed with status code: ' + $elm$core$String$fromInt(statusCode);
		default:
			var message = httpError.a;
			return message;
	}
};
var $tesk9$accessible_html$Accessibility$Live$busy = A2(
	$elm$core$Basics$composeL,
	$tesk9$accessible_html$Accessibility$Utils$aria('busy'),
	$tesk9$accessible_html$Accessibility$Utils$toBoolString);
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$svg$Svg$animate = $elm$svg$Svg$trustedNode('animate');
var $elm$svg$Svg$Attributes$attributeName = _VirtualDom_attribute('attributeName');
var $elm$svg$Svg$Attributes$begin = _VirtualDom_attribute('begin');
var $elm$svg$Svg$Attributes$calcMode = _VirtualDom_attribute('calcMode');
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$dur = _VirtualDom_attribute('dur');
var $elm$svg$Svg$Attributes$fillOpacity = _VirtualDom_attribute('fill-opacity');
var $elm$svg$Svg$Attributes$from = function (value) {
	return A2(
		_VirtualDom_attribute,
		'from',
		_VirtualDom_noJavaScriptUri(value));
};
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$Attributes$repeatCount = _VirtualDom_attribute('repeatCount');
var $elm$svg$Svg$Attributes$to = function (value) {
	return A2(
		_VirtualDom_attribute,
		'to',
		_VirtualDom_noJavaScriptUri(value));
};
var $elm$svg$Svg$Attributes$values = function (value) {
	return A2(
		_VirtualDom_attribute,
		'values',
		_VirtualDom_noJavaScriptUri(value));
};
var $jouderianjr$elm_loaders$Internal$ThreeDots$view = F2(
	function (widthVal, color) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width(
					$elm$core$String$fromFloat(widthVal)),
					$elm$svg$Svg$Attributes$viewBox('0 0 120 30'),
					$elm$svg$Svg$Attributes$fill(color)
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('15'),
							$elm$svg$Svg$Attributes$cy('15'),
							$elm$svg$Svg$Attributes$r('15')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$animate,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$attributeName('r'),
									$elm$svg$Svg$Attributes$from('15'),
									$elm$svg$Svg$Attributes$to('15'),
									$elm$svg$Svg$Attributes$begin('0s'),
									$elm$svg$Svg$Attributes$dur('0.8s'),
									$elm$svg$Svg$Attributes$values('15;9;15'),
									$elm$svg$Svg$Attributes$calcMode('linear'),
									$elm$svg$Svg$Attributes$repeatCount('indefinite')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$animate,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$attributeName('fill-opacity'),
									$elm$svg$Svg$Attributes$from('1'),
									$elm$svg$Svg$Attributes$to('1'),
									$elm$svg$Svg$Attributes$begin('0s'),
									$elm$svg$Svg$Attributes$dur('0.8s'),
									$elm$svg$Svg$Attributes$values('1;.5;1'),
									$elm$svg$Svg$Attributes$calcMode('linear'),
									$elm$svg$Svg$Attributes$repeatCount('indefinite')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('60'),
							$elm$svg$Svg$Attributes$cy('15'),
							$elm$svg$Svg$Attributes$r('9'),
							$elm$svg$Svg$Attributes$fillOpacity('0.3')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$animate,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$attributeName('r'),
									$elm$svg$Svg$Attributes$from('9'),
									$elm$svg$Svg$Attributes$to('9'),
									$elm$svg$Svg$Attributes$begin('0s'),
									$elm$svg$Svg$Attributes$dur('0.8s'),
									$elm$svg$Svg$Attributes$values('9;15;9'),
									$elm$svg$Svg$Attributes$calcMode('linear'),
									$elm$svg$Svg$Attributes$repeatCount('indefinite')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$animate,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$attributeName('fill-opacity'),
									$elm$svg$Svg$Attributes$from('0.5'),
									$elm$svg$Svg$Attributes$to('0.5'),
									$elm$svg$Svg$Attributes$begin('0s'),
									$elm$svg$Svg$Attributes$dur('0.8s'),
									$elm$svg$Svg$Attributes$values('.5;1;.5'),
									$elm$svg$Svg$Attributes$calcMode('linear'),
									$elm$svg$Svg$Attributes$repeatCount('indefinite')
								]),
							_List_Nil)
						])),
					A2(
					$elm$svg$Svg$circle,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$cx('105'),
							$elm$svg$Svg$Attributes$cy('15'),
							$elm$svg$Svg$Attributes$r('15')
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$animate,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$attributeName('r'),
									$elm$svg$Svg$Attributes$from('15'),
									$elm$svg$Svg$Attributes$to('15'),
									$elm$svg$Svg$Attributes$begin('0s'),
									$elm$svg$Svg$Attributes$dur('0.8s'),
									$elm$svg$Svg$Attributes$values('15;9;15'),
									$elm$svg$Svg$Attributes$calcMode('linear'),
									$elm$svg$Svg$Attributes$repeatCount('indefinite')
								]),
							_List_Nil),
							A2(
							$elm$svg$Svg$animate,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$attributeName('fill-opacity'),
									$elm$svg$Svg$Attributes$from('1'),
									$elm$svg$Svg$Attributes$to('1'),
									$elm$svg$Svg$Attributes$begin('0s'),
									$elm$svg$Svg$Attributes$dur('0.8s'),
									$elm$svg$Svg$Attributes$values('1;.5;1'),
									$elm$svg$Svg$Attributes$calcMode('linear'),
									$elm$svg$Svg$Attributes$repeatCount('indefinite')
								]),
							_List_Nil)
						]))
				]));
	});
var $jouderianjr$elm_loaders$Loaders$threeDots = $jouderianjr$elm_loaders$Internal$ThreeDots$view;
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $tesk9$accessible_html$Accessibility$Live$polite = A2($tesk9$accessible_html$Accessibility$Utils$aria, 'live', 'polite');
var $elm$core$Elm$JsArray$appendN = _JsArray_appendN;
var $elm$core$Elm$JsArray$slice = _JsArray_slice;
var $elm$core$Array$appendHelpBuilder = F2(
	function (tail, builder) {
		var tailLen = $elm$core$Elm$JsArray$length(tail);
		var notAppended = ($elm$core$Array$branchFactor - $elm$core$Elm$JsArray$length(builder.tail)) - tailLen;
		var appended = A3($elm$core$Elm$JsArray$appendN, $elm$core$Array$branchFactor, builder.tail, tail);
		return (notAppended < 0) ? {
			nodeList: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.nodeList),
			nodeListSize: builder.nodeListSize + 1,
			tail: A3($elm$core$Elm$JsArray$slice, notAppended, tailLen, tail)
		} : ((!notAppended) ? {
			nodeList: A2(
				$elm$core$List$cons,
				$elm$core$Array$Leaf(appended),
				builder.nodeList),
			nodeListSize: builder.nodeListSize + 1,
			tail: $elm$core$Elm$JsArray$empty
		} : {nodeList: builder.nodeList, nodeListSize: builder.nodeListSize, tail: appended});
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$Array$sliceLeft = F2(
	function (from, array) {
		var len = array.a;
		var tree = array.c;
		var tail = array.d;
		if (!from) {
			return array;
		} else {
			if (_Utils_cmp(
				from,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					len - from,
					$elm$core$Array$shiftStep,
					$elm$core$Elm$JsArray$empty,
					A3(
						$elm$core$Elm$JsArray$slice,
						from - $elm$core$Array$tailIndex(len),
						$elm$core$Elm$JsArray$length(tail),
						tail));
			} else {
				var skipNodes = (from / $elm$core$Array$branchFactor) | 0;
				var helper = F2(
					function (node, acc) {
						if (node.$ === 'SubTree') {
							var subTree = node.a;
							return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
						} else {
							var leaf = node.a;
							return A2($elm$core$List$cons, leaf, acc);
						}
					});
				var leafNodes = A3(
					$elm$core$Elm$JsArray$foldr,
					helper,
					_List_fromArray(
						[tail]),
					tree);
				var nodesToInsert = A2($elm$core$List$drop, skipNodes, leafNodes);
				if (!nodesToInsert.b) {
					return $elm$core$Array$empty;
				} else {
					var head = nodesToInsert.a;
					var rest = nodesToInsert.b;
					var firstSlice = from - (skipNodes * $elm$core$Array$branchFactor);
					var initialBuilder = {
						nodeList: _List_Nil,
						nodeListSize: 0,
						tail: A3(
							$elm$core$Elm$JsArray$slice,
							firstSlice,
							$elm$core$Elm$JsArray$length(head),
							head)
					};
					return A2(
						$elm$core$Array$builderToArray,
						true,
						A3($elm$core$List$foldl, $elm$core$Array$appendHelpBuilder, initialBuilder, rest));
				}
			}
		}
	});
var $elm$core$Array$fetchNewTail = F4(
	function (shift, end, treeEnd, tree) {
		fetchNewTail:
		while (true) {
			var pos = $elm$core$Array$bitMask & (treeEnd >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (_v0.$ === 'SubTree') {
				var sub = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$end = end,
					$temp$treeEnd = treeEnd,
					$temp$tree = sub;
				shift = $temp$shift;
				end = $temp$end;
				treeEnd = $temp$treeEnd;
				tree = $temp$tree;
				continue fetchNewTail;
			} else {
				var values = _v0.a;
				return A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, values);
			}
		}
	});
var $elm$core$Array$hoistTree = F3(
	function (oldShift, newShift, tree) {
		hoistTree:
		while (true) {
			if ((_Utils_cmp(oldShift, newShift) < 1) || (!$elm$core$Elm$JsArray$length(tree))) {
				return tree;
			} else {
				var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, 0, tree);
				if (_v0.$ === 'SubTree') {
					var sub = _v0.a;
					var $temp$oldShift = oldShift - $elm$core$Array$shiftStep,
						$temp$newShift = newShift,
						$temp$tree = sub;
					oldShift = $temp$oldShift;
					newShift = $temp$newShift;
					tree = $temp$tree;
					continue hoistTree;
				} else {
					return tree;
				}
			}
		}
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$sliceTree = F3(
	function (shift, endIdx, tree) {
		var lastPos = $elm$core$Array$bitMask & (endIdx >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, lastPos, tree);
		if (_v0.$ === 'SubTree') {
			var sub = _v0.a;
			var newSub = A3($elm$core$Array$sliceTree, shift - $elm$core$Array$shiftStep, endIdx, sub);
			return (!$elm$core$Elm$JsArray$length(newSub)) ? A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree) : A3(
				$elm$core$Elm$JsArray$unsafeSet,
				lastPos,
				$elm$core$Array$SubTree(newSub),
				A3($elm$core$Elm$JsArray$slice, 0, lastPos + 1, tree));
		} else {
			return A3($elm$core$Elm$JsArray$slice, 0, lastPos, tree);
		}
	});
var $elm$core$Array$sliceRight = F2(
	function (end, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		if (_Utils_eq(end, len)) {
			return array;
		} else {
			if (_Utils_cmp(
				end,
				$elm$core$Array$tailIndex(len)) > -1) {
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					startShift,
					tree,
					A3($elm$core$Elm$JsArray$slice, 0, $elm$core$Array$bitMask & end, tail));
			} else {
				var endIdx = $elm$core$Array$tailIndex(end);
				var depth = $elm$core$Basics$floor(
					A2(
						$elm$core$Basics$logBase,
						$elm$core$Array$branchFactor,
						A2($elm$core$Basics$max, 1, endIdx - 1)));
				var newShift = A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep);
				return A4(
					$elm$core$Array$Array_elm_builtin,
					end,
					newShift,
					A3(
						$elm$core$Array$hoistTree,
						startShift,
						newShift,
						A3($elm$core$Array$sliceTree, startShift, endIdx, tree)),
					A4($elm$core$Array$fetchNewTail, startShift, end, endIdx, tree));
			}
		}
	});
var $elm$core$Array$translateIndex = F2(
	function (index, _v0) {
		var len = _v0.a;
		var posIndex = (index < 0) ? (len + index) : index;
		return (posIndex < 0) ? 0 : ((_Utils_cmp(posIndex, len) > 0) ? len : posIndex);
	});
var $elm$core$Array$slice = F3(
	function (from, to, array) {
		var correctTo = A2($elm$core$Array$translateIndex, to, array);
		var correctFrom = A2($elm$core$Array$translateIndex, from, array);
		return (_Utils_cmp(correctFrom, correctTo) > 0) ? $elm$core$Array$empty : A2(
			$elm$core$Array$sliceLeft,
			correctFrom,
			A2($elm$core$Array$sliceRight, correctTo, array));
	});
var $tesk9$accessible_html$Accessibility$Role$article = $tesk9$accessible_html$Accessibility$Utils$role('article');
var $elm$html$Html$article = _VirtualDom_node('article');
var $author$project$Page$Search$getString = function (val) {
	if (val.$ === 'Just') {
		var v = val.a;
		return v;
	} else {
		return '';
	}
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Page$Search$rating = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class(' hidden flex flex-row  justify-end gap-x-4')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('/assets/like.svg'),
					$elm$html$Html$Attributes$class('dark:grayscale')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('/assets/dislike.svg'),
					$elm$html$Html$Attributes$class('dark:grayscale')
				]),
			_List_Nil)
		]));
var $elm$core$String$reverse = _String_reverse;
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Page$Search$viewLocation = F2(
	function (model, country) {
		var value = A2($elm$core$Dict$get, country, model.locationTr);
		var cty = function () {
			if (value.$ === 'Just') {
				var val = value.a;
				return val;
			} else {
				return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(cty)
				]));
	});
var $author$project$Page$Search$viewTag = function (tag) {
	var isTag = $elm$core$String$isEmpty(tag);
	var visibleOr = function () {
		if (isTag) {
			return 'invisibe';
		} else {
			return 'bg-slate-100  p-2 text-xs text-slate-700 dark:shadow-lg rounded-md mr-2';
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(visibleOr)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(tag)
			]));
};
var $author$project$Page$Search$viewWebpage = function (page) {
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href(page),
				$elm$html$Html$Attributes$rel('external noopener noreferrer'),
				$elm$html$Html$Attributes$target('_blank'),
				$elm$html$Html$Attributes$class('dark:text-slate-950'),
				$elm$html$Html$Attributes$tabindex(0),
				$tesk9$accessible_html$Accessibility$Role$link,
				$elm$html$Html$Attributes$class('dont-break-out')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(page)
			]));
};
var $author$project$Page$Search$viewDoc = F3(
	function (sharedstate, model, doc) {
		var urlL = A3($elm$core$String$slice, 0, 100, doc.meta.url);
		var url = A2($elm$core$String$split, '/', doc.meta.url);
		var returnStr = function (val) {
			if (val.$ === 'Just') {
				var v = val.a;
				return v;
			} else {
				return '';
			}
		};
		var purpose = $elm$core$List$head(doc.meta.purpose);
		var purposeStr = function () {
			if (purpose.$ === 'Just') {
				var p = purpose.a;
				return p;
			} else {
				return '';
			}
		}();
		var metaMain = doc.meta.tags_main_country;
		var loct = A2(
			$elm$core$List$map,
			function (x) {
				return A2($elm$core$Dict$get, x, model.locationTr);
			},
			doc.meta.tags_main_country);
		var locationsN = $elm$core$List$head(doc.meta.tags_countries);
		var locationNone = function () {
			if (locationsN.$ === 'Just') {
				var locti = locationsN.a;
				return _List_fromArray(
					[locti]);
			} else {
				return _List_Nil;
			}
		}();
		var loc = $elm$core$List$head(doc.meta.tags_main_country);
		var mainC = function () {
			if (loc.$ === 'Just') {
				var cty = loc.a;
				return cty;
			} else {
				return '';
			}
		}();
		var mainCFinal = A2($elm$core$Dict$get, mainC, model.locationTr);
		var mainFinal = function () {
			if (mainCFinal.$ === 'Just') {
				var main = mainCFinal.a;
				return main;
			} else {
				return '';
			}
		}();
		var lines = A2($elm$core$String$split, '.', doc.content);
		var linees = A3($elm$core$String$slice, 0, 400, doc.content);
		var lessLines = A2($elm$core$List$take, 1, lines);
		var howMany = ($elm$core$List$length(doc.meta.tags_main_country) > 1) ? 'Multiple Location:' : 'Location: ';
		var finalTest = A2($elm$core$String$join, '.', lessLines);
		var finalLocations = (_Utils_eq(model.search.filters.tags_main_country, $elm$core$Maybe$Nothing) || _Utils_eq(
			model.search.filters.tags_main_country,
			$elm$core$Maybe$Just(
				{val: _List_Nil}))) ? locationNone : A2(
			$elm$core$List$map,
			function (x) {
				return returnStr(x);
			},
			loct);
		var finalLine = linees + '...';
		var date = $elm$core$Array$fromList(
			A2($elm$core$String$split, 'T', doc.meta.published_date));
		var getDate = A2($elm$core$Array$get, 0, date);
		var returnDate = function () {
			if (getDate.$ === 'Just') {
				var dt = getDate.a;
				return dt;
			} else {
				return '';
			}
		}();
		var returnDateSp = A2($elm$core$String$split, '-', returnDate);
		var reversereturn = $elm$core$List$reverse(returnDateSp);
		var finalDate = A2($elm$core$String$join, '.', reversereturn);
		var testrverse = $elm$core$String$reverse(returnDate);
		var countryF = model.search.filters.tags_main_country;
		var countrtFstr = function () {
			if (countryF.$ === 'Just') {
				var ct = countryF.a;
				return ct;
			} else {
				return {
					val: _List_fromArray(
						[''])
				};
			}
		}();
		var getVal = $elm$core$List$head(countrtFstr.val);
		var getCstr = function () {
			if (getVal.$ === 'Just') {
				var cty = getVal.a;
				return cty;
			} else {
				return '';
			}
		}();
		var getModelC = A2($elm$core$Dict$get, getCstr, model.locationTr);
		var getFinalC = function () {
			if (getModelC.$ === 'Just') {
				var cty = getModelC.a;
				return cty;
			} else {
				return '';
			}
		}();
		var moreCMain = ($elm$core$List$length(metaMain) > 0) ? A2(
			$elm$core$List$filter,
			function (x) {
				return _Utils_eq(x, getCstr);
			},
			metaMain) : _List_fromArray(
			['']);
		var moreC = $elm$core$List$head(moreCMain);
		var getMoreC = function () {
			if (moreC.$ === 'Just') {
				var cty = moreC.a;
				return cty;
			} else {
				return '';
			}
		}();
		var getDictC = A2($elm$core$Dict$get, getMoreC, model.locationTr);
		var getFilterC = function () {
			if (getDictC.$ === 'Just') {
				var cty = getDictC.a;
				return cty;
			} else {
				return '';
			}
		}();
		var content = doc.content;
		var arrUrl = $elm$core$Array$fromList(url);
		var http = A3($elm$core$Array$slice, 0, 3, arrUrl);
		var httpList = $elm$core$Array$toList(http);
		var httpUrl = A2($elm$core$String$join, '/', httpList);
		return (doc.meta.resource_type !== 'org_details') ? A2(
			$elm$html$Html$article,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dark: text-slate-800 mx-12 md:ml-0 md:w-3/4 mb-12 '),
					$tesk9$accessible_html$Accessibility$Role$article
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row gap-x-4 items-center ')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-sm font-bold')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(httpUrl),
											$elm$html$Html$Attributes$target('_blank'),
											$elm$html$Html$Attributes$rel('external noopener noreferrer'),
											$elm$html$Html$Attributes$tabindex(0),
											$tesk9$accessible_html$Accessibility$Role$link
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(doc.meta.publisher)
										]))
								])),
							(finalDate !== '') ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xs text-slate-600')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									_Utils_ap(
										A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.published'),
										finalDate))
								])) : A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						])),
					(mainC !== '') ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row items-center text-xs gap-x-2 mt-0.5 ')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.loc'))
								])),
							(howMany !== 'Multiple Location:') ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-row gap-x-2  text-xs')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(mainFinal)
								])) : A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(getFilterC),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('italic text-slate-400')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('')
										]))
								]))
						])) : A2($elm$html$Html$span, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(' text-ktitle font-bold dark:font-bold dark:text-slate-700 text-lg hover:text-kompas-400 mt-0.5')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(doc.meta.url),
									$elm$html$Html$Attributes$target('_blank'),
									$tesk9$accessible_html$Accessibility$Role$link
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(doc.meta.title)
								]))
						])),
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(' text-kgreen  dark:font-bold dark:text-slate-700 text-sm flex  flex-row flex-wrap ')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(doc.meta.url),
									$elm$html$Html$Attributes$class('block dont-break-out'),
									$elm$html$Html$Attributes$rel('external noopener noreferrer'),
									$elm$html$Html$Attributes$target('_blank'),
									$elm$html$Html$Attributes$tabindex(0),
									$tesk9$accessible_html$Accessibility$Role$link,
									$tesk9$accessible_html$Accessibility$Aria$roleDescription('link to the record')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(urlL)
								]))
						])),
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(' text-primarytext   dark:font-bold dark:text-slate-700 text-sm italic font-bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(doc.meta.subtitle)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-4 text-primarytext text-sm')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(finalLine)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row flex-wrap justify-between mb-2 mt-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-row')
								]),
							A2($elm$core$List$map, $author$project$Page$Search$viewTag, doc.meta.tags_topics)),
							$author$project$Page$Search$rating
						])),
					(doc.meta.internal_id !== '') ? A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(' text-klicense dark:text-slate-600 text-xs')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('License - ' + doc.meta.internal_id)
						])) : A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]))
				])) : A2(
			$elm$html$Html$article,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dark: text-slate-800 mx-12 md:ml-0 md:w-3/4 mb-12 '),
					$tesk9$accessible_html$Accessibility$Role$article
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row gap-x-4 items-center ')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-sm font-bold')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(httpUrl),
											$elm$html$Html$Attributes$rel('external noopener noreferrer'),
											$elm$html$Html$Attributes$target('_blank'),
											$tesk9$accessible_html$Accessibility$Role$link,
											$elm$html$Html$Attributes$tabindex(0)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(doc.meta.publisher)
										]))
								])),
							(finalDate !== '') ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-xs text-slate-600')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									_Utils_ap(
										A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.published'),
										finalDate))
								])) : A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row items-center text-xs gap-x-2 ')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.loc'))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-row gap-x-2  text-xs')
								]),
							A2(
								$elm$core$List$map,
								$author$project$Page$Search$viewLocation(model),
								doc.meta.tags_main_country))
						])),
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(' text-ktitle font-bold dark:font-bold dark:text-slate-700 text-lg hover:text-kompas-400 mt-0.5')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(doc.meta.url),
									$elm$html$Html$Attributes$target('_blank'),
									$elm$html$Html$Attributes$rel('external noopener noreferrer'),
									$tesk9$accessible_html$Accessibility$Role$link,
									$elm$html$Html$Attributes$tabindex(0)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(doc.meta.title)
								]))
						])),
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(' text-kgreen  dark:font-bold dark:text-slate-700 text-sm')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(doc.meta.url),
									$elm$html$Html$Attributes$class('dont-break-out'),
									$elm$html$Html$Attributes$target('_blank'),
									$elm$html$Html$Attributes$rel('external noopener noreferrer')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(urlL)
								]))
						])),
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(' text-primarytext mb-2  dark:font-bold dark:text-slate-700 text-sm  italic font-bold')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(doc.meta.subtitle)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-4 text-primarytext text-sm')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(finalLine)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row text-xs gap-x-2 mt-4')
						]),
					_List_fromArray(
						[
							(!_Utils_eq(
							$elm$core$List$head(doc.meta.email),
							$elm$core$Maybe$Just(''))) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-row flex-wrap gap-x-2 text-ktitle dark:text-slate-950')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/assets/email.svg'),
											$elm$html$Html$Attributes$class('dark:grayscale text-ktitle'),
											$elm$html$Html$Attributes$alt('email icon'),
											$tesk9$accessible_html$Accessibility$Role$presentation
										]),
									_List_Nil),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											'mailto:' + $author$project$Page$Search$getString(
												$elm$core$List$head(doc.meta.email))),
											$elm$html$Html$Attributes$target('_blank'),
											$elm$html$Html$Attributes$rel('external noopener noreferrer'),
											$elm$html$Html$Attributes$tabindex(0),
											$tesk9$accessible_html$Accessibility$Role$link,
											$elm$html$Html$Attributes$class('dont-break-out')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Page$Search$getString(
												$elm$core$List$head(doc.meta.email)))
										]))
								])) : A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row text-xs gap-x-2 mt-4 md:mt-0.5')
						]),
					_List_fromArray(
						[
							((!_Utils_eq(
							$elm$core$List$head(doc.meta.webpage),
							$elm$core$Maybe$Just(''))) && ($elm$core$List$length(doc.meta.webpage) < 2)) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-row gap-x-2  text-ktitle dark:text-slate-950')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/assets/web.svg'),
											$elm$html$Html$Attributes$class('dark:grayscale text-ktitle'),
											$elm$html$Html$Attributes$alt('webpage icon'),
											$tesk9$accessible_html$Accessibility$Role$presentation
										]),
									_List_Nil),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(
											$author$project$Page$Search$getString(
												$elm$core$List$head(doc.meta.webpage))),
											$elm$html$Html$Attributes$target('_blank'),
											$elm$html$Html$Attributes$rel('external noopener noreferrer'),
											$elm$html$Html$Attributes$tabindex(0),
											$tesk9$accessible_html$Accessibility$Role$link,
											$elm$html$Html$Attributes$class('dont-break-out')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Page$Search$getString(
												$elm$core$List$head(doc.meta.webpage)))
										]))
								])) : (($elm$core$List$length(doc.meta.webpage) > 1) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-row gap-x-2 text-ktitle')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/assets/web.svg'),
											$elm$html$Html$Attributes$class('dark:grayscale text-ktitle')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-row  flex-wrap gap-x-2')
										]),
									A2($elm$core$List$map, $author$project$Page$Search$viewWebpage, doc.meta.webpage))
								])) : A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('')
								])))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row text-xs gap-x-2 mt-2')
						]),
					_List_fromArray(
						[
							(!_Utils_eq(
							$elm$core$List$head(doc.meta.contact_person),
							$elm$core$Maybe$Just(''))) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-row gap-x-2')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/assets/person.svg'),
											$elm$html$Html$Attributes$class('dark:grayscale')
										]),
									_List_Nil),
									$elm$html$Html$text(
									$author$project$Page$Search$getString(
										$elm$core$List$head(doc.meta.contact_person)))
								])) : A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-row justify-between mt-2 ')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex flex-row flex-wrap')
								]),
							A2($elm$core$List$map, $author$project$Page$Search$viewTag, doc.meta.tags_topics)),
							$author$project$Page$Search$rating
						])),
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(' text-klicense dark:text-slate-600 text-xs')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Page$Search$viewData = F3(
	function (sharedState, data, model) {
		var responseArr = $elm$core$Array$fromList(data.documents);
		var topK = A3($elm$core$Array$slice, 0, 10, responseArr);
		var results = $elm$core$Array$toList(topK);
		var length = $elm$core$List$length(data.documents);
		var lenString = $elm$core$String$fromInt(length);
		var lenArr = $elm$core$Array$length(topK);
		var lenStr = $elm$core$String$fromInt(lenArr);
		var count = ($elm$core$List$length(results) > 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-kompas-300 mx-12  dark:text-slate-700 ml-12 md:ml-0 mt-4')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'search.results'))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-kompas-300  dark:text-slate-700 ml-12 md:ml-0 ')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-lg text-primarytext')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'search.noresults'))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold text-kompas-300 mt-4 text-md sm:text-center md:text-start')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'search.suggestions'))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-4 ml-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-disc ')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'search.checkspelling'))
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list-disc ')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'search.usingkeyword'))
								]))
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('basis-2/3 '),
					$tesk9$accessible_html$Accessibility$Live$polite
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-slate-400  dark:text-slate-950 text-sm mb-4 ')
						]),
					_List_fromArray(
						[count])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$Page$Search$viewDoc, sharedState, model),
						results))
				]));
	});
var $author$project$Page$Search$viewError = F2(
	function (sharedState, errorMessage) {
		var error = ' Failed to fetch the data';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(' w-full mt-8')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-bold  dark:text-slate-950 text-kompas-300 text-2xl p-4 mx-12 ')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'search.error'))
						]))
				]));
	});
var $author$project$Page$Search$viewDataorError = F2(
	function (sharedstate, model) {
		var _v0 = model.data;
		switch (_v0.$) {
			case 'NotAsked':
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('basis-3/4')
						]),
					_List_Nil);
			case 'Loading':
				return A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(' h-full  basis-3/4  pt-12  pb-12 md:pb-0 md:pt-28 grid place-content-center  dark:bg-slate dark:text-slate-400 font-bold text-kompas-300 dark:text-slate-950'),
							$elm$html$Html$Attributes$alt('Kompas is loading data'),
							$tesk9$accessible_html$Accessibility$Aria$roleDescription('loading'),
							$tesk9$accessible_html$Accessibility$Live$busy(true)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(' text-primarytext text-center')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.loading'))
								])),
							A2($jouderianjr$elm_loaders$Loaders$threeDots, 60, '#2d3748')
						]));
			case 'Success':
				var data = _v0.a;
				return A3($author$project$Page$Search$viewData, sharedstate, data, model);
			default:
				var httpError = _v0.a;
				return A2(
					$author$project$Page$Search$viewError,
					sharedstate,
					$author$project$Page$Search$buildError(httpError));
		}
	});
var $author$project$Page$Search$SelectLocation = F2(
	function (a, b) {
		return {$: 'SelectLocation', a: a, b: b};
	});
var $author$project$Page$Search$viewDropdown = F2(
	function (share, loc) {
		var nameUk = loc.name_ukr;
		var nameEn = loc.name_eng;
		var lang = A2($ChristophP$elm_i18next$I18Next$t, share.translations, 'lang');
		var name = (lang === 'en') ? nameEn : nameUk;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2($author$project$Page$Search$SelectLocation, name, loc.id))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				]));
	});
var $author$project$Page$Search$SelectCities = F2(
	function (a, b) {
		return {$: 'SelectCities', a: a, b: b};
	});
var $author$project$Page$Search$viewDropdownCities = F2(
	function (share, loc) {
		var nameUk = loc.name_ukr;
		var nameEn = loc.name_eng;
		var lang = A2($ChristophP$elm_i18next$I18Next$t, share.translations, 'lang');
		var name = (lang === 'en') ? nameEn : nameUk;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2($author$project$Page$Search$SelectCities, name, loc.id))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				]));
	});
var $author$project$Page$Search$SelectRegion = F2(
	function (a, b) {
		return {$: 'SelectRegion', a: a, b: b};
	});
var $author$project$Page$Search$viewDropdownRegion = F2(
	function (share, loc) {
		var nameUk = loc.name_ukr;
		var nameEn = loc.name_eng;
		var lang = A2($ChristophP$elm_i18next$I18Next$t, share.translations, 'lang');
		var name = (lang === 'en') ? nameEn : nameUk;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2($author$project$Page$Search$SelectRegion, name, loc.id))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				]));
	});
var $author$project$Page$Search$SelectSmallCities = F2(
	function (a, b) {
		return {$: 'SelectSmallCities', a: a, b: b};
	});
var $author$project$Page$Search$viewDropdownSmCities = F2(
	function (share, loc) {
		var nameUk = loc.name_ukr;
		var nameEn = loc.name_eng;
		var lang = A2($ChristophP$elm_i18next$I18Next$t, share.translations, 'lang');
		var name = (lang === 'en') ? nameEn : nameUk;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2($author$project$Page$Search$SelectSmallCities, name, loc.id))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				]));
	});
var $author$project$Page$Search$SelectVillage = F2(
	function (a, b) {
		return {$: 'SelectVillage', a: a, b: b};
	});
var $author$project$Page$Search$viewDropdownVillages = F2(
	function (share, loc) {
		var nameUk = loc.name_ukr;
		var nameEn = loc.name_eng;
		var lang = A2($ChristophP$elm_i18next$I18Next$t, share.translations, 'lang');
		var name = (lang === 'en') ? nameEn : nameUk;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2($author$project$Page$Search$SelectVillage, name, loc.id))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				]));
	});
var $author$project$Page$Search$FilterSubTopics = F2(
	function (a, b) {
		return {$: 'FilterSubTopics', a: a, b: b};
	});
var $author$project$Page$Search$cmdCheck = function (name) {
	return $elm$html$Html$Events$onCheck(
		$author$project$Page$Search$FilterSubTopics(name));
};
var $author$project$Page$Search$viewSubTopics = F2(
	function (share, subTopic) {
		var topicid = subTopic.id;
		var nameUk = subTopic.name_ukr;
		var nameEn = subTopic.name_eng;
		var lang = A2($ChristophP$elm_i18next$I18Next$t, share.translations, 'lang');
		var name = (lang === 'en') ? nameEn : nameUk;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(name)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$author$project$Page$Search$cmdCheck(topicid),
							$elm$html$Html$Attributes$id(name),
							$tesk9$accessible_html$Accessibility$Role$checkBox,
							$elm$html$Html$Attributes$tabindex(0),
							$tesk9$accessible_html$Accessibility$Aria$roleDescription('select subtopic'),
							$elm$html$Html$Attributes$id('uncheck')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]))
				]));
	});
var $author$project$Page$Search$view = F2(
	function (sharedstate, model) {
		var viewTransportation = function () {
			var _v28 = model.transportSubOpen;
			if (_v28) {
				return 'block';
			} else {
				return 'hidden';
			}
		}();
		var viewTopics = function () {
			var _v27 = model.topicsOpen;
			if (_v27) {
				return 'visible  w-5/6 lg:block  text-sm md:text-sm lg:w-full  xs:w-full sm:gap-x-2 ml-4  md:ml-0 h-40  box-shadow-md dark:scrolld scroll overflow-y-auto ';
			} else {
				return 'hidden';
			}
		}();
		var viewSocial = function () {
			var _v26 = model.socialSubOpen;
			if (_v26) {
				return 'block';
			} else {
				return 'hidden';
			}
		}();
		var viewPsychology = function () {
			var _v25 = model.psychoSubOpen;
			if (_v25) {
				return 'block';
			} else {
				return 'hidden';
			}
		}();
		var viewProtection = function () {
			var _v24 = model.protectionSubOpen;
			if (_v24) {
				return 'block';
			} else {
				return 'hidden';
			}
		}();
		var viewPets = function () {
			var _v23 = model.petSubOpen;
			if (_v23) {
				return 'block';
			} else {
				return 'hidden';
			}
		}();
		var viewLocs = function () {
			var _v22 = model.locationOpen;
			if (_v22) {
				return 'visible w-5/6 lg:block  text-sm md:text-sm lg:w-full mb-2  xs:w-full sm:gap-x-2 ml-4 md:ml-0 h-40 md:h-full   box-shadow-md dark:scrolld scroll overflow-y-auto ';
			} else {
				return 'hidden';
			}
		}();
		var viewLegalAid = function () {
			var _v21 = model.legalaidSubOpen;
			if (_v21) {
				return 'block';
			} else {
				return 'hidden';
			}
		}();
		var viewHumanitarian = function () {
			var _v20 = model.humanitarianSubOpen;
			if (_v20) {
				return 'block';
			} else {
				return 'hidden';
			}
		}();
		var viewHousing = function () {
			var _v19 = model.housingSubOpen;
			if (_v19) {
				return 'block';
			} else {
				return 'hidden';
			}
		}();
		var viewHotlines = function () {
			var _v18 = model.hotlineSubOpen;
			if (_v18) {
				return 'block';
			} else {
				return 'hidden';
			}
		}();
		var viewHealthcare = function () {
			var _v17 = model.healthcareSubOpen;
			if (_v17) {
				return 'block';
			} else {
				return 'hidden';
			}
		}();
		var viewFinancialSupport = function () {
			var _v16 = model.financialSubOpen;
			if (_v16) {
				return 'block';
			} else {
				return 'hidden';
			}
		}();
		var viewEmployment = function () {
			var _v15 = model.employmentSubOpen;
			if (_v15) {
				return 'block';
			} else {
				return 'hidden';
			}
		}();
		var viewEmigration = function () {
			var _v14 = model.emigrationSubOpen;
			if (_v14) {
				return 'block';
			} else {
				return 'hidden';
			}
		}();
		var viewEducation = function () {
			var _v13 = model.educationSubOpen;
			if (_v13) {
				return 'block';
			} else {
				return 'hidden';
			}
		}();
		var viewApplyBtn = (model.selectOpen || (model.selectedLocation !== 'Enter Location')) ? 'bg-kompas-300 text-white  p-2 my-2  rounded-md ml-2 dark:bg-slate-500' : 'invisible';
		var topicSelect = model.showTopics ? ' cursor-pointer  text-xs text-kompas-300 font-extrabold p-2  border-b-4  border-kompas-300' : 'cursor-pointer';
		var result = '  bg-white dark:bg-slate-50 ';
		var receivedV = function () {
			var _v12 = model.villageList;
			if (_v12.$ === 'Success') {
				var cities = _v12.a;
				return cities;
			} else {
				return _List_Nil;
			}
		}();
		var receivedVillagesSortedEN = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.name_eng;
			},
			receivedV);
		var receivedVillagesSortedUA = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.name_rus;
			},
			receivedV);
		var receivedVillagesSorted = (A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'lang') === 'en') ? receivedVillagesSortedEN : receivedVillagesSortedUA;
		var receivedSn = function () {
			var _v11 = model.smallCitiesList;
			if (_v11.$ === 'Success') {
				var cities = _v11.a;
				return cities;
			} else {
				return _List_Nil;
			}
		}();
		var receivedSmCitiesSortedUA = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.name_rus;
			},
			receivedSn);
		var receivedSmCitiesSortedEN = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.name_eng;
			},
			receivedSn);
		var receivedSmCitiesSorted = (A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'lang') === 'en') ? receivedSmCitiesSortedEN : receivedSmCitiesSortedUA;
		var receivedR = function () {
			var _v10 = model.regionList;
			if (_v10.$ === 'Success') {
				var regions = _v10.a;
				return regions;
			} else {
				return _List_Nil;
			}
		}();
		var receivedRegionSortedEN = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.name_eng;
			},
			receivedR);
		var receivedRegionSortedUA = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.name_rus;
			},
			receivedR);
		var receivedRegionSorted = (A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'lang') === 'en') ? receivedRegionSortedEN : receivedRegionSortedUA;
		var receivedL = function () {
			var _v9 = model.locationList;
			if (_v9.$ === 'Success') {
				var locations = _v9.a;
				return locations;
			} else {
				return _List_Nil;
			}
		}();
		var receivedLocationSorted = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.name_eng;
			},
			receivedL);
		var receivedLocationUASorted = A2(
			$rtfeldman$elm_sorter_experiment$Sort$list,
			A2(
				$rtfeldman$elm_sorter_experiment$Sort$by,
				function ($) {
					return $.name_rus;
				},
				$rtfeldman$elm_sorter_experiment$Sort$alphabetical),
			receivedL);
		var receivedC = function () {
			var _v8 = model.citiesList;
			if (_v8.$ === 'Success') {
				var cities = _v8.a;
				return cities;
			} else {
				return _List_Nil;
			}
		}();
		var receivedCitiesSortedEN = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.name_eng;
			},
			receivedC);
		var receivedCitiesSortedUA = A2(
			$elm$core$List$sortBy,
			function ($) {
				return $.name_rus;
			},
			receivedC);
		var receivedCitiesSorted = (A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'lang') === 'en') ? receivedCitiesSortedEN : receivedCitiesSortedUA;
		var openDropVillage = function () {
			var _v7 = model.selectVOpen;
			if (_v7) {
				return 'visible    ml-12 mt-2 max-h-32 overflow-y-auto';
			} else {
				return 'hidden';
			}
		}();
		var openDropSmCities = function () {
			var _v6 = model.selectSOpen;
			if (_v6) {
				return 'visible   ml-12 mt-2 max-h-32 overflow-y-auto';
			} else {
				return 'hidden';
			}
		}();
		var openDropRegion = function () {
			var _v5 = model.selectROpen;
			if (_v5) {
				return 'visible  ml-12 mt-2 max-h-32 overflow-x-auto';
			} else {
				return 'hidden';
			}
		}();
		var openDropCities = function () {
			var _v4 = model.selectCOpen;
			if (_v4) {
				return 'visible    ml-12 mt-2 max-h-32 overflow-y-auto';
			} else {
				return 'hidden';
			}
		}();
		var openDrop = function () {
			var _v3 = model.selectOpen;
			if (_v3) {
				return 'visible w-5/6  ml-12 mt-2 max-h-32 overflow-y-auto';
			} else {
				return 'hidden';
			}
		}();
		var locationSelect = ((model.selectedLocation === 'All') || ((model.selectedLocation === ' ') || (model.selectedLocation === 'все'))) ? A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'location.everywhere') : model.selectedLocation;
		var locSelect = model.showLocation ? ' cursor-pointer  text-xs text-kompas-300 font-extrabold p-2  border-b-4  border-kompas-300' : 'cursor-pointer';
		var layout = 'bg-white  dark:bg-slate-50 border-solid-red';
		var isOpen = function () {
			var _v2 = model.openSurvey;
			if (_v2) {
				return 'dark: text-slate-700 flex flex-row items-center  h-14 text-center  w-full text-sm dark:shadow-lg z-10';
			} else {
				return 'hidden ';
			}
		}();
		var iconTopics = function () {
			var _v1 = model.topicsOpen;
			if (_v1) {
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/chevron.svg'),
							$elm$html$Html$Attributes$class('bg-white'),
							$elm$html$Html$Attributes$alt(' open list icon'),
							$elm$html$Html$Attributes$tabindex(0),
							$tesk9$accessible_html$Accessibility$Aria$roleDescription('open topics dropdown')
						]),
					_List_Nil);
			} else {
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/arrow.svg'),
							$elm$html$Html$Attributes$class(' bg-white'),
							$elm$html$Html$Attributes$alt('close list icon'),
							$elm$html$Html$Attributes$tabindex(0),
							$tesk9$accessible_html$Accessibility$Aria$roleDescription('close topics dropdown')
						]),
					_List_Nil);
			}
		}();
		var iconLocs = function () {
			var _v0 = model.locationOpen;
			if (_v0) {
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/chevron.svg'),
							$elm$html$Html$Attributes$class('bg-white'),
							$elm$html$Html$Attributes$alt('open list location '),
							$elm$html$Html$Attributes$tabindex(0),
							$tesk9$accessible_html$Accessibility$Aria$roleDescription('open location  dropdown')
						]),
					_List_Nil);
			} else {
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src('/assets/arrow.svg'),
							$elm$html$Html$Attributes$class(' bg-white'),
							$elm$html$Html$Attributes$alt('close list location'),
							$elm$html$Html$Attributes$tabindex(0),
							$tesk9$accessible_html$Accessibility$Aria$roleDescription('open location  dropdown')
						]),
					_List_Nil);
			}
		}();
		var filterStyle = 'absolute top-12 bg-white cursor-pointer h-48 overflow-y-scroll   w-fit  z-10 drop-shadow-lg  border-0.5border-solid border-slate-300 rounded-sm';
		var showloc = model.showLocation ? (filterStyle + ' md:left-72  p-4 text-xs border-2 border-slate-100 bottom-6 rounded-sm') : 'hidden';
		var showtop = model.showTopics ? (filterStyle + 'md:left-20 text-xs p-4 border border-2 border-slate-100 bottom-6 rounded-sm ') : 'hidden';
		var centered = '  bg-white  dark:bg-slate-50';
		var all = {
			id: A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'location.all'),
			name_eng: A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'location.all'),
			name_rus: A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'location.all'),
			name_ukr: A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'location.all')
		};
		var receivedCities = (model.selectedCountry === 'UA') ? A2($elm$core$List$cons, all, receivedCitiesSorted) : _List_fromArray(
			[all]);
		var receivedLocationEN = A2($elm$core$List$cons, all, receivedLocationSorted);
		var receivedLocationUA = A2($elm$core$List$cons, all, receivedLocationUASorted);
		var receivedRegion = (model.selectedCountry === 'UA') ? A2($elm$core$List$cons, all, receivedRegionSorted) : _List_fromArray(
			[all]);
		var receivedSmCities = (model.selectedCountry === 'UA') ? A2($elm$core$List$cons, all, receivedSmCitiesSorted) : _List_fromArray(
			[all]);
		var receivedVillages = (model.selectedCountry === 'UA') ? A2($elm$core$List$cons, all, receivedVillagesSorted) : _List_fromArray(
			[all]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(layout)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(isOpen),
							$tesk9$accessible_html$Accessibility$Aria$labelledBy('header-id')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(' relative basis-full dark:bg-white bg-kompas-300 p-2 dark:border-solid dark:border-2 dark:border-slate-200 text-primarytext text-sm')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(' text-xs md:text-sm h-10 md:h-10 flex  flex-col md:flex-row gap-x-2 justify-center items-center relative ')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(' flex flex-row gap-x-2 dark:grayscale  items-center text-white dark:text-primarytext ')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src('/assets/message.svg'),
															$elm$html$Html$Attributes$alt('editing-icon')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$id('header-id')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'survey.help'))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('font-bold underline ')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href(
															A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'survey.link')),
															$elm$html$Html$Attributes$rel('external noopener noreferrer'),
															$elm$html$Html$Attributes$target('_blank'),
															$elm$html$Html$Attributes$class('text-kyellow dark:text-primarytext'),
															$elm$html$Html$Attributes$tabindex(0),
															$tesk9$accessible_html$Accessibility$Role$link
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'survey.submit'))
														]))
												]))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('absolute right-2 top-2'),
											$elm$html$Html$Events$onClick($author$project$Page$Search$CloseSurvey),
											$elm$html$Html$Attributes$alt('button for closing survey banner'),
											$elm$html$Html$Attributes$title('close survey '),
											$tesk9$accessible_html$Accessibility$Aria$label('close Modal'),
											$tesk9$accessible_html$Accessibility$Aria$roleDescription('close modal'),
											$elm$html$Html$Attributes$tabindex(0)
										]),
									_List_fromArray(
										[
											A2($icidasset$elm_material_icons$Material$Icons$Outlined$close, 18, $icidasset$elm_material_icons$Material$Icons$Types$Inherit)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block text-center md:hidden bg-slate-kompas mt-4')
						]),
					_List_fromArray(
						[
							A2($author$project$Page$Search$searchSm, sharedstate, model)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('w-full p-6  md:pl-42  py-2  flex flex-row gap-x-4 relative justify-center  md:justify-start  items-center text-primarytext text-sm  border border-b-2 border-slate-200')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(topicSelect),
									$elm$html$Html$Events$onClick(
									$author$project$Page$Search$ShowFilters('topics'))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'filter.filtertopics'))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(locSelect),
									$elm$html$Html$Events$onClick(
									$author$project$Page$Search$ShowFilters('location'))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'filter.filterlocation'))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(showtop)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row items-center   justify-between  items-center basis-1/2  border border-solid border-slate-100  p-4   sm:h-8 md:h-12 ')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-slate-600 w-1/2 flex flex-row items-center')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$for('housing')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('checkbox'),
																			$elm$html$Html$Attributes$id('housing '),
																			$tesk9$accessible_html$Accessibility$Role$checkBox,
																			$elm$html$Html$Events$onCheck(
																			$author$project$Page$Search$FilterTopics('Housing')),
																			$elm$html$Html$Attributes$id('uncheck')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('ml-0.2')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'topics.housing'))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Search$ViewSubTopic('housing')),
																	$elm$html$Html$Attributes$class('grow flex flex row justify-end pr-2')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src('/assets/arrow.svg'),
																			$elm$html$Html$Attributes$alt('editing-icon'),
																			$tesk9$accessible_html$Accessibility$Aria$label('open subtopic'),
																			$elm$html$Html$Attributes$tabindex(0)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(viewHousing)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4  md:ml-12 text-slate-600')
																]),
															A2(
																$elm$core$List$map,
																$author$project$Page$Search$viewSubTopics(sharedstate),
																$author$project$Page$Search$getDictList(
																	A2($elm$core$Dict$get, 'Housing', model.subTopicsDict))))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row items-center basis-1/2   border border-solid border-slate-100  p-4   sm:h-8 md:h-12 ')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-slate-600 flex flex-row items-center')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$for('healthcare')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('checkbox'),
																			$elm$html$Html$Attributes$id('healthcare'),
																			$tesk9$accessible_html$Accessibility$Role$checkBox,
																			$elm$html$Html$Events$onCheck(
																			$author$project$Page$Search$FilterTopics('Healthcare')),
																			$elm$html$Html$Attributes$id('uncheck')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('ml-0.2')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'topics.healthcare'))
																		]))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Search$ViewSubTopic('healthcare')),
																	$elm$html$Html$Attributes$class('grow flex flex row justify-end pr-2')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src('/assets/arrow.svg'),
																			$elm$html$Html$Attributes$alt('editing-icon'),
																			$tesk9$accessible_html$Accessibility$Aria$label('open subtopic'),
																			$elm$html$Html$Attributes$tabindex(0)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(viewHealthcare)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 ml-12 text-slate-600')
																]),
															A2(
																$elm$core$List$map,
																$author$project$Page$Search$viewSubTopics(sharedstate),
																$author$project$Page$Search$getDictList(
																	A2($elm$core$Dict$get, 'Healthcare', model.subTopicsDict))))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row items-center basis-1/2  border border-solid border-slate-100  p-4   sm:h-8 md:h-12 ')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-slate-600 flex flex-row items-center')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$for('legalaid')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('checkbox'),
																			$elm$html$Html$Attributes$id('legalaid'),
																			$tesk9$accessible_html$Accessibility$Role$checkBox,
																			$elm$html$Html$Events$onCheck(
																			$author$project$Page$Search$FilterTopics('Legal aid')),
																			$elm$html$Html$Attributes$id('uncheck')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('ml-0.2')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'topics.legalaid'))
																		]))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Search$ViewSubTopic('legalaid')),
																	$elm$html$Html$Attributes$class('grow flex flex row justify-end pr-2')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src('/assets/arrow.svg'),
																			$elm$html$Html$Attributes$alt('editing-icon'),
																			$tesk9$accessible_html$Accessibility$Aria$label('open subtopic'),
																			$elm$html$Html$Attributes$tabindex(0)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(viewLegalAid)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 ml-12 text-slate-600')
																]),
															A2(
																$elm$core$List$map,
																$author$project$Page$Search$viewSubTopics(sharedstate),
																$author$project$Page$Search$getDictList(
																	A2($elm$core$Dict$get, 'Legal aid', model.subTopicsDict))))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row items-center basis-1/2   border border-solid border-slate-100  p-4   sm:h-8 md:h-12 ')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-slate-600 flex flex-row items-center')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$for('education')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('checkbox'),
																			$elm$html$Html$Attributes$id('education'),
																			$tesk9$accessible_html$Accessibility$Role$checkBox,
																			$elm$html$Html$Events$onCheck(
																			$author$project$Page$Search$FilterTopics('Education')),
																			$elm$html$Html$Attributes$id('uncheck')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('ml-0.2')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'topics.education'))
																		]))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Search$ViewSubTopic('education')),
																	$elm$html$Html$Attributes$class('grow flex flex row justify-end pr-2')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src('/assets/arrow.svg'),
																			$elm$html$Html$Attributes$alt('editing-icon'),
																			$tesk9$accessible_html$Accessibility$Aria$label('open subtopic'),
																			$elm$html$Html$Attributes$tabindex(0)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(viewEducation)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 ml-12 text-slate-600')
																]),
															A2(
																$elm$core$List$map,
																$author$project$Page$Search$viewSubTopics(sharedstate),
																$author$project$Page$Search$getDictList(
																	A2($elm$core$Dict$get, 'Education', model.subTopicsDict))))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row items-center basis-1/2   border border-solid border-slate-100  p-4   sm:h-8 md:h-12 ')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-slate-600 flex flex-row items-center')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$for('employment')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('checkbox'),
																			$elm$html$Html$Attributes$id('employment'),
																			$tesk9$accessible_html$Accessibility$Role$checkBox,
																			$elm$html$Html$Events$onCheck(
																			$author$project$Page$Search$FilterTopics('Employment')),
																			$elm$html$Html$Attributes$id('uncheck')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('ml-0.2')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'topics.employment'))
																		]))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Search$ViewSubTopic('employment')),
																	$elm$html$Html$Attributes$class('grow flex flex row justify-end pr-2')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src('/assets/arrow.svg'),
																			$elm$html$Html$Attributes$alt('editing-icon'),
																			$tesk9$accessible_html$Accessibility$Aria$label('open subtopic'),
																			$elm$html$Html$Attributes$tabindex(0)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(viewEmployment)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 ml-12 text-slate-600')
																]),
															A2(
																$elm$core$List$map,
																$author$project$Page$Search$viewSubTopics(sharedstate),
																$author$project$Page$Search$getDictList(
																	A2($elm$core$Dict$get, 'Employment', model.subTopicsDict))))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row items-center basis-1/2   border border-solid border-slate-100  p-4   sm:h-8 md:h-12 ')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-slate-600 flex flex-row items-center')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$for('financialsupport')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('checkbox'),
																			$elm$html$Html$Attributes$id('financialsupport'),
																			$tesk9$accessible_html$Accessibility$Role$checkBox,
																			$elm$html$Html$Events$onCheck(
																			$author$project$Page$Search$FilterTopics('Financial support')),
																			$elm$html$Html$Attributes$id('uncheck')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('ml-0.2')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'topics.financialsupport'))
																		]))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Search$ViewSubTopic('financialsupport')),
																	$elm$html$Html$Attributes$class('grow flex flex row justify-end pr-2')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src('/assets/arrow.svg'),
																			$elm$html$Html$Attributes$alt('editing-icon'),
																			$tesk9$accessible_html$Accessibility$Aria$label('open subtopic'),
																			$elm$html$Html$Attributes$tabindex(0)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(viewFinancialSupport)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 ml-12 text-slate-600')
																]),
															A2(
																$elm$core$List$map,
																$author$project$Page$Search$viewSubTopics(sharedstate),
																$author$project$Page$Search$getDictList(
																	A2($elm$core$Dict$get, 'Financial support', model.subTopicsDict))))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row items-center basis-1/2   border border-solid border-slate-100  p-4   sm:h-8 md:h-12 ')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-slate-600 flex flex-row items-center')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$for('humanitarianaid')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('checkbox'),
																			$elm$html$Html$Attributes$id('humanitarianaid'),
																			$tesk9$accessible_html$Accessibility$Role$checkBox,
																			$elm$html$Html$Events$onCheck(
																			$author$project$Page$Search$FilterTopics('Humanitarian aid')),
																			$elm$html$Html$Attributes$id('uncheck')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('ml-0.2')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'topics.humanitarianaid'))
																		]))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Search$ViewSubTopic('humanitarianaid')),
																	$elm$html$Html$Attributes$class('grow flex flex row justify-end pr-2')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src('/assets/arrow.svg'),
																			$elm$html$Html$Attributes$alt('editing-icon'),
																			$tesk9$accessible_html$Accessibility$Aria$label('open subtopic'),
																			$elm$html$Html$Attributes$tabindex(0)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(viewHumanitarian)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 ml-12 text-slate-600')
																]),
															A2(
																$elm$core$List$map,
																$author$project$Page$Search$viewSubTopics(sharedstate),
																$author$project$Page$Search$getDictList(
																	A2($elm$core$Dict$get, 'Humanitarian aid', model.subTopicsDict))))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row items-center basis-1/2   border border-solid border-slate-100  p-4   sm:h-8 md:h-12 ')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-slate-600 flex flex-row items-center')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$for('socialservices')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('checkbox'),
																			$elm$html$Html$Attributes$id('socialservices'),
																			$tesk9$accessible_html$Accessibility$Role$checkBox,
																			$elm$html$Html$Events$onCheck(
																			$author$project$Page$Search$FilterTopics('Social services')),
																			$elm$html$Html$Attributes$id('uncheck')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('ml-0.2')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'topics.socialservices'))
																		]))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Search$ViewSubTopic('socialservices')),
																	$elm$html$Html$Attributes$class('grow flex flex row justify-end pr-2')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src('/assets/arrow.svg'),
																			$elm$html$Html$Attributes$alt('editing-icon'),
																			$tesk9$accessible_html$Accessibility$Aria$label('open subtopic'),
																			$elm$html$Html$Attributes$tabindex(0)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(viewSocial)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 ml-12 text-slate-600')
																]),
															A2(
																$elm$core$List$map,
																$author$project$Page$Search$viewSubTopics(sharedstate),
																$author$project$Page$Search$getDictList(
																	A2($elm$core$Dict$get, 'Social services', model.subTopicsDict))))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row items-center basis-1/2   border border-solid border-slate-100  p-4   sm:h-8 md:h-12 ')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-slate-600 flex flex-row items-center')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$for('emigration')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('checkbox'),
																			$elm$html$Html$Attributes$id('emigration'),
																			$tesk9$accessible_html$Accessibility$Role$checkBox,
																			$elm$html$Html$Events$onCheck(
																			$author$project$Page$Search$FilterTopics('Emigration')),
																			$elm$html$Html$Attributes$id('uncheck')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('ml-0.2')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'topics.emigration'))
																		]))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Search$ViewSubTopic('emigration')),
																	$elm$html$Html$Attributes$class('grow flex flex row justify-end pr-2')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src('/assets/arrow.svg'),
																			$elm$html$Html$Attributes$alt('editing-icon'),
																			$tesk9$accessible_html$Accessibility$Aria$label('open subtopic'),
																			$elm$html$Html$Attributes$tabindex(0)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(viewEmigration)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 ml-12 text-slate-600')
																]),
															A2(
																$elm$core$List$map,
																$author$project$Page$Search$viewSubTopics(sharedstate),
																$author$project$Page$Search$getDictList(
																	A2($elm$core$Dict$get, 'Emigration', model.subTopicsDict))))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row items-center basis-1/2   border border-solid border-slate-100  p-4   sm:h-8 md:h-12 ')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-slate-600 flex flex-row items-center')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$for('protection')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('checkbox'),
																			$elm$html$Html$Attributes$id('protection'),
																			$tesk9$accessible_html$Accessibility$Role$checkBox,
																			$elm$html$Html$Events$onCheck(
																			$author$project$Page$Search$FilterTopics('Protection')),
																			$elm$html$Html$Attributes$id('uncheck')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('ml-0.2')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'topics.protection'))
																		]))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Search$ViewSubTopic('protection')),
																	$elm$html$Html$Attributes$class('grow flex flex row justify-end pr-2')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src('/assets/arrow.svg'),
																			$elm$html$Html$Attributes$alt('editing-icon'),
																			$tesk9$accessible_html$Accessibility$Aria$label('open subtopic'),
																			$elm$html$Html$Attributes$tabindex(0)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(viewProtection)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 ml-12 text-slate-600')
																]),
															A2(
																$elm$core$List$map,
																$author$project$Page$Search$viewSubTopics(sharedstate),
																$author$project$Page$Search$getDictList(
																	A2($elm$core$Dict$get, 'Protection', model.subTopicsDict))))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row items-center basis-1/2   border border-solid border-slate-100  p-4   sm:h-8 md:h-12 ')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-slate-600 flex flex-row items-center')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$for('transportation')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('checkbox'),
																			$elm$html$Html$Attributes$id('transportation'),
																			$tesk9$accessible_html$Accessibility$Role$checkBox,
																			$elm$html$Html$Events$onCheck(
																			$author$project$Page$Search$FilterTopics(
																				A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'Transportation'))),
																			$elm$html$Html$Attributes$id('uncheck')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('ml-0.2')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'topics.transportation'))
																		]))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Search$ViewSubTopic('transportation')),
																	$elm$html$Html$Attributes$class('grow flex flex row justify-end pr-2')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src('/assets/arrow.svg'),
																			$elm$html$Html$Attributes$alt('editing-icon'),
																			$tesk9$accessible_html$Accessibility$Aria$label('open subtopic'),
																			$elm$html$Html$Attributes$tabindex(0)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(viewTransportation)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 ml-12 text-slate-600')
																]),
															A2(
																$elm$core$List$map,
																$author$project$Page$Search$viewSubTopics(sharedstate),
																$author$project$Page$Search$getDictList(
																	A2($elm$core$Dict$get, 'Transportation', model.subTopicsDict))))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row items-center basis-1/2   border border-solid border-slate-100  p-4   sm:h-8 md:h-12 ')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-slate-600 flex flex-row items-center')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$for('pets')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('checkbox'),
																			$elm$html$Html$Attributes$id('pets'),
																			$tesk9$accessible_html$Accessibility$Role$checkBox,
																			$elm$html$Html$Events$onCheck(
																			$author$project$Page$Search$FilterTopics('Pets')),
																			$elm$html$Html$Attributes$id('uncheck')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('ml-0.2')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'topics.pets'))
																		]))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Search$ViewSubTopic('pets')),
																	$elm$html$Html$Attributes$class('grow flex flex row justify-end pr-2')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src('/assets/arrow.svg'),
																			$elm$html$Html$Attributes$alt('editing-icon'),
																			$tesk9$accessible_html$Accessibility$Aria$label('open subtopic'),
																			$elm$html$Html$Attributes$tabindex(0)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(viewPets)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 ml-12 text-slate-600')
																]),
															A2(
																$elm$core$List$map,
																$author$project$Page$Search$viewSubTopics(sharedstate),
																$author$project$Page$Search$getDictList(
																	A2($elm$core$Dict$get, 'Pets', model.subTopicsDict))))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row items-center basis-1/2   border border-solid border-slate-100  p-4   sm:h-8 md:h-12 ')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-slate-600 flex flex-row items-center')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$for('hotlines')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('checkbox'),
																			$elm$html$Html$Attributes$id('hotlines'),
																			$tesk9$accessible_html$Accessibility$Role$checkBox,
																			$elm$html$Html$Events$onCheck(
																			$author$project$Page$Search$FilterTopics('Hotlines')),
																			$elm$html$Html$Attributes$id('uncheck')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('ml-0.2')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'topics.hotlines'))
																		]))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Search$ViewSubTopic('hotlines')),
																	$elm$html$Html$Attributes$class('grow flex flex row justify-end pr-2')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src('/assets/arrow.svg'),
																			$elm$html$Html$Attributes$alt('editing-icon'),
																			$tesk9$accessible_html$Accessibility$Aria$label('open subtopic'),
																			$elm$html$Html$Attributes$tabindex(0)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(viewHotlines)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 ml-12 text-slate-600')
																]),
															A2(
																$elm$core$List$map,
																$author$project$Page$Search$viewSubTopics(sharedstate),
																$author$project$Page$Search$getDictList(
																	A2($elm$core$Dict$get, 'Hotlines', model.subTopicsDict))))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row items-center basis-1/2   border border-solid border-slate-100  p-4   sm:h-8 md:h-12 ')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-slate-600 flex flex-row items-center')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$for('psychology')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$input,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$type_('checkbox'),
																			$elm$html$Html$Attributes$id('psychology'),
																			$tesk9$accessible_html$Accessibility$Role$checkBox,
																			$elm$html$Html$Events$onCheck(
																			$author$project$Page$Search$FilterTopics('Psychological support')),
																			$elm$html$Html$Attributes$id('uncheck')
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('ml-0.2')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'topics.psychologicalsupport'))
																		]))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$Page$Search$ViewSubTopic('psychologicalsupport')),
																	$elm$html$Html$Attributes$class('grow flex flex row justify-end pr-2')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$img,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$src('./assets/arrow.svg'),
																			$elm$html$Html$Attributes$alt('editing-icon'),
																			$tesk9$accessible_html$Accessibility$Aria$label('open subtopic'),
																			$elm$html$Html$Attributes$tabindex(0)
																		]),
																	_List_Nil)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(viewPsychology)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-4 text-xs text-slate-600')
																]),
															A2(
																$elm$core$List$map,
																$author$project$Page$Search$viewSubTopics(sharedstate),
																$author$project$Page$Search$getDictList(
																	A2($elm$core$Dict$get, 'Psychological support', model.subTopicsDict))))
														]))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(showloc)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(' w-full mb-2 text-sx text-slate-600')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row  w-full  items-center h-12 border border-solid border hover:border-kompas-300 dark:hover:border-slate-950 border-slate-100 rounded-md p-0.5')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-row  grow gap-x-4  md:px-2 ml-4')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('align-middle  grow   '),
																			$elm$html$Html$Events$onClick(
																			$author$project$Page$Search$ViewDropdown('Country')),
																			$tesk9$accessible_html$Accessibility$Role$listBox,
																			$elm$html$Html$Attributes$tabindex(0),
																			$tesk9$accessible_html$Accessibility$Aria$roleDescription('select country'),
																			$tesk9$accessible_html$Accessibility$Aria$label('Select Country'),
																			$elm$html$Html$Attributes$title('select country')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(model.selectedLocation)
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(openDrop)
														]),
													A2(
														$elm$core$List$map,
														$author$project$Page$Search$viewDropdown(sharedstate),
														(A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'lang') === 'en') ? receivedLocationEN : receivedLocationUA))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(' w-full mb-2 text-sx text-slate-600 ')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row w-full  items-center h-12 border border-solid border hover:border-kompas-300 dark:hover:border-slate-950 border-slate-100 rounded-md p-0.5')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-row  grow gap-x-4 px-2 ml-4')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('align-middle  grow  '),
																			$elm$html$Html$Events$onClick(
																			$author$project$Page$Search$ViewDropdown('Region')),
																			$tesk9$accessible_html$Accessibility$Role$listBox,
																			$elm$html$Html$Attributes$tabindex(0),
																			$tesk9$accessible_html$Accessibility$Aria$roleDescription('select region'),
																			$tesk9$accessible_html$Accessibility$Aria$label('Select Region'),
																			$elm$html$Html$Attributes$title('select region')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(model.selectedRegion)
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(openDropRegion)
														]),
													A2(
														$elm$core$List$map,
														$author$project$Page$Search$viewDropdownRegion(sharedstate),
														receivedRegion))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(' w-full  mb-2 text-sx text-slate-600')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row w-full  items-center h-12 border border-solid border hover:border-kompas-300 dark:hover:border-slate-950 border-slate- rounded-md p-0.5')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-row  grow gap-x-4 px-2 ml-4')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('align-middle  grow  '),
																			$elm$html$Html$Events$onClick(
																			$author$project$Page$Search$ViewDropdown('Cities')),
																			$tesk9$accessible_html$Accessibility$Role$listBox,
																			$elm$html$Html$Attributes$tabindex(0),
																			$tesk9$accessible_html$Accessibility$Aria$roleDescription('select cities'),
																			$tesk9$accessible_html$Accessibility$Aria$label('Select cities'),
																			$elm$html$Html$Attributes$title('select cities')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(model.selectedCities)
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(openDropCities)
														]),
													A2(
														$elm$core$List$map,
														$author$project$Page$Search$viewDropdownCities(sharedstate),
														receivedCities))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(' w-full  mb-2 text-sx text-slate-600')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row w-full   items-center h-12 border border-solid border hover:border-kompas-300 dark:hover:border-slate-950 border-slate- rounded-md p-0.5')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-row  grow gap-x-4 px-2 ml-4')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('align-middle  grow  '),
																			$elm$html$Html$Events$onClick(
																			$author$project$Page$Search$ViewDropdown('Small cities')),
																			$tesk9$accessible_html$Accessibility$Role$listBox,
																			$elm$html$Html$Attributes$tabindex(0),
																			$tesk9$accessible_html$Accessibility$Aria$roleDescription('Select small cities'),
																			$tesk9$accessible_html$Accessibility$Aria$label('Select Small Cities'),
																			$elm$html$Html$Attributes$title('select  small cities')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(model.selectedSmallCities)
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(openDropSmCities)
														]),
													A2(
														$elm$core$List$map,
														$author$project$Page$Search$viewDropdownSmCities(sharedstate),
														receivedSmCities))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(' w-full  mb-2 text-sx text-slate-600')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('flex flex-row w-full   items-center h-12 border border-solid border hover:border-kompas-300 dark:hover:border-slate-950 border-slate- rounded-md p-0.5')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('flex flex-row  grow gap-x-4 px-2 ml-4')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('align-middle  grow  '),
																			$elm$html$Html$Events$onClick(
																			$author$project$Page$Search$ViewDropdown('Villages')),
																			$tesk9$accessible_html$Accessibility$Role$listBox,
																			$elm$html$Html$Attributes$tabindex(0),
																			$tesk9$accessible_html$Accessibility$Aria$roleDescription('Select Villages'),
																			$tesk9$accessible_html$Accessibility$Aria$label('Select Villages'),
																			$elm$html$Html$Attributes$title('select village')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(model.selectedVillage)
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class(openDropVillage)
														]),
													A2(
														$elm$core$List$map,
														$author$project$Page$Search$viewDropdownVillages(sharedstate),
														receivedVillages))
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('bg-kompas-200 ml-4 p-1.5 dark:text-primarytext hover:dark:bg-slate-950 hover:dark:text-white dark:bg-slate-300   text-kompas-300 hover:bg-kompas-300 hover:text-white font-bold  text-center rounded-md  cursor-pointer'),
									$elm$html$Html$Events$onClick(
									$author$project$Page$Search$ResetFilters('location')),
									$elm$html$Html$Attributes$tabindex(0),
									$tesk9$accessible_html$Accessibility$Aria$label('reset location filters')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'filter.reset'))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex-col-reverse flex md:flex-row mt-4  md:max-w-screen-xl xl:max-w-full md:ml-40 md:mr-12   px-2 ')
						]),
					_List_fromArray(
						[
							A2($author$project$Page$Search$viewDataorError, sharedstate, model),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(' block    mt-4 mx-12  md:block   lg:w-1/3   md:items-start md:mx-0 p-4  border border-solid border-slate-200  rounded-md h-fit')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('font-bold text-sm text-primarytext')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.common.title'))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pt-2')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-primarytext text-sm cursor-pointer flex flex-row items-center gap-x-2 mt-4'),
													$elm$html$Html$Events$onClick(
													$author$project$Page$Search$CommonSearch(
														A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.common.q1')))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src('/assets/search.svg'),
															$elm$html$Html$Attributes$class('dark:grayscale text-ktitle'),
															$elm$html$Html$Attributes$alt('email icon'),
															$tesk9$accessible_html$Accessibility$Role$presentation
														]),
													_List_Nil),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.common.q1'))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-primarytext text-sm cursor-pointer flex flex-row items-center gap-x-2 mt-4'),
													$elm$html$Html$Events$onClick(
													$author$project$Page$Search$CommonSearch(
														A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.common.q2')))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src('/assets/search.svg'),
															$elm$html$Html$Attributes$class('dark:grayscale text-ktitle'),
															$elm$html$Html$Attributes$alt('email icon'),
															$tesk9$accessible_html$Accessibility$Role$presentation
														]),
													_List_Nil),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.common.q2'))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-primarytext text-sm cursor-pointer flex flex-row items-center gap-x-2 mt-4'),
													$elm$html$Html$Events$onClick(
													$author$project$Page$Search$CommonSearch(
														A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.common.q3')))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src('/assets/search.svg'),
															$elm$html$Html$Attributes$class('dark:grayscale text-ktitle'),
															$elm$html$Html$Attributes$alt('email icon'),
															$tesk9$accessible_html$Accessibility$Role$presentation
														]),
													_List_Nil),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.common.q3'))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-primarytext text-sm cursor-pointer flex flex-row items-center gap-x-2 mt-4 '),
													$elm$html$Html$Events$onClick(
													$author$project$Page$Search$CommonSearch(
														A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.common.q4')))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src('/assets/search.svg'),
															$elm$html$Html$Attributes$class('dark:grayscale text-ktitle'),
															$elm$html$Html$Attributes$alt('email icon'),
															$tesk9$accessible_html$Accessibility$Role$presentation
														]),
													_List_Nil),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.common.q4'))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-primarytext text-sm cursor-pointer flex flex-row items-center gap-x-2 mt-4 '),
													$elm$html$Html$Events$onClick(
													$author$project$Page$Search$CommonSearch(
														A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.common.q5')))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src('/assets/search.svg'),
															$elm$html$Html$Attributes$class('dark:grayscale text-ktitle'),
															$elm$html$Html$Attributes$alt('email icon'),
															$tesk9$accessible_html$Accessibility$Role$presentation
														]),
													_List_Nil),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($ChristophP$elm_i18next$I18Next$t, sharedstate.translations, 'search.common.q5'))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Routing$Router$view = F2(
	function (sharedState, model) {
		var _v0 = model.route;
		switch (_v0.$) {
			case 'NotFound':
				return A2(
					$elm$html$Html$main_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(' grow text-center  text-2xl grid place-content-center basis-5/6 font-bold text-kompas-300'),
							$tesk9$accessible_html$Accessibility$Landmark$main_,
							$tesk9$accessible_html$Accessibility$Aria$label('Page not found'),
							$elm$html$Html$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('#footer'),
									$elm$html$Html$Attributes$class('hidden'),
									$tesk9$accessible_html$Accessibility$Aria$label('skip to footer')
								]),
							_List_Nil),
							$elm$html$Html$text(' Page not found')
						]));
			case 'Search':
				return A2(
					$elm$html$Html$main_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('grow dark:bg-white'),
							$tesk9$accessible_html$Accessibility$Aria$roleDescription('Main'),
							$tesk9$accessible_html$Accessibility$Landmark$main_,
							$elm$html$Html$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('#footer'),
									$elm$html$Html$Attributes$class('hidden'),
									$tesk9$accessible_html$Accessibility$Aria$label('skip to footer')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$map,
							$author$project$Routing$Router$SearchMsg,
							A2($author$project$Page$Search$view, sharedState, model.searchModel))
						]));
			case 'Home':
				return A2(
					$elm$html$Html$main_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(' grow flex flex-col justify-center border-solid dark:bg-white'),
							$elm$html$Html$Attributes$id('main'),
							$tesk9$accessible_html$Accessibility$Aria$roleDescription('Main'),
							$tesk9$accessible_html$Accessibility$Landmark$main_
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('#footer'),
									$elm$html$Html$Attributes$class('hidden'),
									$tesk9$accessible_html$Accessibility$Aria$label('skip to footer')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$map,
							$author$project$Routing$Router$HomeMsg,
							A2($author$project$Page$Home$view, sharedState, model.homeModel))
						]));
			case 'Contact':
				return A2(
					$elm$html$Html$main_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('grow dark:bg-white'),
							$tesk9$accessible_html$Accessibility$Aria$roleDescription('Main'),
							$tesk9$accessible_html$Accessibility$Landmark$main_,
							$elm$html$Html$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('#footer'),
									$elm$html$Html$Attributes$class('hidden'),
									$tesk9$accessible_html$Accessibility$Aria$label('skip to footer')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('relative ')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Routing$Router$SearchMsg,
									A2($author$project$Page$Search$searchSm, sharedState, model.searchModel))
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Routing$Router$ContactMsg,
							$author$project$Page$Contact$view(sharedState))
						]));
			case 'Report':
				return A2(
					$elm$html$Html$main_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('grow dark:bg-white'),
							$tesk9$accessible_html$Accessibility$Aria$roleDescription('Main'),
							$tesk9$accessible_html$Accessibility$Landmark$main_,
							$elm$html$Html$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('#footer'),
									$elm$html$Html$Attributes$class('hidden'),
									$tesk9$accessible_html$Accessibility$Aria$label('skip to footer')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$map,
							$author$project$Routing$Router$SearchMsg,
							A2($author$project$Page$Search$searchSm, sharedState, model.searchModel)),
							A2(
							$elm$html$Html$map,
							$author$project$Routing$Router$ReportMsg,
							$author$project$Page$Report$view(sharedState))
						]));
			default:
				return A2(
					$elm$html$Html$main_,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('grow dark:bg-white'),
							$tesk9$accessible_html$Accessibility$Aria$roleDescription('Main'),
							$tesk9$accessible_html$Accessibility$Landmark$main_,
							$elm$html$Html$Attributes$id('main')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('#footer'),
									$elm$html$Html$Attributes$class('hidden'),
									$tesk9$accessible_html$Accessibility$Aria$label('skip to footer')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$map,
							$author$project$Routing$Router$SearchMsg,
							A2($author$project$Page$Search$searchSm, sharedState, model.searchModel)),
							A2(
							$elm$html$Html$map,
							$author$project$Routing$Router$PrivacyMsg,
							$author$project$Page$Privacy$view(sharedState))
						]));
		}
	});
var $tesk9$accessible_html$Accessibility$Landmark$contentInfo = $tesk9$accessible_html$Accessibility$Utils$role('contentinfo');
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $author$project$Main$viewFooter = function (sharedState) {
	return A2(
		$elm$html$Html$footer,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('  bg-kompas-100 sm:bg-transparent px-4 md:px-12 text-center block align-center mt-4  md:flex md:flex-row min-h-14 py-4 md:justify-between font-thin text-xs  dark:bg-white text-kgray dark:text-slate-950 items-center'),
				$tesk9$accessible_html$Accessibility$Aria$roleDescription('footer'),
				$tesk9$accessible_html$Accessibility$Landmark$contentInfo
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(' block sm:flex sm:flex-row  md:gap-x-8  md:justify-start justify-around  md:basis-3/4 items-center')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(' py-1  ')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('/privacy'),
										$tesk9$accessible_html$Accessibility$Aria$label('privacy'),
										$tesk9$accessible_html$Accessibility$Role$link,
										$elm$html$Html$Attributes$rel('external noopener noreferrer'),
										$elm$html$Html$Attributes$class('text-kgray text-xs dark:text-slate-950 ')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'footer.privacy'))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(' py-1')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href(
										A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'survey.link')),
										$tesk9$accessible_html$Accessibility$Role$link,
										$elm$html$Html$Attributes$rel('external noopener noreferrer'),
										$tesk9$accessible_html$Accessibility$Aria$label('help'),
										$elm$html$Html$Attributes$class('text-kgray text-xs dark:text-slate-950'),
										$elm$html$Html$Attributes$target('_blank')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'footer.help'))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(' py-1')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('/contact'),
										$tesk9$accessible_html$Accessibility$Aria$label('contact'),
										$tesk9$accessible_html$Accessibility$Role$link,
										$elm$html$Html$Attributes$rel('external noopener noreferrer'),
										$elm$html$Html$Attributes$class('text-kgray text-xs dark:text-slate-950 ')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'footer.contact'))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(' py-1')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('/report'),
										$tesk9$accessible_html$Accessibility$Role$link,
										$tesk9$accessible_html$Accessibility$Aria$label('report'),
										$elm$html$Html$Attributes$rel('external noopener noreferrer'),
										$elm$html$Html$Attributes$class('text-kgray text-xs dark:text-slate-950 ')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'footer.report'))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-row justify-center items-end   sm:ml-8 md:ml-0 md:mt-0 mt-4  ')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('\u00A9'),
						$elm$html$Html$text(
						A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'footer.rights'))
					]))
			]));
};
var $author$project$Main$ChangedTh = function (a) {
	return {$: 'ChangedTh', a: a};
};
var $author$project$Main$OpenHamb = {$: 'OpenHamb'};
var $author$project$Main$SelectLoc = function (a) {
	return {$: 'SelectLoc', a: a};
};
var $author$project$Main$ViewLoc = {$: 'ViewLoc'};
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $tesk9$accessible_html$Accessibility$Landmark$navigation = $tesk9$accessible_html$Accessibility$Utils$role('navigation');
var $author$project$Page$Search$searchNav = F2(
	function (sharedState, model) {
		var visibleOR = function () {
			var _v5 = sharedState.testRoute;
			switch (_v5.$) {
				case 'Home':
					return 'hidden';
				case 'Search':
					return 'ml-2 w-128 hidden sm:block';
				default:
					return 'hidden sm:block ml-2 w-128 hidden md:block md:w-128 ';
			}
		}();
		var showSearchBar = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-kompas-300 dark:bg-slate-400 h-full   w-24 border-md flex flex-row justify-center items-center'),
					$elm$html$Html$Events$onClick($author$project$Page$Search$SearchData),
					$tesk9$accessible_html$Accessibility$Role$button,
					$elm$html$Html$Attributes$title('submit'),
					$tesk9$accessible_html$Accessibility$Aria$label('submit')
				]),
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Outlined$search,
					32,
					$icidasset$elm_material_icons$Material$Icons$Types$Color(
						A3($avh4$elm_color$Color$rgb255, 255, 255, 255)))
				]));
		var isHidden = function () {
			var _v4 = $elm$core$String$isEmpty(model.search.query);
			if (_v4) {
				return 'invisible';
			} else {
				return 'mx-2';
			}
		}();
		var showReset = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(isHidden),
					$elm$html$Html$Events$onClick($author$project$Page$Search$ResetQuery),
					$elm$html$Html$Attributes$tabindex(0)
				]),
			_List_fromArray(
				[
					A2(
					$icidasset$elm_material_icons$Material$Icons$Outlined$cancel,
					25,
					$icidasset$elm_material_icons$Material$Icons$Types$Color(
						A3($avh4$elm_color$Color$rgb255, 45, 55, 72)))
				]));
		var isError = function () {
			var _v2 = sharedState.testRoute;
			if (_v2.$ === 'Search') {
				var _v3 = $elm$core$String$isEmpty(model.error);
				if (_v3) {
					return 'invisible';
				} else {
					return 'text-center text-kompas-300 dark:text-slate-950 text-sm visible ';
				}
			} else {
				return 'invisible';
			}
		}();
		var hiddenForm = function () {
			var _v1 = sharedState.testRoute;
			switch (_v1.$) {
				case 'Home':
					return 'hidden';
				case 'Search':
					return 'hidden';
				default:
					return 'block';
			}
		}();
		var data = function () {
			var _v0 = model.data;
			if (_v0.$ === 'Success') {
				return true;
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(visibleOR)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$form,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('bg-white rounded-3xl h-10'),
							$elm$html$Html$Events$onSubmit($author$project$Page$Search$SearchData),
							$tesk9$accessible_html$Accessibility$Landmark$form
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('hiddenForm md:block rounded-3xl overflow-hidden dark:bg-none dark:border-solid dark:border dark:border-slate-600 drop-shadow-lg  border-solid border border-kompas-300 h-full  ')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('flex flex-row h-full items-center bg-white')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$for('search-kompas')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_(' text'),
													$elm$html$Html$Attributes$class(' w-full h-full rounded-3xl  px-12 outline-none rounded-md text-slate-700 focus:bg-white '),
													$elm$html$Html$Attributes$value(model.search.query),
													$elm$html$Html$Attributes$id('search-kompas'),
													$elm$html$Html$Attributes$name('search-kompas'),
													$elm$html$Html$Attributes$placeholder(
													A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'search.searchData')),
													$elm$html$Html$Events$onInput($author$project$Page$Search$UpdateQuery),
													$elm$html$Html$Attributes$autofocus(true),
													$tesk9$accessible_html$Accessibility$Role$textBox,
													$tesk9$accessible_html$Accessibility$Aria$required(true)
												]),
											_List_Nil),
											showReset,
											showSearchBar
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(isError)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($ChristophP$elm_i18next$I18Next$t, sharedState.translations, 'errors.search'))
								]))
						]))
				]));
	});
var $author$project$Main$viewHeader = F2(
	function (sharedState, model) {
		var selectedLn = function () {
			var _v3 = model.selectLn;
			if ((_v3.$ === 'Just') && (_v3.a === 'en')) {
				return 'English';
			} else {
				return 'українська';
			}
		}();
		var searchModel = function () {
			var _v2 = model.appState;
			if (_v2.$ === 'Ready') {
				var shared = _v2.a;
				var routerModel = _v2.b;
				return routerModel.searchModel;
			} else {
				return {
					citiesList: $krisajenkins$remotedata$RemoteData$NotAsked,
					data: $krisajenkins$remotedata$RemoteData$NotAsked,
					educationSubOpen: false,
					emigrationSubOpen: false,
					employmentSubOpen: false,
					error: '',
					financialSubOpen: false,
					healthcareSubOpen: false,
					hotlineSubOpen: false,
					housingSubOpen: false,
					humanitarianSubOpen: false,
					legalaidSubOpen: false,
					locationList: $krisajenkins$remotedata$RemoteData$NotAsked,
					locationOpen: false,
					locationTr: $elm$core$Dict$empty,
					modalOpen: false,
					openSurvey: true,
					petSubOpen: false,
					protectionSubOpen: false,
					psychoSubOpen: false,
					regionList: $krisajenkins$remotedata$RemoteData$NotAsked,
					search: {
						filters: {tags_cities: $elm$core$Maybe$Nothing, tags_main_country: $elm$core$Maybe$Nothing, tags_regions: $elm$core$Maybe$Nothing, tags_small_cities: $elm$core$Maybe$Nothing, tags_sub_topics: $elm$core$Maybe$Nothing, tags_topics: $elm$core$Maybe$Nothing, tags_village: $elm$core$Maybe$Nothing, visible: true},
						query: ''
					},
					selectCOpen: false,
					selectOpen: false,
					selectROpen: false,
					selectSOpen: false,
					selectVOpen: false,
					selectedCities: '',
					selectedCountry: '',
					selectedLocation: 'All',
					selectedRegion: '',
					selectedSmallCities: '',
					selectedVillage: '',
					showLocation: false,
					showTopics: false,
					smallCitiesList: $krisajenkins$remotedata$RemoteData$NotAsked,
					socialSubOpen: false,
					subTopicsDict: $elm$core$Dict$empty,
					tagsSubTopics: $elm$core$Maybe$Nothing,
					tagsTopics: $elm$core$Maybe$Nothing,
					topicsOpen: false,
					transportSubOpen: false,
					url: '',
					viewData: $elm$core$Maybe$Nothing,
					villageList: $krisajenkins$remotedata$RemoteData$NotAsked
				};
			}
		}();
		var navLink = F2(
			function (route, _v1) {
				var url = _v1.url;
				var caption = _v1.caption;
				return A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url),
									$elm$html$Html$Attributes$class('ml-4 text-slate-100 dark:text-slate-950'),
									$tesk9$accessible_html$Accessibility$Aria$label('caption')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(caption)
								]))
						]));
			});
		var logosm = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(' sm:hidden ')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/'),
							$tesk9$accessible_html$Accessibility$Aria$label('Kompas logo')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/assets/logo-sm2.svg'),
									$elm$html$Html$Attributes$alt(' kompas logo'),
									$elm$html$Html$Attributes$class('dark:grayscale  visible')
								]),
							_List_Nil)
						]))
				]));
		var logo = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(''),
					$elm$html$Html$Attributes$tabindex(0)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/'),
							$tesk9$accessible_html$Accessibility$Aria$label('Kompas logo ')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/assets/Logo.svg'),
									$elm$html$Html$Attributes$class('dark:grayscale hidden  sm:visible  sm:block'),
									$elm$html$Html$Attributes$alt('kompas logo')
								]),
							_List_Nil)
						]))
				]));
		var lnMenu = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col text-xs text-primarytest cursor-default '),
					$tesk9$accessible_html$Accessibility$Aria$label('select language'),
					$elm$html$Html$Attributes$tabindex(0)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Main$ViewLoc),
							$elm$html$Html$Attributes$class('flex flex-row gap-x-2 p-4 justify-end ')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/assets/lang.svg'),
									$elm$html$Html$Attributes$alt('language icon'),
									$tesk9$accessible_html$Accessibility$Aria$label('language icon')
								]),
							_List_Nil),
							$elm$html$Html$text(selectedLn),
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/assets/arrowd.svg'),
									$elm$html$Html$Attributes$alt('open language down arrow icon'),
									$tesk9$accessible_html$Accessibility$Aria$label('open location dropdown')
								]),
							_List_Nil)
						])),
					model.locOpen ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute top-10 ml-7 border border-slate-100 bg-slate-300 px-4 py-0.5 rounded-md flex flex-col z-10  ')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Main$SelectLoc('uk')),
									$elm$html$Html$Attributes$class('py-0.5 hover:font-bold hover:text-kompas-300 cursor-pointer dark:hover:text-slate-950'),
									$elm$html$Html$Attributes$tabindex(0),
									$tesk9$accessible_html$Accessibility$Aria$label('select ukrainian')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('українська')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Main$SelectLoc('en')),
									$elm$html$Html$Attributes$class('py-0.5 hover:font-bold hover:text-kompas-300 cursor-pointer dark:hover:text-slate-950'),
									$elm$html$Html$Attributes$tabindex(0),
									$tesk9$accessible_html$Accessibility$Aria$label('select english')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('English')
								]))
						])) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
				]));
		var ln = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-col text-xs text-primarytest cursor-default hidden sm:block'),
					$tesk9$accessible_html$Accessibility$Aria$label('select language'),
					$elm$html$Html$Attributes$tabindex(0)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$Main$ViewLoc),
							$elm$html$Html$Attributes$class('flex flex-row gap-x-2 p-4 items-center')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/assets/lang.svg'),
									$elm$html$Html$Attributes$alt('language icon'),
									$tesk9$accessible_html$Accessibility$Aria$label('language icon')
								]),
							_List_Nil),
							$elm$html$Html$text(selectedLn),
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src('/assets/arrowd.svg'),
									$elm$html$Html$Attributes$alt('open language down arrow icon'),
									$tesk9$accessible_html$Accessibility$Aria$label('open location dropdown')
								]),
							_List_Nil)
						])),
					model.locOpen ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('absolute top-10 ml-7 border border-slate-100 bg-kompas-100 px-4 py-2 rounded-md flex flex-col z-10 ')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Main$SelectLoc('uk')),
									$elm$html$Html$Attributes$class('py-2 hover:font-bold hover:text-kompas-300 cursor-pointer dark:hover:text-slate-950'),
									$elm$html$Html$Attributes$tabindex(0),
									$tesk9$accessible_html$Accessibility$Aria$label('select ukrainian')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('українська')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Main$SelectLoc('en')),
									$elm$html$Html$Attributes$class('py-2 hover:font-bold hover:text-kompas-300 cursor-pointer dark:hover:text-slate-950'),
									$elm$html$Html$Attributes$tabindex(0),
									$tesk9$accessible_html$Accessibility$Aria$label('select english')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('English')
								]))
						])) : A2($elm$html$Html$span, _List_Nil, _List_Nil)
				]));
		var hamb = A2(
			$elm$html$Html$img,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src('/assets/hamb.svg'),
					$elm$html$Html$Attributes$class(' block sm:hidden cursor-pointer'),
					$elm$html$Html$Events$onClick($author$project$Main$OpenHamb)
				]),
			_List_Nil);
		var form = A2(
			$elm$html$Html$map,
			$author$project$Main$RouterMsg,
			A2(
				$elm$html$Html$map,
				$author$project$Routing$Router$SearchMsg,
				A2($author$project$Page$Search$searchNav, sharedState, searchModel)));
		var right = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('basis-1/5 md:basis-4/6 flex flex-row items-center justify-start  gap-x-2 sm:gap-x-12  ')
				]),
			_List_fromArray(
				[logo, logosm, form]));
		var color = function () {
			var _v0 = model.theme;
			if (_v0 === 'white') {
				return '#5151ce';
			} else {
				return '#2d3748';
			}
		}();
		var svgTh = A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$width('30'),
					$elm$svg$Svg$Attributes$height('29'),
					$elm$svg$Svg$Attributes$viewBox('0 0 30 29'),
					$elm$svg$Svg$Attributes$fill('none')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$path,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$d('M17.4407 16.5763L17.3594 16.4949C18.4729 15.2695 19.1543 13.6424 19.1543 11.8627C19.1543 10.0169 18.4221 8.33898 17.2322 7.09831C20.3899 8.6339 22.7695 11.1407 23.5068 11.9797C22.7797 12.7729 20.4916 15.0966 17.4407 16.5763ZM1.02207 11.9797C1.14919 11.8322 1.33224 11.6339 1.55597 11.4L6.35088 16.1949C3.67122 14.7203 1.68817 12.7068 1.02207 11.9797ZM7.02207 7.39831C6.84919 7.6017 6.68648 7.81525 6.53394 8.03898L6.18309 7.68814C6.41699 7.55085 6.66106 7.41864 6.91021 7.28644L7.02207 7.39831ZM15.4526 16.9576L13.1339 14.639C13.4085 14.5525 13.6628 14.4305 13.8916 14.2729L16.1034 16.4847C15.9 16.6525 15.6814 16.8102 15.4526 16.9576ZM6.72716 14.2017L9.92546 17.4C8.48648 16.7898 7.33733 15.6407 6.72716 14.2017ZM9.37122 12.1119C9.48817 13.5203 10.6119 14.639 12.0204 14.761L14.6441 17.3847C14.3746 17.5017 14.095 17.5983 13.8051 17.6746L6.45258 10.322C6.52885 10.0322 6.62546 9.75254 6.74241 9.48305L9.37122 12.1119ZM9.85936 10.2305C9.70173 10.4644 9.5797 10.7186 9.49326 10.9932L7.17461 8.67458C7.31699 8.44576 7.47461 8.22712 7.64749 8.01864L9.85936 10.2305ZM5.42038 8.1661L6.08139 8.82712C5.95428 9.08644 5.84241 9.35085 5.75088 9.62543L4.74919 8.62373C4.96783 8.4661 5.19156 8.31356 5.42038 8.1661ZM4.04241 9.15254L5.49156 10.6017C5.43055 10.9322 5.39495 11.2729 5.3797 11.6186L3.41699 9.65593C3.62038 9.48814 3.82377 9.32034 4.04241 9.15254ZM2.75597 10.2305L5.46105 12.9356C5.54749 13.4847 5.70004 14.0085 5.90851 14.5068L2.17631 10.7746C2.35427 10.6068 2.54749 10.4237 2.75597 10.2305ZM12.2644 17.8729C12.1577 17.8729 12.056 17.8678 11.9492 17.8627C11.8322 17.8576 11.7153 17.8475 11.6034 17.8322L6.28987 12.5288C6.26444 12.3102 6.25428 12.0915 6.25428 11.8627C6.25428 11.7 6.26445 11.5424 6.27461 11.3847L12.7475 17.8525C12.6916 17.8576 12.6356 17.8627 12.5797 17.8678C12.4729 17.8678 12.3712 17.8729 12.2644 17.8729ZM18.2746 11.8627C18.2746 13.4034 17.6899 14.8068 16.739 15.8746L14.5373 13.6729C14.9339 13.1746 15.1729 12.5492 15.1729 11.8627C15.1729 10.2559 13.8712 8.95424 12.2644 8.95424C11.578 8.95424 10.9526 9.19322 10.4543 9.58983L8.25258 7.38814C9.24411 6.49831 10.5255 5.9339 11.939 5.85763C12.0458 5.85254 12.1526 5.84746 12.2594 5.84746C12.3661 5.84746 12.4729 5.85254 12.5797 5.85763C15.7526 6.03051 18.2746 8.65932 18.2746 11.8627ZM24.4272 12.2644C24.5594 12.1017 24.5644 11.8729 24.4322 11.7102C24.2136 11.4407 19.1289 5.2322 12.6509 4.98814C12.5238 4.98305 12.3916 4.97797 12.2644 4.97797C12.1322 4.97797 12.0051 4.98305 11.878 4.98814C10.1594 5.05424 8.53733 5.5322 7.08309 6.21356L0.864444 0L0.244105 0.62034L6.25428 6.63051C2.66953 8.56271 0.244104 11.522 0.0966468 11.7102C-0.0355566 11.8729 -0.0304718 12.1068 0.101732 12.2644C0.320376 12.5237 5.40512 18.5136 11.8831 18.7424C12.0102 18.7475 12.1322 18.7525 12.2644 18.7525C12.3916 18.7525 12.5187 18.7475 12.6458 18.7424C13.0068 18.7271 13.3577 18.7017 13.7085 18.6559C13.7136 18.6559 13.7187 18.6559 13.7289 18.6559C13.7746 18.6559 13.8204 18.6458 13.8661 18.6305C15.0661 18.4576 16.2102 18.1017 17.2678 17.639L23.6238 24L24.2441 23.3797L18.1068 17.2424C21.7831 15.3814 24.2746 12.4424 24.4272 12.2644Z'),
							$elm$svg$Svg$Attributes$fill(color)
						]),
					_List_Nil)
				]));
		var th = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Main$ChangedTh(model.theme)),
					$elm$html$Html$Attributes$class(' hidden sm:block'),
					$elm$html$Html$Attributes$title('change theme'),
					$elm$html$Html$Attributes$class('h-6'),
					$tesk9$accessible_html$Accessibility$Aria$label('Accessibility Icon'),
					$elm$html$Html$Attributes$tabindex(0)
				]),
			_List_fromArray(
				[svgTh]));
		var thMenu = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Main$ChangedTh(model.theme)),
					$elm$html$Html$Attributes$title('change theme'),
					$elm$html$Html$Attributes$class('px-4 flex flex-row justify-start '),
					$tesk9$accessible_html$Accessibility$Aria$label('Accessibility Icon'),
					$elm$html$Html$Attributes$tabindex(0)
				]),
			_List_fromArray(
				[svgTh]));
		var hambMenu = model.openHamb ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(' block sm:hidden absolute z-10 top-5 right-0 p-0.5  bg-slate-100  rounded-md')
				]),
			_List_fromArray(
				[lnMenu, thMenu])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hidden')
				]),
			_List_Nil);
		var left = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('basis-4/5 md:basis-2/6 flex flex-row  gap-x-12   sm:gap-x-8 items-center justify-end relative')
				]),
			_List_fromArray(
				[ln, th, hamb, hambMenu]));
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-row  h-28  px-8 md:px-12 py-4 items-center md:justify-around  dark:bg-white'),
					$tesk9$accessible_html$Accessibility$Aria$roleDescription('Navigation'),
					$tesk9$accessible_html$Accessibility$Landmark$navigation
				]),
			_List_fromArray(
				[right, left]));
	});
var $author$project$Main$view = function (model) {
	return {
		body: _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('h-full flex flex-col justify-between '),
						$tesk9$accessible_html$Accessibility$Role$document
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href('#main'),
								$tesk9$accessible_html$Accessibility$Aria$label('skip to main'),
								$elm$html$Html$Attributes$class('hidden')
							]),
						_List_Nil),
						A2(
						$author$project$Main$viewHeader,
						$author$project$Main$returnState(model).a,
						model),
						A2(
						$elm$html$Html$map,
						$author$project$Main$RouterMsg,
						A2(
							$author$project$Routing$Router$view,
							$author$project$Main$returnState(model).a,
							$author$project$Main$returnState(model).b)),
						$author$project$Main$viewFooter(
						$author$project$Main$returnState(model).a)
					]))
			]),
		title: 'Kompas'
	};
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{init: $author$project$Main$init, onUrlChange: $author$project$Main$UrlChanged, onUrlRequest: $author$project$Main$LinkClicked, subscriptions: $author$project$Main$subscriptions, update: $author$project$Main$update, view: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (tr) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (env) {
					return $elm$json$Json$Decode$succeed(
						{env: env, tr: tr});
				},
				A2(
					$elm$json$Json$Decode$field,
					'env',
					A2(
						$elm$json$Json$Decode$andThen,
						function (weetags) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (haycap) {
									return $elm$json$Json$Decode$succeed(
										{haycap: haycap, weetags: weetags});
								},
								A2($elm$json$Json$Decode$field, 'haycap', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'weetags', $elm$json$Json$Decode$string))));
		},
		A2($elm$json$Json$Decode$field, 'tr', $elm$json$Json$Decode$string)))(0)}});

//////////////////// HMR BEGIN ////////////////////

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Original Author: Flux Xu @fluxxu
*/

/*
    A note about the environment that this code runs in...

    assumed globals:
        - `module` (from Node.js module system and webpack)

    assumed in scope after injection into the Elm IIFE:
        - `scope` (has an 'Elm' property which contains the public Elm API)
        - various functions defined by Elm which we have to hook such as `_Platform_initialize` and `_Scheduler_binding`
 */

if (module.hot) {
    (function () {
        "use strict";

        //polyfill for IE: https://github.com/fluxxu/elm-hot-loader/issues/16
        if (typeof Object.assign != 'function') {
            Object.assign = function (target) {
                'use strict';
                if (target == null) {
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                target = Object(target);
                for (var index = 1; index < arguments.length; index++) {
                    var source = arguments[index];
                    if (source != null) {
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                }
                return target;
            };
        }

        // Elm 0.19.1 introduced a '$' prefix at the beginning of the symbols it emits,
        // and we check for `Maybe.Just` because we expect it to be present in all Elm programs.
        var elmVersion;
        if (typeof elm$core$Maybe$Just !== 'undefined')
            elmVersion = '0.19.0';
        else if (typeof $elm$core$Maybe$Just !== 'undefined')
            elmVersion = '0.19.1';
        else
            throw new Error("Could not determine Elm version");

        function elmSymbol(symbol) {
            try {
                switch (elmVersion) {
                    case '0.19.0':
                        return eval(symbol);
                    case '0.19.1':
                        return eval('$' + symbol);
                    default:
                        throw new Error('Cannot resolve ' + symbol + '. Elm version unknown!')
                }
            } catch (e) {
                if (e instanceof ReferenceError) {
                    return undefined;
                } else {
                    throw e;
                }
            }
        }

        var instances = module.hot.data
            ? module.hot.data.instances || {}
            : {};
        var uid = module.hot.data
            ? module.hot.data.uid || 0
            : 0;

        if (Object.keys(instances).length === 0) {
            log("[elm-hot] Enabled");
        }

        var cancellers = [];

        // These 2 variables act as dynamically-scoped variables which are set only when the
        // Elm module's hooked init function is called.
        var initializingInstance = null;
        var swappingInstance = null;

        module.hot.accept();
        module.hot.dispose(function (data) {
            data.instances = instances;
            data.uid = uid;

            // Cleanup pending async tasks

            // First, make sure that no new tasks can be started until we finish replacing the code
            _Scheduler_binding = function () {
                return _Scheduler_fail(new Error('[elm-hot] Inactive Elm instance.'))
            };

            // Second, kill pending tasks belonging to the old instance
            if (cancellers.length) {
                log('[elm-hot] Killing ' + cancellers.length + ' running processes...');
                try {
                    cancellers.forEach(function (cancel) {
                        cancel();
                    });
                } catch (e) {
                    console.warn('[elm-hot] Kill process error: ' + e.message);
                }
            }
        });

        function log(message) {
            if (module.hot.verbose) {
                console.log(message)
            }
        }

        function getId() {
            return ++uid;
        }

        function findPublicModules(parent, path) {
            var modules = [];
            for (var key in parent) {
                var child = parent[key];
                var currentPath = path ? path + '.' + key : key;
                if ('init' in child) {
                    modules.push({
                        path: currentPath,
                        module: child
                    });
                } else {
                    modules = modules.concat(findPublicModules(child, currentPath));
                }
            }
            return modules;
        }

        function registerInstance(domNode, flags, path, portSubscribes, portSends) {
            var id = getId();

            var instance = {
                id: id,
                path: path,
                domNode: domNode,
                flags: flags,
                portSubscribes: portSubscribes,
                portSends: portSends,
                lastState: null // last Elm app state (root model)
            };

            return instances[id] = instance
        }

        function isFullscreenApp() {
            // Returns true if the Elm app will take over the entire DOM body.
            return typeof elmSymbol("elm$browser$Browser$application") !== 'undefined'
                || typeof elmSymbol("elm$browser$Browser$document") !== 'undefined';
        }

        function wrapDomNode(node) {
            // When embedding an Elm app into a specific DOM node, Elm will replace the provided
            // DOM node with the Elm app's content. When the Elm app is compiled normally, the
            // original DOM node is reused (its attributes and content changes, but the object
            // in memory remains the same). But when compiled using `--debug`, Elm will completely
            // destroy the original DOM node and instead replace it with 2 brand new nodes: one
            // for your Elm app's content and the other for the Elm debugger UI. In this case,
            // if you held a reference to the DOM node provided for embedding, it would be orphaned
            // after Elm module initialization.
            //
            // So in order to make both cases consistent and isolate us from changes in how Elm
            // does this, we will insert a dummy node to wrap the node for embedding and hold
            // a reference to the dummy node.
            //
            // We will also put a tag on the dummy node so that the Elm developer knows who went
            // behind their back and rudely put stuff in their DOM.
            var dummyNode = document.createElement("div");
            dummyNode.setAttribute("data-elm-hot", "true");
            dummyNode.style.height = "inherit";
            var parentNode = node.parentNode;
            parentNode.replaceChild(dummyNode, node);
            dummyNode.appendChild(node);
            return dummyNode;
        }

        function wrapPublicModule(path, module) {
            var originalInit = module.init;
            if (originalInit) {
                module.init = function (args) {
                    var elm;
                    var portSubscribes = {};
                    var portSends = {};
                    var domNode = null;
                    var flags = null;
                    if (typeof args !== 'undefined') {
                        // normal case
                        domNode = args['node'] && !isFullscreenApp()
                            ? wrapDomNode(args['node'])
                            : document.body;
                        flags = args['flags'];
                    } else {
                        // rare case: Elm allows init to be called without any arguments at all
                        domNode = document.body;
                        flags = undefined
                    }
                    initializingInstance = registerInstance(domNode, flags, path, portSubscribes, portSends);
                    elm = originalInit(args);
                    wrapPorts(elm, portSubscribes, portSends);
                    initializingInstance = null;
                    return elm;
                };
            } else {
                console.error("Could not find a public module to wrap at path " + path)
            }
        }

        function swap(Elm, instance) {
            log('[elm-hot] Hot-swapping module: ' + instance.path);

            swappingInstance = instance;

            // remove from the DOM everything that had been created by the old Elm app
            var containerNode = instance.domNode;
            while (containerNode.lastChild) {
                containerNode.removeChild(containerNode.lastChild);
            }

            var m = getAt(instance.path.split('.'), Elm);
            var elm;
            if (m) {
                // prepare to initialize the new Elm module
                var args = {flags: instance.flags};
                if (containerNode === document.body) {
                    // fullscreen case: no additional args needed
                } else {
                    // embed case: provide a new node for Elm to use
                    var nodeForEmbed = document.createElement("div");
                    containerNode.appendChild(nodeForEmbed);
                    args['node'] = nodeForEmbed;
                }

                elm = m.init(args);

                Object.keys(instance.portSubscribes).forEach(function (portName) {
                    if (portName in elm.ports && 'subscribe' in elm.ports[portName]) {
                        var handlers = instance.portSubscribes[portName];
                        if (!handlers.length) {
                            return;
                        }
                        log('[elm-hot] Reconnect ' + handlers.length + ' handler(s) to port \''
                            + portName + '\' (' + instance.path + ').');
                        handlers.forEach(function (handler) {
                            elm.ports[portName].subscribe(handler);
                        });
                    } else {
                        delete instance.portSubscribes[portName];
                        log('[elm-hot] Port was removed: ' + portName);
                    }
                });

                Object.keys(instance.portSends).forEach(function (portName) {
                    if (portName in elm.ports && 'send' in elm.ports[portName]) {
                        log('[elm-hot] Replace old port send with the new send');
                        instance.portSends[portName] = elm.ports[portName].send;
                    } else {
                        delete instance.portSends[portName];
                        log('[elm-hot] Port was removed: ' + portName);
                    }
                });
            } else {
                log('[elm-hot] Module was removed: ' + instance.path);
            }

            swappingInstance = null;
        }

        function wrapPorts(elm, portSubscribes, portSends) {
            var portNames = Object.keys(elm.ports || {});
            //hook ports
            if (portNames.length) {
                // hook outgoing ports
                portNames
                    .filter(function (name) {
                        return 'subscribe' in elm.ports[name];
                    })
                    .forEach(function (portName) {
                        var port = elm.ports[portName];
                        var subscribe = port.subscribe;
                        var unsubscribe = port.unsubscribe;
                        elm.ports[portName] = Object.assign(port, {
                            subscribe: function (handler) {
                                log('[elm-hot] ports.' + portName + '.subscribe called.');
                                if (!portSubscribes[portName]) {
                                    portSubscribes[portName] = [handler];
                                } else {
                                    //TODO handle subscribing to single handler more than once?
                                    portSubscribes[portName].push(handler);
                                }
                                return subscribe.call(port, handler);
                            },
                            unsubscribe: function (handler) {
                                log('[elm-hot] ports.' + portName + '.unsubscribe called.');
                                var list = portSubscribes[portName];
                                if (list && list.indexOf(handler) !== -1) {
                                    list.splice(list.lastIndexOf(handler), 1);
                                } else {
                                    console.warn('[elm-hot] ports.' + portName + '.unsubscribe: handler not subscribed');
                                }
                                return unsubscribe.call(port, handler);
                            }
                        });
                    });

                // hook incoming ports
                portNames
                    .filter(function (name) {
                        return 'send' in elm.ports[name];
                    })
                    .forEach(function (portName) {
                        var port = elm.ports[portName];
                        portSends[portName] = port.send;
                        elm.ports[portName] = Object.assign(port, {
                            send: function (val) {
                                return portSends[portName].call(port, val);
                            }
                        });
                    });
            }
            return portSubscribes;
        }

        /*
        Breadth-first search for a `Browser.Navigation.Key` in the user's app model.
        Returns the key and keypath or null if not found.
        */
        function findNavKey(rootModel) {
            var queue = [];
            if (isDebuggerModel(rootModel)) {
                /*
                 Extract the user's app model from the Elm Debugger's model. The Elm debugger
                 can hold multiple references to the user's model (e.g. in its "history"). So
                 we must be careful to only search within the "state" part of the Debugger.
                */
                queue.push({value: rootModel['state'], keypath: ['state']});
            } else {
                queue.push({value: rootModel, keypath: []});
            }

            while (queue.length !== 0) {
                var item = queue.shift();

                if (typeof item.value === "undefined" || item.value === null) {
                    continue;
                }

                // The nav key is identified by a runtime tag added by the elm-hot injector.
                if (item.value.hasOwnProperty("elm-hot-nav-key")) {
                    // found it!
                    return item;
                }

                if (typeof item.value !== "object") {
                    continue;
                }

                for (var propName in item.value) {
                    if (!item.value.hasOwnProperty(propName)) continue;
                    var newKeypath = item.keypath.slice();
                    newKeypath.push(propName);
                    queue.push({value: item.value[propName], keypath: newKeypath})
                }
            }

            return null;
        }


        function isDebuggerModel(model) {
            // Up until elm/browser 1.0.2, the Elm debugger could be identified by a
            // property named "expando". But in version 1.0.2 that was renamed to "expandoModel"
            return model
                && (model.hasOwnProperty("expando") || model.hasOwnProperty("expandoModel"))
                && model.hasOwnProperty("state");
        }

        function getAt(keyPath, obj) {
            return keyPath.reduce(function (xs, x) {
                return (xs && xs[x]) ? xs[x] : null
            }, obj)
        }

        function removeNavKeyListeners(navKey) {
            window.removeEventListener('popstate', navKey.value);
            window.navigator.userAgent.indexOf('Trident') < 0 || window.removeEventListener('hashchange', navKey.value);
        }

        // hook program creation
        var initialize = _Platform_initialize;
        _Platform_initialize = function (flagDecoder, args, init, update, subscriptions, stepperBuilder) {
            var instance = initializingInstance || swappingInstance;
            var tryFirstRender = !!swappingInstance;

            var hookedInit = function (args) {
                var initialStateTuple = init(args);
                if (swappingInstance) {
                    var oldModel = swappingInstance.lastState;
                    var newModel = initialStateTuple.a;

                    if (typeof elmSymbol("elm$browser$Browser$application") !== 'undefined') {
                        var oldKeyLoc = findNavKey(oldModel);

                        // attempt to find the Browser.Navigation.Key in the newly-constructed model
                        // and bring it along with the rest of the old data.
                        var newKeyLoc = findNavKey(newModel);
                        var error = null;
                        if (newKeyLoc === null) {
                            error = "could not find Browser.Navigation.Key in the new app model";
                        } else if (oldKeyLoc === null) {
                            error = "could not find Browser.Navigation.Key in the old app model.";
                        } else if (newKeyLoc.keypath.toString() !== oldKeyLoc.keypath.toString()) {
                            error = "the location of the Browser.Navigation.Key in the model has changed.";
                        } else {
                            // remove event listeners attached to the old nav key
                            removeNavKeyListeners(oldKeyLoc.value);

                            // insert the new nav key into the old model in the exact same location
                            var parentKeyPath = oldKeyLoc.keypath.slice(0, -1);
                            var lastSegment = oldKeyLoc.keypath.slice(-1)[0];
                            var oldParent = getAt(parentKeyPath, oldModel);
                            oldParent[lastSegment] = newKeyLoc.value;
                        }

                        if (error !== null) {
                            console.error("[elm-hot] Hot-swapping " + instance.path + " not possible: " + error);
                            oldModel = newModel;
                        }
                    }

                    // the heart of the app state hot-swap
                    initialStateTuple.a = oldModel;

                    // ignore any Cmds returned by the init during hot-swap
                    initialStateTuple.b = elmSymbol("elm$core$Platform$Cmd$none");
                } else {
                    // capture the initial state for later
                    initializingInstance.lastState = initialStateTuple.a;
                }

                return initialStateTuple
            };

            var hookedStepperBuilder = function (sendToApp, model) {
                var result;
                // first render may fail if shape of model changed too much
                if (tryFirstRender) {
                    tryFirstRender = false;
                    try {
                        result = stepperBuilder(sendToApp, model)
                    } catch (e) {
                        throw new Error('[elm-hot] Hot-swapping ' + instance.path +
                            ' is not possible, please reload page. Error: ' + e.message)
                    }
                } else {
                    result = stepperBuilder(sendToApp, model)
                }

                return function (nextModel, isSync) {
                    if (instance) {
                        // capture the state after every step so that later we can restore from it during a hot-swap
                        instance.lastState = nextModel
                    }
                    return result(nextModel, isSync)
                }
            };

            return initialize(flagDecoder, args, hookedInit, update, subscriptions, hookedStepperBuilder)
        };

        // hook process creation
        var originalBinding = _Scheduler_binding;
        _Scheduler_binding = function (originalCallback) {
            return originalBinding(function () {
                // start the scheduled process, which may return a cancellation function.
                var cancel = originalCallback.apply(this, arguments);
                if (cancel) {
                    cancellers.push(cancel);
                    return function () {
                        cancellers.splice(cancellers.indexOf(cancel), 1);
                        return cancel();
                    };
                }
                return cancel;
            });
        };

        scope['_elm_hot_loader_init'] = function (Elm) {
            // swap instances
            var removedInstances = [];
            for (var id in instances) {
                var instance = instances[id];
                if (instance.domNode.parentNode) {
                    swap(Elm, instance);
                } else {
                    removedInstances.push(id);
                }
            }

            removedInstances.forEach(function (id) {
                delete instance[id];
            });

            // wrap all public modules
            var publicModules = findPublicModules(Elm);
            publicModules.forEach(function (m) {
                wrapPublicModule(m.path, m.module);
            });
        }
    })();

    scope['_elm_hot_loader_init'](scope['Elm']);
}
//////////////////// HMR END ////////////////////


}(this));